/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getAgaveProject = /* GraphQL */ `query GetAgaveProject($id: ID!) {
  getAgaveProject(id: $id) {
    id
    paidolId
    authPaidolId
    source_id
    address {
      street_1
      street_2
      city
      state
      postal_code
      country
      __typename
    }
    amount
    completion_date
    name
    number
    start_date
    status
    type
    source_create_time
    source_update_time
    source_data {
      CreationDate
      data
      DeliveryAddressLine
      DeliveryCity
      DeliveryCountry
      DeliveryPostcode
      DeliveryState
      FaxNumber
      LogoPath
      ProjectOwnerOrganizationId
      ProjectOwnerOrganizationName
      PhoneNumber
      PostalAddressLine
      PostalCity
      PostalCountry
      PostalPostcode
      PostalState
      ProjectAddressLine
      ProjectCity
      ProjectCode
      ProjectCountry
      ProjectDescription
      ProjectId
      ProjectName
      ProjectPostcode
      ProjectShortName
      ProjectState
      ProjectType
      ProjectValue
      ProjectResponsibilities
      StartDate
      StopDate
      __typename
    }
    createdAt
    updatedAt
    fullName
    relatedIds
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveProjectQueryVariables,
  APITypes.GetAgaveProjectQuery
>;
export const listAgaveProjects = /* GraphQL */ `query ListAgaveProjects(
  $id: ID
  $filter: ModelAgaveProjectFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveProjects(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      amount
      completion_date
      name
      number
      start_date
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectsQueryVariables,
  APITypes.ListAgaveProjectsQuery
>;
export const listAgaveProjectsByPaidolId = /* GraphQL */ `query ListAgaveProjectsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveProjectFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveProjectsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      amount
      completion_date
      name
      number
      start_date
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectsByPaidolIdQueryVariables,
  APITypes.ListAgaveProjectsByPaidolIdQuery
>;
export const getAgaveGlCode = /* GraphQL */ `query GetAgaveGlCode($id: ID!) {
  getAgaveGlCode(id: $id) {
    id
    paidolId
    authPaidolId
    source_id
    classification
    currency_code
    current_balance
    description
    name
    number
    status
    type
    source_create_time
    source_update_time
    source_data {
      CreationDate
      data
      DeliveryAddressLine
      DeliveryCity
      DeliveryCountry
      DeliveryPostcode
      DeliveryState
      FaxNumber
      LogoPath
      ProjectOwnerOrganizationId
      ProjectOwnerOrganizationName
      PhoneNumber
      PostalAddressLine
      PostalCity
      PostalCountry
      PostalPostcode
      PostalState
      ProjectAddressLine
      ProjectCity
      ProjectCode
      ProjectCountry
      ProjectDescription
      ProjectId
      ProjectName
      ProjectPostcode
      ProjectShortName
      ProjectState
      ProjectType
      ProjectValue
      ProjectResponsibilities
      StartDate
      StopDate
      __typename
    }
    createdAt
    updatedAt
    fullName
    relatedIds
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveGlCodeQueryVariables,
  APITypes.GetAgaveGlCodeQuery
>;
export const listAgaveGlCodes = /* GraphQL */ `query ListAgaveGlCodes(
  $id: ID
  $filter: ModelAgaveGlCodeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveGlCodes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      classification
      currency_code
      current_balance
      description
      name
      number
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveGlCodesQueryVariables,
  APITypes.ListAgaveGlCodesQuery
>;
export const listAgaveGlCodesByPaidolId = /* GraphQL */ `query ListAgaveGlCodesByPaidolId(
  $paidolId: ID!
  $name: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveGlCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveGlCodesByPaidolId(
    paidolId: $paidolId
    name: $name
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      classification
      currency_code
      current_balance
      description
      name
      number
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveGlCodesByPaidolIdQueryVariables,
  APITypes.ListAgaveGlCodesByPaidolIdQuery
>;
export const getAgaveCostCode = /* GraphQL */ `query GetAgaveCostCode($id: ID!) {
  getAgaveCostCode(id: $id) {
    id
    paidolId
    authPaidolId
    asset_account_id
    source_id
    formatted_full_code
    code
    full_code
    cost_unit_of_measure
    description
    expense_account_id
    income_account_id
    name
    parent_id
    project_id
    price_unit_of_measure
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    status
    type
    unit_cost
    unit_price
    vendor_id
    sub_job_id
    createdAt
    updatedAt
    projectId
    paidolProject
    projectIds
    cost_type_ids
    fullName
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveCostCodeQueryVariables,
  APITypes.GetAgaveCostCodeQuery
>;
export const listAgaveCostCodes = /* GraphQL */ `query ListAgaveCostCodes(
  $id: ID
  $filter: ModelAgaveCostCodeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveCostCodes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      asset_account_id
      source_id
      formatted_full_code
      code
      full_code
      cost_unit_of_measure
      description
      expense_account_id
      income_account_id
      name
      parent_id
      project_id
      price_unit_of_measure
      source_create_time
      source_update_time
      status
      type
      unit_cost
      unit_price
      vendor_id
      sub_job_id
      createdAt
      updatedAt
      projectId
      paidolProject
      projectIds
      cost_type_ids
      fullName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostCodesQueryVariables,
  APITypes.ListAgaveCostCodesQuery
>;
export const listAgaveCostCodesByPaidolId = /* GraphQL */ `query ListAgaveCostCodesByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveCostCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveCostCodesByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      asset_account_id
      source_id
      formatted_full_code
      code
      full_code
      cost_unit_of_measure
      description
      expense_account_id
      income_account_id
      name
      parent_id
      project_id
      price_unit_of_measure
      source_create_time
      source_update_time
      status
      type
      unit_cost
      unit_price
      vendor_id
      sub_job_id
      createdAt
      updatedAt
      projectId
      paidolProject
      projectIds
      cost_type_ids
      fullName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostCodesByPaidolIdQueryVariables,
  APITypes.ListAgaveCostCodesByPaidolIdQuery
>;
export const listAgaveCostCodesBySubJobId = /* GraphQL */ `query ListAgaveCostCodesBySubJobId(
  $sub_job_id: String!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveCostCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveCostCodesBySubJobId(
    sub_job_id: $sub_job_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      asset_account_id
      source_id
      formatted_full_code
      code
      full_code
      cost_unit_of_measure
      description
      expense_account_id
      income_account_id
      name
      parent_id
      project_id
      price_unit_of_measure
      source_create_time
      source_update_time
      status
      type
      unit_cost
      unit_price
      vendor_id
      sub_job_id
      createdAt
      updatedAt
      projectId
      paidolProject
      projectIds
      cost_type_ids
      fullName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostCodesBySubJobIdQueryVariables,
  APITypes.ListAgaveCostCodesBySubJobIdQuery
>;
export const listAgaveCostCodesByProjectId = /* GraphQL */ `query ListAgaveCostCodesByProjectId(
  $projectId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveCostCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveCostCodesByProjectId(
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      asset_account_id
      source_id
      formatted_full_code
      code
      full_code
      cost_unit_of_measure
      description
      expense_account_id
      income_account_id
      name
      parent_id
      project_id
      price_unit_of_measure
      source_create_time
      source_update_time
      status
      type
      unit_cost
      unit_price
      vendor_id
      sub_job_id
      createdAt
      updatedAt
      projectId
      paidolProject
      projectIds
      cost_type_ids
      fullName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostCodesByProjectIdQueryVariables,
  APITypes.ListAgaveCostCodesByProjectIdQuery
>;
export const listAgaveCostCodesByPaidolAndProject = /* GraphQL */ `query ListAgaveCostCodesByPaidolAndProject(
  $paidolProject: ID!
  $projectId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveCostCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveCostCodesByPaidolAndProject(
    paidolProject: $paidolProject
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      asset_account_id
      source_id
      formatted_full_code
      code
      full_code
      cost_unit_of_measure
      description
      expense_account_id
      income_account_id
      name
      parent_id
      project_id
      price_unit_of_measure
      source_create_time
      source_update_time
      status
      type
      unit_cost
      unit_price
      vendor_id
      sub_job_id
      createdAt
      updatedAt
      projectId
      paidolProject
      projectIds
      cost_type_ids
      fullName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostCodesByPaidolAndProjectQueryVariables,
  APITypes.ListAgaveCostCodesByPaidolAndProjectQuery
>;
export const getAgaveSubJob = /* GraphQL */ `query GetAgaveSubJob($id: ID!) {
  getAgaveSubJob(id: $id) {
    id
    agaveSubJobId
    paidolId
    authPaidolId
    source_id
    name
    number
    code
    status
    type
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    createdAt
    updatedAt
    projectId
    fullName
    cost_code_ids
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveSubJobQueryVariables,
  APITypes.GetAgaveSubJobQuery
>;
export const listAgaveSubJobs = /* GraphQL */ `query ListAgaveSubJobs(
  $id: ID
  $filter: ModelAgaveSubJobFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveSubJobs(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      agaveSubJobId
      paidolId
      authPaidolId
      source_id
      name
      number
      code
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      fullName
      cost_code_ids
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveSubJobsQueryVariables,
  APITypes.ListAgaveSubJobsQuery
>;
export const listAgaveSubJobsByPaidolId = /* GraphQL */ `query ListAgaveSubJobsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveSubJobFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveSubJobsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      agaveSubJobId
      paidolId
      authPaidolId
      source_id
      name
      number
      code
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      fullName
      cost_code_ids
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveSubJobsByPaidolIdQueryVariables,
  APITypes.ListAgaveSubJobsByPaidolIdQuery
>;
export const listAgaveSubJobsByProjectId = /* GraphQL */ `query ListAgaveSubJobsByProjectId(
  $projectId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveSubJobFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveSubJobsByProjectId(
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      agaveSubJobId
      paidolId
      authPaidolId
      source_id
      name
      number
      code
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      fullName
      cost_code_ids
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveSubJobsByProjectIdQueryVariables,
  APITypes.ListAgaveSubJobsByProjectIdQuery
>;
export const listAgaveSubJobsByPaidolAndProject = /* GraphQL */ `query ListAgaveSubJobsByPaidolAndProject(
  $fullName: String!
  $projectId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveSubJobFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveSubJobsByPaidolAndProject(
    fullName: $fullName
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      agaveSubJobId
      paidolId
      authPaidolId
      source_id
      name
      number
      code
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      fullName
      cost_code_ids
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveSubJobsByPaidolAndProjectQueryVariables,
  APITypes.ListAgaveSubJobsByPaidolAndProjectQuery
>;
export const getAgaveProjectCostCode = /* GraphQL */ `query GetAgaveProjectCostCode($id: ID!) {
  getAgaveProjectCostCode(id: $id) {
    id
    paidolId
    authPaidolId
    projectId
    costCodeId
    projectIdCostCodeId
    costCodeName
    costCodeCode
    projectName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveProjectCostCodeQueryVariables,
  APITypes.GetAgaveProjectCostCodeQuery
>;
export const listAgaveProjectCostCodes = /* GraphQL */ `query ListAgaveProjectCostCodes(
  $id: ID
  $filter: ModelAgaveProjectCostCodeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveProjectCostCodes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      costCodeId
      projectIdCostCodeId
      costCodeName
      costCodeCode
      projectName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectCostCodesQueryVariables,
  APITypes.ListAgaveProjectCostCodesQuery
>;
export const listAgaveProjectCostCodesByPaidolId = /* GraphQL */ `query ListAgaveProjectCostCodesByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveProjectCostCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveProjectCostCodesByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      costCodeId
      projectIdCostCodeId
      costCodeName
      costCodeCode
      projectName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectCostCodesByPaidolIdQueryVariables,
  APITypes.ListAgaveProjectCostCodesByPaidolIdQuery
>;
export const listAgaveProjectCostCodesByProjectId = /* GraphQL */ `query ListAgaveProjectCostCodesByProjectId(
  $projectId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveProjectCostCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveProjectCostCodesByProjectId(
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      costCodeId
      projectIdCostCodeId
      costCodeName
      costCodeCode
      projectName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectCostCodesByProjectIdQueryVariables,
  APITypes.ListAgaveProjectCostCodesByProjectIdQuery
>;
export const listAgaveProjectCostCodesByCostCodeId = /* GraphQL */ `query ListAgaveProjectCostCodesByCostCodeId(
  $costCodeId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveProjectCostCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveProjectCostCodesByCostCodeId(
    costCodeId: $costCodeId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      costCodeId
      projectIdCostCodeId
      costCodeName
      costCodeCode
      projectName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectCostCodesByCostCodeIdQueryVariables,
  APITypes.ListAgaveProjectCostCodesByCostCodeIdQuery
>;
export const listAgaveProjectCostCodesByProjectAndCostCode = /* GraphQL */ `query ListAgaveProjectCostCodesByProjectAndCostCode(
  $projectIdCostCodeId: ID!
  $costCodeId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveProjectCostCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveProjectCostCodesByProjectAndCostCode(
    projectIdCostCodeId: $projectIdCostCodeId
    costCodeId: $costCodeId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      costCodeId
      projectIdCostCodeId
      costCodeName
      costCodeCode
      projectName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectCostCodesByProjectAndCostCodeQueryVariables,
  APITypes.ListAgaveProjectCostCodesByProjectAndCostCodeQuery
>;
export const getAgaveProjectSubJob = /* GraphQL */ `query GetAgaveProjectSubJob($id: ID!) {
  getAgaveProjectSubJob(id: $id) {
    id
    paidolId
    authPaidolId
    projectId
    subJobId
    projectIdSubJobId
    subJobName
    subJobNumber
    projectName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveProjectSubJobQueryVariables,
  APITypes.GetAgaveProjectSubJobQuery
>;
export const listAgaveProjectSubJobs = /* GraphQL */ `query ListAgaveProjectSubJobs(
  $id: ID
  $filter: ModelAgaveProjectSubJobFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveProjectSubJobs(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      subJobId
      projectIdSubJobId
      subJobName
      subJobNumber
      projectName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectSubJobsQueryVariables,
  APITypes.ListAgaveProjectSubJobsQuery
>;
export const listAgaveProjectSubJobsByPaidolId = /* GraphQL */ `query ListAgaveProjectSubJobsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveProjectSubJobFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveProjectSubJobsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      subJobId
      projectIdSubJobId
      subJobName
      subJobNumber
      projectName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectSubJobsByPaidolIdQueryVariables,
  APITypes.ListAgaveProjectSubJobsByPaidolIdQuery
>;
export const listAgaveProjectSubJobsByProjectId = /* GraphQL */ `query ListAgaveProjectSubJobsByProjectId(
  $projectId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveProjectSubJobFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveProjectSubJobsByProjectId(
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      subJobId
      projectIdSubJobId
      subJobName
      subJobNumber
      projectName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectSubJobsByProjectIdQueryVariables,
  APITypes.ListAgaveProjectSubJobsByProjectIdQuery
>;
export const listAgaveProjectSubJobsBySubJobId = /* GraphQL */ `query ListAgaveProjectSubJobsBySubJobId(
  $subJobId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveProjectSubJobFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveProjectSubJobsBySubJobId(
    subJobId: $subJobId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      subJobId
      projectIdSubJobId
      subJobName
      subJobNumber
      projectName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectSubJobsBySubJobIdQueryVariables,
  APITypes.ListAgaveProjectSubJobsBySubJobIdQuery
>;
export const listAgaveProjectSubJobsByProjectAndSubJob = /* GraphQL */ `query ListAgaveProjectSubJobsByProjectAndSubJob(
  $projectIdSubJobId: ID!
  $subJobId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveProjectSubJobFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveProjectSubJobsByProjectAndSubJob(
    projectIdSubJobId: $projectIdSubJobId
    subJobId: $subJobId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      subJobId
      projectIdSubJobId
      subJobName
      subJobNumber
      projectName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectSubJobsByProjectAndSubJobQueryVariables,
  APITypes.ListAgaveProjectSubJobsByProjectAndSubJobQuery
>;
export const getAgaveSubJobCostCode = /* GraphQL */ `query GetAgaveSubJobCostCode($id: ID!) {
  getAgaveSubJobCostCode(id: $id) {
    id
    paidolId
    authPaidolId
    subJobId
    costCodeId
    projectId
    subJobIdCostCodeId
    costCodeName
    costCodeCode
    subJobName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveSubJobCostCodeQueryVariables,
  APITypes.GetAgaveSubJobCostCodeQuery
>;
export const listAgaveSubJobCostCodes = /* GraphQL */ `query ListAgaveSubJobCostCodes(
  $id: ID
  $filter: ModelAgaveSubJobCostCodeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveSubJobCostCodes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      subJobId
      costCodeId
      projectId
      subJobIdCostCodeId
      costCodeName
      costCodeCode
      subJobName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveSubJobCostCodesQueryVariables,
  APITypes.ListAgaveSubJobCostCodesQuery
>;
export const listAgaveSubJobCostCodesByPaidolId = /* GraphQL */ `query ListAgaveSubJobCostCodesByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveSubJobCostCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveSubJobCostCodesByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      subJobId
      costCodeId
      projectId
      subJobIdCostCodeId
      costCodeName
      costCodeCode
      subJobName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveSubJobCostCodesByPaidolIdQueryVariables,
  APITypes.ListAgaveSubJobCostCodesByPaidolIdQuery
>;
export const listAgaveSubJobCostCodesBySubJobId = /* GraphQL */ `query ListAgaveSubJobCostCodesBySubJobId(
  $subJobId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveSubJobCostCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveSubJobCostCodesBySubJobId(
    subJobId: $subJobId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      subJobId
      costCodeId
      projectId
      subJobIdCostCodeId
      costCodeName
      costCodeCode
      subJobName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveSubJobCostCodesBySubJobIdQueryVariables,
  APITypes.ListAgaveSubJobCostCodesBySubJobIdQuery
>;
export const listAgaveSubJobCostCodesByCostCodeId = /* GraphQL */ `query ListAgaveSubJobCostCodesByCostCodeId(
  $costCodeId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveSubJobCostCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveSubJobCostCodesByCostCodeId(
    costCodeId: $costCodeId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      subJobId
      costCodeId
      projectId
      subJobIdCostCodeId
      costCodeName
      costCodeCode
      subJobName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveSubJobCostCodesByCostCodeIdQueryVariables,
  APITypes.ListAgaveSubJobCostCodesByCostCodeIdQuery
>;
export const listAgaveSubJobCostCodesBySubJobAndCostCode = /* GraphQL */ `query ListAgaveSubJobCostCodesBySubJobAndCostCode(
  $subJobIdCostCodeId: ID!
  $costCodeId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveSubJobCostCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveSubJobCostCodesBySubJobAndCostCode(
    subJobIdCostCodeId: $subJobIdCostCodeId
    costCodeId: $costCodeId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      subJobId
      costCodeId
      projectId
      subJobIdCostCodeId
      costCodeName
      costCodeCode
      subJobName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveSubJobCostCodesBySubJobAndCostCodeQueryVariables,
  APITypes.ListAgaveSubJobCostCodesBySubJobAndCostCodeQuery
>;
export const getAgaveProjectLocation = /* GraphQL */ `query GetAgaveProjectLocation($id: ID!) {
  getAgaveProjectLocation(id: $id) {
    id
    paidolId
    authPaidolId
    projectId
    locationId
    projectName
    locationName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveProjectLocationQueryVariables,
  APITypes.GetAgaveProjectLocationQuery
>;
export const listAgaveProjectLocations = /* GraphQL */ `query ListAgaveProjectLocations(
  $id: ID
  $filter: ModelAgaveProjectLocationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveProjectLocations(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      locationId
      projectName
      locationName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectLocationsQueryVariables,
  APITypes.ListAgaveProjectLocationsQuery
>;
export const listAgaveProjectLocationsByPaidolId = /* GraphQL */ `query ListAgaveProjectLocationsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveProjectLocationFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveProjectLocationsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      locationId
      projectName
      locationName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectLocationsByPaidolIdQueryVariables,
  APITypes.ListAgaveProjectLocationsByPaidolIdQuery
>;
export const listAgaveProjectLocationsByProjectId = /* GraphQL */ `query ListAgaveProjectLocationsByProjectId(
  $projectId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveProjectLocationFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveProjectLocationsByProjectId(
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      locationId
      projectName
      locationName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectLocationsByProjectIdQueryVariables,
  APITypes.ListAgaveProjectLocationsByProjectIdQuery
>;
export const listAgaveProjectLocationsByLocationId = /* GraphQL */ `query ListAgaveProjectLocationsByLocationId(
  $locationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveProjectLocationFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveProjectLocationsByLocationId(
    locationId: $locationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      locationId
      projectName
      locationName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectLocationsByLocationIdQueryVariables,
  APITypes.ListAgaveProjectLocationsByLocationIdQuery
>;
export const getAgaveProjectDepartment = /* GraphQL */ `query GetAgaveProjectDepartment($id: ID!) {
  getAgaveProjectDepartment(id: $id) {
    id
    paidolId
    authPaidolId
    projectId
    departmentId
    projectName
    departmentName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveProjectDepartmentQueryVariables,
  APITypes.GetAgaveProjectDepartmentQuery
>;
export const listAgaveProjectDepartments = /* GraphQL */ `query ListAgaveProjectDepartments(
  $id: ID
  $filter: ModelAgaveProjectDepartmentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveProjectDepartments(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      departmentId
      projectName
      departmentName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectDepartmentsQueryVariables,
  APITypes.ListAgaveProjectDepartmentsQuery
>;
export const listAgaveProjectDepartmentsByPaidolId = /* GraphQL */ `query ListAgaveProjectDepartmentsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveProjectDepartmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveProjectDepartmentsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      departmentId
      projectName
      departmentName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectDepartmentsByPaidolIdQueryVariables,
  APITypes.ListAgaveProjectDepartmentsByPaidolIdQuery
>;
export const listAgaveProjectDepartmentsByProjectId = /* GraphQL */ `query ListAgaveProjectDepartmentsByProjectId(
  $projectId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveProjectDepartmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveProjectDepartmentsByProjectId(
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      departmentId
      projectName
      departmentName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectDepartmentsByProjectIdQueryVariables,
  APITypes.ListAgaveProjectDepartmentsByProjectIdQuery
>;
export const listAgaveProjectDepartmentsByDepartmentId = /* GraphQL */ `query ListAgaveProjectDepartmentsByDepartmentId(
  $departmentId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveProjectDepartmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveProjectDepartmentsByDepartmentId(
    departmentId: $departmentId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      departmentId
      projectName
      departmentName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveProjectDepartmentsByDepartmentIdQueryVariables,
  APITypes.ListAgaveProjectDepartmentsByDepartmentIdQuery
>;
export const getAgaveEmployeeEntity = /* GraphQL */ `query GetAgaveEmployeeEntity($id: ID!) {
  getAgaveEmployeeEntity(id: $id) {
    id
    paidolId
    authPaidolId
    name
    fullName
    firstName
    lastName
    email
    status
    source_id
    source_create_time
    source_update_time
    createdAt
    updatedAt
    source_data
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveEmployeeEntityQueryVariables,
  APITypes.GetAgaveEmployeeEntityQuery
>;
export const listAgaveEmployeeEntities = /* GraphQL */ `query ListAgaveEmployeeEntities(
  $id: ID
  $filter: ModelAgaveEmployeeEntityFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveEmployeeEntities(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      fullName
      firstName
      lastName
      email
      status
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmployeeEntitiesQueryVariables,
  APITypes.ListAgaveEmployeeEntitiesQuery
>;
export const listAgaveEmployeesByPaidolId = /* GraphQL */ `query ListAgaveEmployeesByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveEmployeeEntityFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveEmployeesByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      fullName
      firstName
      lastName
      email
      status
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmployeesByPaidolIdQueryVariables,
  APITypes.ListAgaveEmployeesByPaidolIdQuery
>;
export const getAgaveEmployeeLocation = /* GraphQL */ `query GetAgaveEmployeeLocation($id: ID!) {
  getAgaveEmployeeLocation(id: $id) {
    id
    paidolId
    authPaidolId
    employeeId
    locationId
    employeeName
    locationName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveEmployeeLocationQueryVariables,
  APITypes.GetAgaveEmployeeLocationQuery
>;
export const listAgaveEmployeeLocations = /* GraphQL */ `query ListAgaveEmployeeLocations(
  $id: ID
  $filter: ModelAgaveEmployeeLocationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveEmployeeLocations(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      employeeId
      locationId
      employeeName
      locationName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmployeeLocationsQueryVariables,
  APITypes.ListAgaveEmployeeLocationsQuery
>;
export const listAgaveEmployeeLocationsByPaidolId = /* GraphQL */ `query ListAgaveEmployeeLocationsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveEmployeeLocationFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveEmployeeLocationsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      employeeId
      locationId
      employeeName
      locationName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmployeeLocationsByPaidolIdQueryVariables,
  APITypes.ListAgaveEmployeeLocationsByPaidolIdQuery
>;
export const listAgaveEmployeeLocationsByEmployeeId = /* GraphQL */ `query ListAgaveEmployeeLocationsByEmployeeId(
  $employeeId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveEmployeeLocationFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveEmployeeLocationsByEmployeeId(
    employeeId: $employeeId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      employeeId
      locationId
      employeeName
      locationName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmployeeLocationsByEmployeeIdQueryVariables,
  APITypes.ListAgaveEmployeeLocationsByEmployeeIdQuery
>;
export const listAgaveEmployeeLocationsByLocationId = /* GraphQL */ `query ListAgaveEmployeeLocationsByLocationId(
  $locationId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveEmployeeLocationFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveEmployeeLocationsByLocationId(
    locationId: $locationId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      employeeId
      locationId
      employeeName
      locationName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmployeeLocationsByLocationIdQueryVariables,
  APITypes.ListAgaveEmployeeLocationsByLocationIdQuery
>;
export const getAgaveEmployeeDepartment = /* GraphQL */ `query GetAgaveEmployeeDepartment($id: ID!) {
  getAgaveEmployeeDepartment(id: $id) {
    id
    paidolId
    authPaidolId
    employeeId
    departmentId
    employeeName
    departmentName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveEmployeeDepartmentQueryVariables,
  APITypes.GetAgaveEmployeeDepartmentQuery
>;
export const listAgaveEmployeeDepartments = /* GraphQL */ `query ListAgaveEmployeeDepartments(
  $id: ID
  $filter: ModelAgaveEmployeeDepartmentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveEmployeeDepartments(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      employeeId
      departmentId
      employeeName
      departmentName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmployeeDepartmentsQueryVariables,
  APITypes.ListAgaveEmployeeDepartmentsQuery
>;
export const listAgaveEmployeeDepartmentsByPaidolId = /* GraphQL */ `query ListAgaveEmployeeDepartmentsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveEmployeeDepartmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveEmployeeDepartmentsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      employeeId
      departmentId
      employeeName
      departmentName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmployeeDepartmentsByPaidolIdQueryVariables,
  APITypes.ListAgaveEmployeeDepartmentsByPaidolIdQuery
>;
export const listAgaveEmployeeDepartmentsByEmployeeId = /* GraphQL */ `query ListAgaveEmployeeDepartmentsByEmployeeId(
  $employeeId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveEmployeeDepartmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveEmployeeDepartmentsByEmployeeId(
    employeeId: $employeeId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      employeeId
      departmentId
      employeeName
      departmentName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmployeeDepartmentsByEmployeeIdQueryVariables,
  APITypes.ListAgaveEmployeeDepartmentsByEmployeeIdQuery
>;
export const listAgaveEmployeeDepartmentsByDepartmentId = /* GraphQL */ `query ListAgaveEmployeeDepartmentsByDepartmentId(
  $departmentId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveEmployeeDepartmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveEmployeeDepartmentsByDepartmentId(
    departmentId: $departmentId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      employeeId
      departmentId
      employeeName
      departmentName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmployeeDepartmentsByDepartmentIdQueryVariables,
  APITypes.ListAgaveEmployeeDepartmentsByDepartmentIdQuery
>;
export const getAgaveCostType = /* GraphQL */ `query GetAgaveCostType($id: ID!) {
  getAgaveCostType(id: $id) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    project_id
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    createdAt
    updatedAt
    projectId
    paidolProject
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveCostTypeQueryVariables,
  APITypes.GetAgaveCostTypeQuery
>;
export const listAgaveCostTypes = /* GraphQL */ `query ListAgaveCostTypes(
  $id: ID
  $filter: ModelAgaveCostTypeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveCostTypes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      project_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      paidolProject
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostTypesQueryVariables,
  APITypes.ListAgaveCostTypesQuery
>;
export const listAgaveCostTypesByPaidolId = /* GraphQL */ `query ListAgaveCostTypesByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveCostTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveCostTypesByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      project_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      paidolProject
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostTypesByPaidolIdQueryVariables,
  APITypes.ListAgaveCostTypesByPaidolIdQuery
>;
export const listAgaveCostTypesByProjectId = /* GraphQL */ `query ListAgaveCostTypesByProjectId(
  $projectId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveCostTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveCostTypesByProjectId(
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      project_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      paidolProject
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostTypesByProjectIdQueryVariables,
  APITypes.ListAgaveCostTypesByProjectIdQuery
>;
export const listAgaveCostTypesByPaidolAndProject = /* GraphQL */ `query ListAgaveCostTypesByPaidolAndProject(
  $paidolProject: ID!
  $projectId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveCostTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveCostTypesByPaidolAndProject(
    paidolProject: $paidolProject
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      project_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      paidolProject
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostTypesByPaidolAndProjectQueryVariables,
  APITypes.ListAgaveCostTypesByPaidolAndProjectQuery
>;
export const getAgaveEquipment = /* GraphQL */ `query GetAgaveEquipment($id: ID!) {
  getAgaveEquipment(id: $id) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    fullName
    emGroup
    emCo
    category
    department
    status
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    lastSeenAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveEquipmentQueryVariables,
  APITypes.GetAgaveEquipmentQuery
>;
export const listAgaveEquipments = /* GraphQL */ `query ListAgaveEquipments(
  $id: ID
  $filter: ModelAgaveEquipmentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveEquipments(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCo
      category
      department
      status
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEquipmentsQueryVariables,
  APITypes.ListAgaveEquipmentsQuery
>;
export const listAgaveEquipmentByPaidolId = /* GraphQL */ `query ListAgaveEquipmentByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveEquipmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveEquipmentByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCo
      category
      department
      status
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEquipmentByPaidolIdQueryVariables,
  APITypes.ListAgaveEquipmentByPaidolIdQuery
>;
export const getAgaveEmCostCode = /* GraphQL */ `query GetAgaveEmCostCode($id: ID!) {
  getAgaveEmCostCode(id: $id) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    fullName
    emGroup
    emCostTypeCodes
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    lastSeenAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveEmCostCodeQueryVariables,
  APITypes.GetAgaveEmCostCodeQuery
>;
export const listAgaveEmCostCodes = /* GraphQL */ `query ListAgaveEmCostCodes(
  $id: ID
  $filter: ModelAgaveEmCostCodeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveEmCostCodes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCostTypeCodes
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmCostCodesQueryVariables,
  APITypes.ListAgaveEmCostCodesQuery
>;
export const listAgaveEmCostCodesByPaidolId = /* GraphQL */ `query ListAgaveEmCostCodesByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveEmCostCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveEmCostCodesByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCostTypeCodes
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmCostCodesByPaidolIdQueryVariables,
  APITypes.ListAgaveEmCostCodesByPaidolIdQuery
>;
export const getAgaveEmDepartment = /* GraphQL */ `query GetAgaveEmDepartment($id: ID!) {
  getAgaveEmDepartment(id: $id) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    fullName
    emCo
    costCodeKeys
    costTypeKeys
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    lastSeenAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveEmDepartmentQueryVariables,
  APITypes.GetAgaveEmDepartmentQuery
>;
export const listAgaveEmDepartments = /* GraphQL */ `query ListAgaveEmDepartments(
  $id: ID
  $filter: ModelAgaveEmDepartmentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveEmDepartments(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emCo
      costCodeKeys
      costTypeKeys
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmDepartmentsQueryVariables,
  APITypes.ListAgaveEmDepartmentsQuery
>;
export const listAgaveEmDepartmentsByPaidolId = /* GraphQL */ `query ListAgaveEmDepartmentsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveEmDepartmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveEmDepartmentsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emCo
      costCodeKeys
      costTypeKeys
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmDepartmentsByPaidolIdQueryVariables,
  APITypes.ListAgaveEmDepartmentsByPaidolIdQuery
>;
export const getAgaveEmCostType = /* GraphQL */ `query GetAgaveEmCostType($id: ID!) {
  getAgaveEmCostType(id: $id) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    fullName
    emGroup
    abbreviation
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    lastSeenAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveEmCostTypeQueryVariables,
  APITypes.GetAgaveEmCostTypeQuery
>;
export const listAgaveEmCostTypes = /* GraphQL */ `query ListAgaveEmCostTypes(
  $id: ID
  $filter: ModelAgaveEmCostTypeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveEmCostTypes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      abbreviation
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmCostTypesQueryVariables,
  APITypes.ListAgaveEmCostTypesQuery
>;
export const listAgaveEmCostTypesByPaidolId = /* GraphQL */ `query ListAgaveEmCostTypesByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveEmCostTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveEmCostTypesByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      abbreviation
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmCostTypesByPaidolIdQueryVariables,
  APITypes.ListAgaveEmCostTypesByPaidolIdQuery
>;
export const getAgaveCostCodeCostType = /* GraphQL */ `query GetAgaveCostCodeCostType($id: ID!) {
  getAgaveCostCodeCostType(id: $id) {
    id
    paidolId
    authPaidolId
    costCodeId
    costTypeId
    projectId
    costCodeCode
    costCodeName
    costTypeCode
    costTypeName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveCostCodeCostTypeQueryVariables,
  APITypes.GetAgaveCostCodeCostTypeQuery
>;
export const listAgaveCostCodeCostTypes = /* GraphQL */ `query ListAgaveCostCodeCostTypes(
  $id: ID
  $filter: ModelAgaveCostCodeCostTypeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveCostCodeCostTypes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      costCodeId
      costTypeId
      projectId
      costCodeCode
      costCodeName
      costTypeCode
      costTypeName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostCodeCostTypesQueryVariables,
  APITypes.ListAgaveCostCodeCostTypesQuery
>;
export const listAgaveCostCodeCostTypesByPaidolId = /* GraphQL */ `query ListAgaveCostCodeCostTypesByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveCostCodeCostTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveCostCodeCostTypesByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      costCodeId
      costTypeId
      projectId
      costCodeCode
      costCodeName
      costTypeCode
      costTypeName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostCodeCostTypesByPaidolIdQueryVariables,
  APITypes.ListAgaveCostCodeCostTypesByPaidolIdQuery
>;
export const listAgaveCostCodeCostTypesByCostCodeId = /* GraphQL */ `query ListAgaveCostCodeCostTypesByCostCodeId(
  $costCodeId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveCostCodeCostTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveCostCodeCostTypesByCostCodeId(
    costCodeId: $costCodeId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      costCodeId
      costTypeId
      projectId
      costCodeCode
      costCodeName
      costTypeCode
      costTypeName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostCodeCostTypesByCostCodeIdQueryVariables,
  APITypes.ListAgaveCostCodeCostTypesByCostCodeIdQuery
>;
export const listAgaveCostCodeCostTypesByCostTypeId = /* GraphQL */ `query ListAgaveCostCodeCostTypesByCostTypeId(
  $costTypeId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveCostCodeCostTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveCostCodeCostTypesByCostTypeId(
    costTypeId: $costTypeId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      costCodeId
      costTypeId
      projectId
      costCodeCode
      costCodeName
      costTypeCode
      costTypeName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostCodeCostTypesByCostTypeIdQueryVariables,
  APITypes.ListAgaveCostCodeCostTypesByCostTypeIdQuery
>;
export const listAgaveCostCodeCostTypesByProjectId = /* GraphQL */ `query ListAgaveCostCodeCostTypesByProjectId(
  $projectId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveCostCodeCostTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveCostCodeCostTypesByProjectId(
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      costCodeId
      costTypeId
      projectId
      costCodeCode
      costCodeName
      costTypeCode
      costTypeName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostCodeCostTypesByProjectIdQueryVariables,
  APITypes.ListAgaveCostCodeCostTypesByProjectIdQuery
>;
export const getAgaveEmCostCodeCostType = /* GraphQL */ `query GetAgaveEmCostCodeCostType($id: ID!) {
  getAgaveEmCostCodeCostType(id: $id) {
    id
    paidolId
    authPaidolId
    emCostCodeId
    emCostTypeId
    emGroup
    emCostCodeCode
    emCostCodeName
    emCostTypeCode
    emCostTypeName
    unitOfMeasure
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveEmCostCodeCostTypeQueryVariables,
  APITypes.GetAgaveEmCostCodeCostTypeQuery
>;
export const listAgaveEmCostCodeCostTypes = /* GraphQL */ `query ListAgaveEmCostCodeCostTypes(
  $id: ID
  $filter: ModelAgaveEmCostCodeCostTypeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveEmCostCodeCostTypes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      emCostCodeId
      emCostTypeId
      emGroup
      emCostCodeCode
      emCostCodeName
      emCostTypeCode
      emCostTypeName
      unitOfMeasure
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmCostCodeCostTypesQueryVariables,
  APITypes.ListAgaveEmCostCodeCostTypesQuery
>;
export const listAgaveEmCostCodeCostTypesByPaidolId = /* GraphQL */ `query ListAgaveEmCostCodeCostTypesByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveEmCostCodeCostTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveEmCostCodeCostTypesByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      emCostCodeId
      emCostTypeId
      emGroup
      emCostCodeCode
      emCostCodeName
      emCostTypeCode
      emCostTypeName
      unitOfMeasure
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmCostCodeCostTypesByPaidolIdQueryVariables,
  APITypes.ListAgaveEmCostCodeCostTypesByPaidolIdQuery
>;
export const listAgaveEmCostCodeCostTypesByEmCostCodeId = /* GraphQL */ `query ListAgaveEmCostCodeCostTypesByEmCostCodeId(
  $emCostCodeId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveEmCostCodeCostTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveEmCostCodeCostTypesByEmCostCodeId(
    emCostCodeId: $emCostCodeId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      emCostCodeId
      emCostTypeId
      emGroup
      emCostCodeCode
      emCostCodeName
      emCostTypeCode
      emCostTypeName
      unitOfMeasure
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmCostCodeCostTypesByEmCostCodeIdQueryVariables,
  APITypes.ListAgaveEmCostCodeCostTypesByEmCostCodeIdQuery
>;
export const listAgaveEmCostCodeCostTypesByEmCostTypeId = /* GraphQL */ `query ListAgaveEmCostCodeCostTypesByEmCostTypeId(
  $emCostTypeId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveEmCostCodeCostTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveEmCostCodeCostTypesByEmCostTypeId(
    emCostTypeId: $emCostTypeId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      emCostCodeId
      emCostTypeId
      emGroup
      emCostCodeCode
      emCostCodeName
      emCostTypeCode
      emCostTypeName
      unitOfMeasure
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveEmCostCodeCostTypesByEmCostTypeIdQueryVariables,
  APITypes.ListAgaveEmCostCodeCostTypesByEmCostTypeIdQuery
>;
export const getAgaveCostCodeCostTypeGl = /* GraphQL */ `query GetAgaveCostCodeCostTypeGl($id: ID!) {
  getAgaveCostCodeCostTypeGl(id: $id) {
    id
    paidolId
    authPaidolId
    projectId
    costCodeId
    costTypeId
    glCodeId
    projectCostCodeCostTypeKey
    glCodeSourceId
    glCodeNumber
    itemSourceId
    itemName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveCostCodeCostTypeGlQueryVariables,
  APITypes.GetAgaveCostCodeCostTypeGlQuery
>;
export const listAgaveCostCodeCostTypeGls = /* GraphQL */ `query ListAgaveCostCodeCostTypeGls(
  $id: ID
  $filter: ModelAgaveCostCodeCostTypeGlFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveCostCodeCostTypeGls(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      costCodeId
      costTypeId
      glCodeId
      projectCostCodeCostTypeKey
      glCodeSourceId
      glCodeNumber
      itemSourceId
      itemName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostCodeCostTypeGlsQueryVariables,
  APITypes.ListAgaveCostCodeCostTypeGlsQuery
>;
export const listAgaveCostCodeCostTypeGlsByPaidolId = /* GraphQL */ `query ListAgaveCostCodeCostTypeGlsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveCostCodeCostTypeGlFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveCostCodeCostTypeGlsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      costCodeId
      costTypeId
      glCodeId
      projectCostCodeCostTypeKey
      glCodeSourceId
      glCodeNumber
      itemSourceId
      itemName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostCodeCostTypeGlsByPaidolIdQueryVariables,
  APITypes.ListAgaveCostCodeCostTypeGlsByPaidolIdQuery
>;
export const listAgaveCostCodeCostTypeGlsByPaidolProjectCostCodeCostType = /* GraphQL */ `query ListAgaveCostCodeCostTypeGlsByPaidolProjectCostCodeCostType(
  $paidolId: ID!
  $projectCostCodeCostTypeKey: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveCostCodeCostTypeGlFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveCostCodeCostTypeGlsByPaidolProjectCostCodeCostType(
    paidolId: $paidolId
    projectCostCodeCostTypeKey: $projectCostCodeCostTypeKey
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      costCodeId
      costTypeId
      glCodeId
      projectCostCodeCostTypeKey
      glCodeSourceId
      glCodeNumber
      itemSourceId
      itemName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostCodeCostTypeGlsByPaidolProjectCostCodeCostTypeQueryVariables,
  APITypes.ListAgaveCostCodeCostTypeGlsByPaidolProjectCostCodeCostTypeQuery
>;
export const listAgaveCostCodeCostTypeGlsByProjectId = /* GraphQL */ `query ListAgaveCostCodeCostTypeGlsByProjectId(
  $projectId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveCostCodeCostTypeGlFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveCostCodeCostTypeGlsByProjectId(
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      costCodeId
      costTypeId
      glCodeId
      projectCostCodeCostTypeKey
      glCodeSourceId
      glCodeNumber
      itemSourceId
      itemName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostCodeCostTypeGlsByProjectIdQueryVariables,
  APITypes.ListAgaveCostCodeCostTypeGlsByProjectIdQuery
>;
export const listAgaveCostCodeCostTypeGlsByCostCodeId = /* GraphQL */ `query ListAgaveCostCodeCostTypeGlsByCostCodeId(
  $costCodeId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveCostCodeCostTypeGlFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveCostCodeCostTypeGlsByCostCodeId(
    costCodeId: $costCodeId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      costCodeId
      costTypeId
      glCodeId
      projectCostCodeCostTypeKey
      glCodeSourceId
      glCodeNumber
      itemSourceId
      itemName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostCodeCostTypeGlsByCostCodeIdQueryVariables,
  APITypes.ListAgaveCostCodeCostTypeGlsByCostCodeIdQuery
>;
export const listAgaveCostCodeCostTypeGlsByCostTypeId = /* GraphQL */ `query ListAgaveCostCodeCostTypeGlsByCostTypeId(
  $costTypeId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveCostCodeCostTypeGlFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveCostCodeCostTypeGlsByCostTypeId(
    costTypeId: $costTypeId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectId
      costCodeId
      costTypeId
      glCodeId
      projectCostCodeCostTypeKey
      glCodeSourceId
      glCodeNumber
      itemSourceId
      itemName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveCostCodeCostTypeGlsByCostTypeIdQueryVariables,
  APITypes.ListAgaveCostCodeCostTypeGlsByCostTypeIdQuery
>;
export const getAgaveLocation = /* GraphQL */ `query GetAgaveLocation($id: ID!) {
  getAgaveLocation(id: $id) {
    id
    paidolId
    authPaidolId
    name
    fullName
    parent_id
    source_id
    source_create_time
    source_update_time
    createdAt
    updatedAt
    source_data
    relatedIds
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveLocationQueryVariables,
  APITypes.GetAgaveLocationQuery
>;
export const listAgaveLocations = /* GraphQL */ `query ListAgaveLocations(
  $id: ID
  $filter: ModelAgaveLocationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveLocations(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      fullName
      parent_id
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveLocationsQueryVariables,
  APITypes.ListAgaveLocationsQuery
>;
export const listAgaveLocationsByPaidolId = /* GraphQL */ `query ListAgaveLocationsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveLocationFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveLocationsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      fullName
      parent_id
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveLocationsByPaidolIdQueryVariables,
  APITypes.ListAgaveLocationsByPaidolIdQuery
>;
export const getAgaveDepartment = /* GraphQL */ `query GetAgaveDepartment($id: ID!) {
  getAgaveDepartment(id: $id) {
    id
    paidolId
    authPaidolId
    code
    name
    fullName
    status
    type
    source_id
    source_create_time
    source_update_time
    createdAt
    updatedAt
    source_data
    relatedIds
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveDepartmentQueryVariables,
  APITypes.GetAgaveDepartmentQuery
>;
export const listAgaveDepartments = /* GraphQL */ `query ListAgaveDepartments(
  $id: ID
  $filter: ModelAgaveDepartmentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveDepartments(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      code
      name
      fullName
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveDepartmentsQueryVariables,
  APITypes.ListAgaveDepartmentsQuery
>;
export const listAgaveDepartmentsByPaidolId = /* GraphQL */ `query ListAgaveDepartmentsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveDepartmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveDepartmentsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      code
      name
      fullName
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveDepartmentsByPaidolIdQueryVariables,
  APITypes.ListAgaveDepartmentsByPaidolIdQuery
>;
export const getAgaveSubaccount = /* GraphQL */ `query GetAgaveSubaccount($id: ID!) {
  getAgaveSubaccount(id: $id) {
    id
    paidolId
    authPaidolId
    code
    name
    status
    type
    source_id
    source_create_time
    source_update_time
    createdAt
    updatedAt
    source_data
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveSubaccountQueryVariables,
  APITypes.GetAgaveSubaccountQuery
>;
export const listAgaveSubaccounts = /* GraphQL */ `query ListAgaveSubaccounts(
  $id: ID
  $filter: ModelAgaveSubaccountFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAgaveSubaccounts(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      code
      name
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveSubaccountsQueryVariables,
  APITypes.ListAgaveSubaccountsQuery
>;
export const listAgaveSubaccountsByPaidolId = /* GraphQL */ `query ListAgaveSubaccountsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveSubaccountFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveSubaccountsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      code
      name
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveSubaccountsByPaidolIdQueryVariables,
  APITypes.ListAgaveSubaccountsByPaidolIdQuery
>;
export const getAgaveVendor = /* GraphQL */ `query GetAgaveVendor($id: ID!) {
  getAgaveVendor(id: $id) {
    id
    paidolId
    authPaidolId
    source_id
    address {
      street_1
      street_2
      city
      state
      country
      postal_code
      __typename
    }
    code
    email
    fax
    name
    phone
    status
    tax_number
    terms
    type
    website
    source_create_time
    source_update_time
    source_data {
      V1099YN
      V1099Type
      V1099Box
      EFT
      data
      __typename
    }
    createdAt
    updatedAt
    fullName
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveVendorQueryVariables,
  APITypes.GetAgaveVendorQuery
>;
export const listAgaveVendors = /* GraphQL */ `query ListAgaveVendors(
  $filter: ModelAgaveVendorFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveVendors(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      code
      email
      fax
      name
      phone
      status
      tax_number
      terms
      type
      website
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveVendorsQueryVariables,
  APITypes.ListAgaveVendorsQuery
>;
export const listAgaveVendorsByPaidolId = /* GraphQL */ `query ListAgaveVendorsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAgaveVendorFilterInput
  $limit: Int
  $nextToken: String
) {
  listAgaveVendorsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      code
      email
      fax
      name
      phone
      status
      tax_number
      terms
      type
      website
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAgaveVendorsByPaidolIdQueryVariables,
  APITypes.ListAgaveVendorsByPaidolIdQuery
>;
export const getPaidolTheme = /* GraphQL */ `query GetPaidolTheme($id: ID!) {
  getPaidolTheme(id: $id) {
    id
    paidolId
    palette {
      primary
      primaryDark
      primaryDarker
      primaryLight
      primaryLighter
      secondary
      secondaryDark
      textPrimary
      textSecondary
      whiteColor
      successColor
      warningColor
      errorColor
      errorLightColor
      lightestGrayColor
      lightGrayColor
      lightBlueColor
      info
      statusSuccess
      statusWarning
      statusError
      neutral95
      neutralVariant25
      neutral50
      neutral90
      surfaceContainerHigh
      orange100
      orange300
      orange700
      green50
      green700
      red50
      red700
      link400
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPaidolThemeQueryVariables,
  APITypes.GetPaidolThemeQuery
>;
export const listPaidolThemes = /* GraphQL */ `query ListPaidolThemes(
  $id: ID
  $filter: ModelPaidolThemeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPaidolThemes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPaidolThemesQueryVariables,
  APITypes.ListPaidolThemesQuery
>;
export const listPaidolThemeByPaidolId = /* GraphQL */ `query ListPaidolThemeByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPaidolThemeFilterInput
  $limit: Int
  $nextToken: String
) {
  listPaidolThemeByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPaidolThemeByPaidolIdQueryVariables,
  APITypes.ListPaidolThemeByPaidolIdQuery
>;
export const getPaidolUser = /* GraphQL */ `query GetPaidolUser($id: ID!) {
  getPaidolUser(id: $id) {
    id
    paidol_id
    paidol {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    user_id
    user {
      id
      username
      email
      first_name
      middle_name
      last_name
      suffix
      picture
      is_speedster
      birthdate
      address
      phone_number
      phone_extension
      password_updated_at
      finicityCustomerId
      dwollaCustomerId
      is_support
      deletedAt
      createdAt
      updatedAt
      __typename
    }
    email
    position
    phone
    address {
      address1
      address2
      city
      state
      country
      postal_code
      __typename
    }
    roles
    is_test_fixture
    paymentCards {
      nextToken
      __typename
    }
    authorizedUserId
    authorizedUserApplicationId
    allowedJobCodes
    employee_id
    managedGroups {
      nextToken
      __typename
    }
    managedProjectsGroups {
      nextToken
      __typename
    }
    glCodeVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    projectVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    departmentVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    columnPreferences {
      paidolId
      __typename
    }
    widgetPreferences {
      widgetId
      hidden
      __typename
    }
    defaultAgaveEmployeeId
    defaultAgaveEmployee {
      id
      paidolId
      authPaidolId
      name
      fullName
      firstName
      lastName
      email
      status
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    deletedAt
    landingPagePreference
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPaidolUserQueryVariables,
  APITypes.GetPaidolUserQuery
>;
export const listPaidolUsers = /* GraphQL */ `query ListPaidolUsers(
  $filter: ModelPaidolUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listPaidolUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPaidolUsersQueryVariables,
  APITypes.ListPaidolUsersQuery
>;
export const paidolUserByPaidolId = /* GraphQL */ `query PaidolUserByPaidolId(
  $paidol_id: ID!
  $roles: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPaidolUserFilterInput
  $limit: Int
  $nextToken: String
) {
  paidolUserByPaidolId(
    paidol_id: $paidol_id
    roles: $roles
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PaidolUserByPaidolIdQueryVariables,
  APITypes.PaidolUserByPaidolIdQuery
>;
export const paidolUserByUserId = /* GraphQL */ `query PaidolUserByUserId(
  $user_id: ID!
  $paidol_id: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPaidolUserFilterInput
  $limit: Int
  $nextToken: String
) {
  paidolUserByUserId(
    user_id: $user_id
    paidol_id: $paidol_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PaidolUserByUserIdQueryVariables,
  APITypes.PaidolUserByUserIdQuery
>;
export const paidolUserByEmail = /* GraphQL */ `query PaidolUserByEmail(
  $email: String!
  $paidol_id: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPaidolUserFilterInput
  $limit: Int
  $nextToken: String
) {
  paidolUserByEmail(
    email: $email
    paidol_id: $paidol_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PaidolUserByEmailQueryVariables,
  APITypes.PaidolUserByEmailQuery
>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    username
    email
    first_name
    middle_name
    last_name
    suffix
    paidol_users {
      nextToken
      __typename
    }
    picture
    is_speedster
    birthdate
    address
    phone_number
    phone_extension
    password_updated_at
    finicityCustomerId
    dwollaCustomerId
    firstRunBanner {
      insights
      transactions
      reimbursements
      cardsManagement
      spendRules
      funding
      teamMembers
      groups
      wallet
      settings
      connections
      __typename
    }
    is_support
    deletedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const getPaidol = /* GraphQL */ `query GetPaidol($id: ID!) {
  getPaidol(id: $id) {
    id
    id_base58
    id_base58_short
    owner_paidol_id
    slug
    legal_name
    account_balance
    name
    dba
    ein
    mcc
    corp_type
    industry
    company_email
    customer_facing_email
    company_phone
    website
    company_address {
      address1
      address2
      city
      state
      country
      postal_code
      __typename
    }
    customer_facing_address {
      address1
      address2
      city
      state
      country
      postal_code
      __typename
    }
    legal_address {
      address1
      address2
      city
      state
      country
      postal_code
      __typename
    }
    business_owner_ssn
    dwolla_business_industry_classification
    admin_user_id
    low_balance_alert_threshold
    low_balance_auto_funding_amount
    low_balance_auto_funding_threshold
    speedscore
    priority_status
    deleted_at
    company_id
    logo
    priority_response
    agave_data_sync_in_progress
    bankAccounts {
      bankId
      accountType
      accountNumber
      routingNumber
      defaults
      isActive
      __typename
    }
    submittedBankAccounts
    achEnabled
    virtualCardRequested
    virtualCardEnabled
    achRequested
    cron_status
    owner_sub
    is_test_fixture
    is_migration
    enablePCards
    accountingDateSettings {
      isEnabled
      __typename
    }
    reimbursementSettings {
      isEnabled
      isCheckrunEnabled
      rhythm
      day
      weekday
      ordinal
      mileageRate
      mileageRateEffectiveFrom
      __typename
    }
    receiptsSettings {
      isEnabled
      minimumAmount
      exemptCardIds
      __typename
    }
    approveWithoutReceipts
    notesSettings {
      isEnabled
      __typename
    }
    editLockingSettings {
      isEnabled
      __typename
    }
    jobCodeSettings {
      isEnabled
      __typename
    }
    flexCodingSettings {
      isEnabled
      __typename
    }
    flexFieldSettings {
      isEnabled
      __typename
    }
    fuelCaptureSettings {
      isEnabled
      isVehicleIdRequired
      isGallonsRequired
      isOdometerRequired
      isMCC5542Required
      isMCC5541Required
      __typename
    }
    isConstructionType
    agaveAccountToken
    agaveSourceSystemSlug
    isAgaveClient
    erpSpeedchain
    erpConnectionId
    priorErpRealmId
    priorErpName
    erpCutoverReconciledAt
    selectedERP
    primaryAuthorizedPerson {
      firstName
      lastName
      email
      hasExtension
      birthdate
      socialSecurityNumber
      jobTitle
      percentageOwnership
      __typename
    }
    firstRunChecklist {
      connectFinancialAccount
      addAdmin
      addTeamMember
      createSpendRule
      issueCard
      createGroup
      setReimbursement
      integrateERP
      dismissWelcomePage
      isStepperComplete
      __typename
    }
    logoUrl
    isProcoreClient
    cardLockSettings {
      isEnabled
      daysToLock
      isReceiptsRequired
      isNotesRequired
      isFuelCaptureRequired
      applyImmediately
      disableAutoUnlock
      includePendingCharges
      __typename
    }
    sessionTimeoutSettings {
      isEnabled
      timeoutMinutes
      __typename
    }
    approvalWorkflowSettings {
      isEnabled
      approvalLevels
      groupApprovalsEnabled
      __typename
    }
    projectFilteringByUser {
      isEnabled
      __typename
    }
    glCodeFilteringByUser {
      isEnabled
      __typename
    }
    locationFilteringByUser {
      isEnabled
      __typename
    }
    departmentFilteringByUser {
      isEnabled
      __typename
    }
    projectVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    glCodeVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    locationVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    creditLimit
    qboPostingSettings {
      isEnabled
      __typename
    }
    qboAnyCodingPostingSettings {
      isEnabled
      __typename
    }
    erpCostCodesUseDescriptionSetting {
      isEnabled
      __typename
    }
    erpDropdownSortByCodeSetting {
      isEnabled
      __typename
    }
    erpProjectsEndpointSetting {
      selectedEndpoint
      isEnabled
      shouldDisplay
      __typename
    }
    intacctProjectsNotLicensed
    intacctTopLevelProjectPosting
    erpDepartmentLocationSetting {
      isEnabled
      departmentEnabled
      locationEnabled
      filterProjectsByEmployeeLocationEnabled
      __typename
    }
    sage300PostingSettings {
      isEnabled
      __typename
    }
    sageIntacctBillableSettings {
      isEnabled
      __typename
    }
    receiptAgentSettings {
      isEnabled
      __typename
    }
    codingColumnsConfig {
      isEnabled
      __typename
    }
    codingRequirements {
      isEnabled
      __typename
    }
    widgetVisibilityConfig {
      widgetId
      hidden
      __typename
    }
    requireProjectBeforeCostCode {
      isEnabled
      __typename
    }
    scopeEquipmentCodesToEmDepartment {
      isEnabled
      __typename
    }
    paymentTermDays
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetPaidolQueryVariables, APITypes.GetPaidolQuery>;
export const listPaidols = /* GraphQL */ `query ListPaidols(
  $filter: ModelPaidolFilterInput
  $limit: Int
  $nextToken: String
) {
  listPaidols(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPaidolsQueryVariables,
  APITypes.ListPaidolsQuery
>;
export const paidolByCronStatus = /* GraphQL */ `query PaidolByCronStatus(
  $cron_status: CronStatus!
  $sortDirection: ModelSortDirection
  $filter: ModelPaidolFilterInput
  $limit: Int
  $nextToken: String
) {
  paidolByCronStatus(
    cron_status: $cron_status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PaidolByCronStatusQueryVariables,
  APITypes.PaidolByCronStatusQuery
>;
export const searchPaidols = /* GraphQL */ `query SearchPaidols(
  $filter: SearchablePaidolFilterInput
  $sort: [SearchablePaidolSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchablePaidolAggregationInput]
) {
  searchPaidols(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchPaidolsQueryVariables,
  APITypes.SearchPaidolsQuery
>;
export const getPaidolAgaveSync = /* GraphQL */ `query GetPaidolAgaveSync($id: ID!) {
  getPaidolAgaveSync(id: $id) {
    id
    paidolId
    authPaidolId
    inProgress
    error
    lastRunStart
    lastRunEnd
    taskArn
    syncEntityFilter
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPaidolAgaveSyncQueryVariables,
  APITypes.GetPaidolAgaveSyncQuery
>;
export const listPaidolAgaveSyncs = /* GraphQL */ `query ListPaidolAgaveSyncs(
  $filter: ModelPaidolAgaveSyncFilterInput
  $limit: Int
  $nextToken: String
) {
  listPaidolAgaveSyncs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      paidolId
      authPaidolId
      inProgress
      error
      lastRunStart
      lastRunEnd
      taskArn
      syncEntityFilter
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPaidolAgaveSyncsQueryVariables,
  APITypes.ListPaidolAgaveSyncsQuery
>;
export const paidolAgaveSyncByPaidolId = /* GraphQL */ `query PaidolAgaveSyncByPaidolId(
  $paidolId: ID!
  $lastRunStart: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPaidolAgaveSyncFilterInput
  $limit: Int
  $nextToken: String
) {
  paidolAgaveSyncByPaidolId(
    paidolId: $paidolId
    lastRunStart: $lastRunStart
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      inProgress
      error
      lastRunStart
      lastRunEnd
      taskArn
      syncEntityFilter
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PaidolAgaveSyncByPaidolIdQueryVariables,
  APITypes.PaidolAgaveSyncByPaidolIdQuery
>;
export const getPaymentFileQueue = /* GraphQL */ `query GetPaymentFileQueue($id: ID!) {
  getPaymentFileQueue(id: $id) {
    id
    user_id
    user {
      id
      username
      email
      first_name
      middle_name
      last_name
      suffix
      picture
      is_speedster
      birthdate
      address
      phone_number
      phone_extension
      password_updated_at
      finicityCustomerId
      dwollaCustomerId
      is_support
      deletedAt
      createdAt
      updatedAt
      __typename
    }
    paidol_id
    paidol {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    key
    status
    processed_at
    error_messages
    num_vendors
    num_payments
    num_success
    num_failed
    total {
      value
      currency
      __typename
    }
    createdAt
    filename
    supplier_vendor_paidol_ids
    referenced_vendors
    invoice_ids
    invoice_spx_ids
    priority_status
    priority_file_id
    priority_process_on
    priority_response
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPaymentFileQueueQueryVariables,
  APITypes.GetPaymentFileQueueQuery
>;
export const listPaymentFileQueues = /* GraphQL */ `query ListPaymentFileQueues(
  $filter: ModelPaymentFileQueueFilterInput
  $limit: Int
  $nextToken: String
) {
  listPaymentFileQueues(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      user_id
      paidol_id
      key
      status
      processed_at
      error_messages
      num_vendors
      num_payments
      num_success
      num_failed
      createdAt
      filename
      supplier_vendor_paidol_ids
      referenced_vendors
      invoice_ids
      invoice_spx_ids
      priority_status
      priority_file_id
      priority_process_on
      priority_response
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPaymentFileQueuesQueryVariables,
  APITypes.ListPaymentFileQueuesQuery
>;
export const paymentFileQueuesByPaidol = /* GraphQL */ `query PaymentFileQueuesByPaidol(
  $paidol_id: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPaymentFileQueueFilterInput
  $limit: Int
  $nextToken: String
) {
  paymentFileQueuesByPaidol(
    paidol_id: $paidol_id
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      user_id
      paidol_id
      key
      status
      processed_at
      error_messages
      num_vendors
      num_payments
      num_success
      num_failed
      createdAt
      filename
      supplier_vendor_paidol_ids
      referenced_vendors
      invoice_ids
      invoice_spx_ids
      priority_status
      priority_file_id
      priority_process_on
      priority_response
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PaymentFileQueuesByPaidolQueryVariables,
  APITypes.PaymentFileQueuesByPaidolQuery
>;
export const paymentFileQueuesByStatus = /* GraphQL */ `query PaymentFileQueuesByStatus(
  $status: PaymentFileQueueStatusEnum!
  $sortDirection: ModelSortDirection
  $filter: ModelPaymentFileQueueFilterInput
  $limit: Int
  $nextToken: String
) {
  paymentFileQueuesByStatus(
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      user_id
      paidol_id
      key
      status
      processed_at
      error_messages
      num_vendors
      num_payments
      num_success
      num_failed
      createdAt
      filename
      supplier_vendor_paidol_ids
      referenced_vendors
      invoice_ids
      invoice_spx_ids
      priority_status
      priority_file_id
      priority_process_on
      priority_response
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PaymentFileQueuesByStatusQueryVariables,
  APITypes.PaymentFileQueuesByStatusQuery
>;
export const searchPaymentFileQueues = /* GraphQL */ `query SearchPaymentFileQueues(
  $filter: SearchablePaymentFileQueueFilterInput
  $sort: [SearchablePaymentFileQueueSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchablePaymentFileQueueAggregationInput]
) {
  searchPaymentFileQueues(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      user_id
      paidol_id
      key
      status
      processed_at
      error_messages
      num_vendors
      num_payments
      num_success
      num_failed
      createdAt
      filename
      supplier_vendor_paidol_ids
      referenced_vendors
      invoice_ids
      invoice_spx_ids
      priority_status
      priority_file_id
      priority_process_on
      priority_response
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchPaymentFileQueuesQueryVariables,
  APITypes.SearchPaymentFileQueuesQuery
>;
export const getPaidolVendor = /* GraphQL */ `query GetPaidolVendor($id: ID!) {
  getPaidolVendor(id: $id) {
    id
    user_vendor_id
    is_migration
    paidol_id
    vendor {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    vendor_paidol_id
    priority_active
    payment_terms
    priority_account_balance
    contact_name
    priority_billing_code
    priority_repeate_code
    priority_group_code
    email_addresses
    priority_document_delivery
    priority_regular_inv
    priority_summary_inv
    foreign_name
    remarks
    box_1099
    form_code_1099
    remark_1
    priority_response
    cron_status
    priority_status
    priority_supplier_id
    virtual_card_email
    bankAccounts {
      bankId
      accountType
      accountNumber
      routingNumber
      defaults
      isActive
      __typename
    }
    achEnabled
    virtualCardEnabled
    checkIssuingEnabled
    checkIssuingPayableTo
    checkIssuingStreet
    checkIssuingCity
    checkIssuingState
    checkIssuingCountry
    checkIssuingPostalCode
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPaidolVendorQueryVariables,
  APITypes.GetPaidolVendorQuery
>;
export const listPaidolVendors = /* GraphQL */ `query ListPaidolVendors(
  $filter: ModelPaidolVendorFilterInput
  $limit: Int
  $nextToken: String
) {
  listPaidolVendors(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      user_vendor_id
      is_migration
      paidol_id
      vendor_paidol_id
      priority_active
      payment_terms
      priority_account_balance
      contact_name
      priority_billing_code
      priority_repeate_code
      priority_group_code
      email_addresses
      priority_document_delivery
      priority_regular_inv
      priority_summary_inv
      foreign_name
      remarks
      box_1099
      form_code_1099
      remark_1
      priority_response
      cron_status
      priority_status
      priority_supplier_id
      virtual_card_email
      achEnabled
      virtualCardEnabled
      checkIssuingEnabled
      checkIssuingPayableTo
      checkIssuingStreet
      checkIssuingCity
      checkIssuingState
      checkIssuingCountry
      checkIssuingPostalCode
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPaidolVendorsQueryVariables,
  APITypes.ListPaidolVendorsQuery
>;
export const vendorByPaidol = /* GraphQL */ `query VendorByPaidol(
  $paidol_id: ID!
  $user_vendor_id: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPaidolVendorFilterInput
  $limit: Int
  $nextToken: String
) {
  vendorByPaidol(
    paidol_id: $paidol_id
    user_vendor_id: $user_vendor_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      user_vendor_id
      is_migration
      paidol_id
      vendor_paidol_id
      priority_active
      payment_terms
      priority_account_balance
      contact_name
      priority_billing_code
      priority_repeate_code
      priority_group_code
      email_addresses
      priority_document_delivery
      priority_regular_inv
      priority_summary_inv
      foreign_name
      remarks
      box_1099
      form_code_1099
      remark_1
      priority_response
      cron_status
      priority_status
      priority_supplier_id
      virtual_card_email
      achEnabled
      virtualCardEnabled
      checkIssuingEnabled
      checkIssuingPayableTo
      checkIssuingStreet
      checkIssuingCity
      checkIssuingState
      checkIssuingCountry
      checkIssuingPostalCode
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.VendorByPaidolQueryVariables,
  APITypes.VendorByPaidolQuery
>;
export const paidolVendorsByCronStatus = /* GraphQL */ `query PaidolVendorsByCronStatus(
  $cron_status: CronStatus!
  $sortDirection: ModelSortDirection
  $filter: ModelPaidolVendorFilterInput
  $limit: Int
  $nextToken: String
) {
  paidolVendorsByCronStatus(
    cron_status: $cron_status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      user_vendor_id
      is_migration
      paidol_id
      vendor_paidol_id
      priority_active
      payment_terms
      priority_account_balance
      contact_name
      priority_billing_code
      priority_repeate_code
      priority_group_code
      email_addresses
      priority_document_delivery
      priority_regular_inv
      priority_summary_inv
      foreign_name
      remarks
      box_1099
      form_code_1099
      remark_1
      priority_response
      cron_status
      priority_status
      priority_supplier_id
      virtual_card_email
      achEnabled
      virtualCardEnabled
      checkIssuingEnabled
      checkIssuingPayableTo
      checkIssuingStreet
      checkIssuingCity
      checkIssuingState
      checkIssuingCountry
      checkIssuingPostalCode
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PaidolVendorsByCronStatusQueryVariables,
  APITypes.PaidolVendorsByCronStatusQuery
>;
export const searchPaidolVendors = /* GraphQL */ `query SearchPaidolVendors(
  $filter: SearchablePaidolVendorFilterInput
  $sort: [SearchablePaidolVendorSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchablePaidolVendorAggregationInput]
) {
  searchPaidolVendors(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      user_vendor_id
      is_migration
      paidol_id
      vendor_paidol_id
      priority_active
      payment_terms
      priority_account_balance
      contact_name
      priority_billing_code
      priority_repeate_code
      priority_group_code
      email_addresses
      priority_document_delivery
      priority_regular_inv
      priority_summary_inv
      foreign_name
      remarks
      box_1099
      form_code_1099
      remark_1
      priority_response
      cron_status
      priority_status
      priority_supplier_id
      virtual_card_email
      achEnabled
      virtualCardEnabled
      checkIssuingEnabled
      checkIssuingPayableTo
      checkIssuingStreet
      checkIssuingCity
      checkIssuingState
      checkIssuingCountry
      checkIssuingPostalCode
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchPaidolVendorsQueryVariables,
  APITypes.SearchPaidolVendorsQuery
>;
export const getInvoice = /* GraphQL */ `query GetInvoice($id: ID!) {
  getInvoice(id: $id) {
    id
    id_base58
    id_base58_short
    payment_file_queue_id
    payment_file {
      id
      user_id
      paidol_id
      key
      status
      processed_at
      error_messages
      num_vendors
      num_payments
      num_success
      num_failed
      createdAt
      filename
      supplier_vendor_paidol_ids
      referenced_vendors
      invoice_ids
      invoice_spx_ids
      priority_status
      priority_file_id
      priority_process_on
      priority_response
      updatedAt
      __typename
    }
    buyer_paidol_id
    paidol_vendor_id
    paidol_vendor {
      id
      user_vendor_id
      is_migration
      paidol_id
      vendor_paidol_id
      priority_active
      payment_terms
      priority_account_balance
      contact_name
      priority_billing_code
      priority_repeate_code
      priority_group_code
      email_addresses
      priority_document_delivery
      priority_regular_inv
      priority_summary_inv
      foreign_name
      remarks
      box_1099
      form_code_1099
      remark_1
      priority_response
      cron_status
      priority_status
      priority_supplier_id
      virtual_card_email
      achEnabled
      virtualCardEnabled
      checkIssuingEnabled
      checkIssuingPayableTo
      checkIssuingStreet
      checkIssuingCity
      checkIssuingState
      checkIssuingCountry
      checkIssuingPostalCode
      createdAt
      updatedAt
      __typename
    }
    supplier_paidol_id
    supplier_paidol {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    user_invoice_id
    date
    balance_due {
      value
      currency
      __typename
    }
    createdAt
    updatedAt
    transaction_id
    priority_payment_id
    priority_payment_status
    priority_payment_type
    priority_payment_date
    priority_payment_auth_message
    priority_response
    status
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInvoiceQueryVariables,
  APITypes.GetInvoiceQuery
>;
export const listInvoices = /* GraphQL */ `query ListInvoices(
  $filter: ModelInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  listInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      id_base58
      id_base58_short
      payment_file_queue_id
      buyer_paidol_id
      paidol_vendor_id
      supplier_paidol_id
      user_invoice_id
      date
      createdAt
      updatedAt
      transaction_id
      priority_payment_id
      priority_payment_status
      priority_payment_type
      priority_payment_date
      priority_payment_auth_message
      priority_response
      status
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvoicesQueryVariables,
  APITypes.ListInvoicesQuery
>;
export const invoicesByPaymentFileQueue = /* GraphQL */ `query InvoicesByPaymentFileQueue(
  $payment_file_queue_id: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  invoicesByPaymentFileQueue(
    payment_file_queue_id: $payment_file_queue_id
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      id_base58
      id_base58_short
      payment_file_queue_id
      buyer_paidol_id
      paidol_vendor_id
      supplier_paidol_id
      user_invoice_id
      date
      createdAt
      updatedAt
      transaction_id
      priority_payment_id
      priority_payment_status
      priority_payment_type
      priority_payment_date
      priority_payment_auth_message
      priority_response
      status
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.InvoicesByPaymentFileQueueQueryVariables,
  APITypes.InvoicesByPaymentFileQueueQuery
>;
export const invoicesByBuyerPaidol = /* GraphQL */ `query InvoicesByBuyerPaidol(
  $buyer_paidol_id: ID!
  $date: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  invoicesByBuyerPaidol(
    buyer_paidol_id: $buyer_paidol_id
    date: $date
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      id_base58
      id_base58_short
      payment_file_queue_id
      buyer_paidol_id
      paidol_vendor_id
      supplier_paidol_id
      user_invoice_id
      date
      createdAt
      updatedAt
      transaction_id
      priority_payment_id
      priority_payment_status
      priority_payment_type
      priority_payment_date
      priority_payment_auth_message
      priority_response
      status
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.InvoicesByBuyerPaidolQueryVariables,
  APITypes.InvoicesByBuyerPaidolQuery
>;
export const invoicesByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceId = /* GraphQL */ `query InvoicesByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceId(
  $buyer_paidol_id: ID!
  $user_invoice_idSupplier_paidol_id: ModelInvoiceByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceIdCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  invoicesByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceId(
    buyer_paidol_id: $buyer_paidol_id
    user_invoice_idSupplier_paidol_id: $user_invoice_idSupplier_paidol_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      id_base58
      id_base58_short
      payment_file_queue_id
      buyer_paidol_id
      paidol_vendor_id
      supplier_paidol_id
      user_invoice_id
      date
      createdAt
      updatedAt
      transaction_id
      priority_payment_id
      priority_payment_status
      priority_payment_type
      priority_payment_date
      priority_payment_auth_message
      priority_response
      status
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.InvoicesByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceIdQueryVariables,
  APITypes.InvoicesByBuyerPaidolIdAndSupplierPaidolIdAndUserInvoiceIdQuery
>;
export const invoicesByBuyerPaidolIdAndUpdatedAt = /* GraphQL */ `query InvoicesByBuyerPaidolIdAndUpdatedAt(
  $buyer_paidol_id: ID!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  invoicesByBuyerPaidolIdAndUpdatedAt(
    buyer_paidol_id: $buyer_paidol_id
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      id_base58
      id_base58_short
      payment_file_queue_id
      buyer_paidol_id
      paidol_vendor_id
      supplier_paidol_id
      user_invoice_id
      date
      createdAt
      updatedAt
      transaction_id
      priority_payment_id
      priority_payment_status
      priority_payment_type
      priority_payment_date
      priority_payment_auth_message
      priority_response
      status
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.InvoicesByBuyerPaidolIdAndUpdatedAtQueryVariables,
  APITypes.InvoicesByBuyerPaidolIdAndUpdatedAtQuery
>;
export const invoicesByUserInvoiceId = /* GraphQL */ `query InvoicesByUserInvoiceId(
  $user_invoice_id: String!
  $buyer_paidol_idSupplier_paidol_id: ModelInvoiceByUserInvoiceIdCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  invoicesByUserInvoiceId(
    user_invoice_id: $user_invoice_id
    buyer_paidol_idSupplier_paidol_id: $buyer_paidol_idSupplier_paidol_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      id_base58
      id_base58_short
      payment_file_queue_id
      buyer_paidol_id
      paidol_vendor_id
      supplier_paidol_id
      user_invoice_id
      date
      createdAt
      updatedAt
      transaction_id
      priority_payment_id
      priority_payment_status
      priority_payment_type
      priority_payment_date
      priority_payment_auth_message
      priority_response
      status
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.InvoicesByUserInvoiceIdQueryVariables,
  APITypes.InvoicesByUserInvoiceIdQuery
>;
export const invoicesByPriorityPaymentId = /* GraphQL */ `query InvoicesByPriorityPaymentId(
  $priority_payment_id: String!
  $sortDirection: ModelSortDirection
  $filter: ModelInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  invoicesByPriorityPaymentId(
    priority_payment_id: $priority_payment_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      id_base58
      id_base58_short
      payment_file_queue_id
      buyer_paidol_id
      paidol_vendor_id
      supplier_paidol_id
      user_invoice_id
      date
      createdAt
      updatedAt
      transaction_id
      priority_payment_id
      priority_payment_status
      priority_payment_type
      priority_payment_date
      priority_payment_auth_message
      priority_response
      status
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.InvoicesByPriorityPaymentIdQueryVariables,
  APITypes.InvoicesByPriorityPaymentIdQuery
>;
export const invoicesByPriorityPaymentStatus = /* GraphQL */ `query InvoicesByPriorityPaymentStatus(
  $priority_payment_status: String!
  $sortDirection: ModelSortDirection
  $filter: ModelInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  invoicesByPriorityPaymentStatus(
    priority_payment_status: $priority_payment_status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      id_base58
      id_base58_short
      payment_file_queue_id
      buyer_paidol_id
      paidol_vendor_id
      supplier_paidol_id
      user_invoice_id
      date
      createdAt
      updatedAt
      transaction_id
      priority_payment_id
      priority_payment_status
      priority_payment_type
      priority_payment_date
      priority_payment_auth_message
      priority_response
      status
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.InvoicesByPriorityPaymentStatusQueryVariables,
  APITypes.InvoicesByPriorityPaymentStatusQuery
>;
export const getSupplierFileQueue = /* GraphQL */ `query GetSupplierFileQueue($id: ID!) {
  getSupplierFileQueue(id: $id) {
    id
    user_id
    user {
      id
      username
      email
      first_name
      middle_name
      last_name
      suffix
      picture
      is_speedster
      birthdate
      address
      phone_number
      phone_extension
      password_updated_at
      finicityCustomerId
      dwollaCustomerId
      is_support
      deletedAt
      createdAt
      updatedAt
      __typename
    }
    paidol_id
    paidol {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    key
    status
    processed_at
    error_messages
    num_vendors
    num_success
    num_failed
    createdAt
    is_migration
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSupplierFileQueueQueryVariables,
  APITypes.GetSupplierFileQueueQuery
>;
export const listSupplierFileQueues = /* GraphQL */ `query ListSupplierFileQueues(
  $filter: ModelSupplierFileQueueFilterInput
  $limit: Int
  $nextToken: String
) {
  listSupplierFileQueues(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      user_id
      paidol_id
      key
      status
      processed_at
      error_messages
      num_vendors
      num_success
      num_failed
      createdAt
      is_migration
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSupplierFileQueuesQueryVariables,
  APITypes.ListSupplierFileQueuesQuery
>;
export const supplierFileQueuesByPaidol = /* GraphQL */ `query SupplierFileQueuesByPaidol(
  $paidol_id: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSupplierFileQueueFilterInput
  $limit: Int
  $nextToken: String
) {
  supplierFileQueuesByPaidol(
    paidol_id: $paidol_id
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      user_id
      paidol_id
      key
      status
      processed_at
      error_messages
      num_vendors
      num_success
      num_failed
      createdAt
      is_migration
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SupplierFileQueuesByPaidolQueryVariables,
  APITypes.SupplierFileQueuesByPaidolQuery
>;
export const getPaymentStatusDownload = /* GraphQL */ `query GetPaymentStatusDownload($id: ID!) {
  getPaymentStatusDownload(id: $id) {
    id
    user_id
    paidol_id
    start_date
    end_date
    s3_key
    cron_status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPaymentStatusDownloadQueryVariables,
  APITypes.GetPaymentStatusDownloadQuery
>;
export const listPaymentStatusDownloads = /* GraphQL */ `query ListPaymentStatusDownloads(
  $filter: ModelPaymentStatusDownloadFilterInput
  $limit: Int
  $nextToken: String
) {
  listPaymentStatusDownloads(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      user_id
      paidol_id
      start_date
      end_date
      s3_key
      cron_status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPaymentStatusDownloadsQueryVariables,
  APITypes.ListPaymentStatusDownloadsQuery
>;
export const paymentStatusDownloadByPaidolId = /* GraphQL */ `query PaymentStatusDownloadByPaidolId(
  $paidol_id: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPaymentStatusDownloadFilterInput
  $limit: Int
  $nextToken: String
) {
  paymentStatusDownloadByPaidolId(
    paidol_id: $paidol_id
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      user_id
      paidol_id
      start_date
      end_date
      s3_key
      cron_status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PaymentStatusDownloadByPaidolIdQueryVariables,
  APITypes.PaymentStatusDownloadByPaidolIdQuery
>;
export const getPaidolHighnoteIntegration = /* GraphQL */ `query GetPaidolHighnoteIntegration($id: ID!) {
  getPaidolHighnoteIntegration(id: $id) {
    id
    paidolId
    userId
    legalBusinessName
    businessAccountHolderId
    primaryAuthorizedPersonId
    financialAccountId
    externalFinancialBankAccountId
    hasInitialFunding
    accountHolderCardProductApplicationId
    isApplicationAccepted
    isDisconnected
    highnoteProductId
    highnoteProduct {
      id
      type
      isActive
      createdAt
      updatedAt
      __typename
    }
    finicityCustomerId
    dwollaCustomerId
    cardProfileId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPaidolHighnoteIntegrationQueryVariables,
  APITypes.GetPaidolHighnoteIntegrationQuery
>;
export const listPaidolHighnoteIntegrations = /* GraphQL */ `query ListPaidolHighnoteIntegrations(
  $filter: ModelPaidolHighnoteIntegrationFilterInput
  $limit: Int
  $nextToken: String
) {
  listPaidolHighnoteIntegrations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      userId
      legalBusinessName
      businessAccountHolderId
      primaryAuthorizedPersonId
      financialAccountId
      externalFinancialBankAccountId
      hasInitialFunding
      accountHolderCardProductApplicationId
      isApplicationAccepted
      isDisconnected
      highnoteProductId
      finicityCustomerId
      dwollaCustomerId
      cardProfileId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPaidolHighnoteIntegrationsQueryVariables,
  APITypes.ListPaidolHighnoteIntegrationsQuery
>;
export const listPaidolHighnoteIntegrationByPaidolId = /* GraphQL */ `query ListPaidolHighnoteIntegrationByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelPaidolHighnoteIntegrationFilterInput
  $limit: Int
  $nextToken: String
) {
  listPaidolHighnoteIntegrationByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      userId
      legalBusinessName
      businessAccountHolderId
      primaryAuthorizedPersonId
      financialAccountId
      externalFinancialBankAccountId
      hasInitialFunding
      accountHolderCardProductApplicationId
      isApplicationAccepted
      isDisconnected
      highnoteProductId
      finicityCustomerId
      dwollaCustomerId
      cardProfileId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPaidolHighnoteIntegrationByPaidolIdQueryVariables,
  APITypes.ListPaidolHighnoteIntegrationByPaidolIdQuery
>;
export const getHighnotePaymentCard = /* GraphQL */ `query GetHighnotePaymentCard($paymentCardId: ID!) {
  getHighnotePaymentCard(paymentCardId: $paymentCardId) {
    paymentCardId
    paidolId
    authPaidolId
    paidolUsers {
      nextToken
      __typename
    }
    name
    cardGroupId
    group {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    status
    bin
    last4
    network
    formFactor
    expirationDate
    budget {
      __typename
    }
    hasPin
    procoreEmployee {
      id
      name
      email_address
      __typename
    }
    cardholderId
    cardholder {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    cardholderName
    isAdminLocked
    lastActionByRole
    lastActionByPaidolUserId
    lastActionByName
    lastActionByEmail
    lastActionAt
    merchantSpendRuleId
    isAuthorizedUserCard
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetHighnotePaymentCardQueryVariables,
  APITypes.GetHighnotePaymentCardQuery
>;
export const listHighnotePaymentCards = /* GraphQL */ `query ListHighnotePaymentCards(
  $paymentCardId: ID
  $filter: ModelHighnotePaymentCardFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listHighnotePaymentCards(
    paymentCardId: $paymentCardId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      paymentCardId
      paidolId
      authPaidolId
      name
      cardGroupId
      status
      bin
      last4
      network
      formFactor
      expirationDate
      hasPin
      cardholderId
      cardholderName
      isAdminLocked
      lastActionByRole
      lastActionByPaidolUserId
      lastActionByName
      lastActionByEmail
      lastActionAt
      merchantSpendRuleId
      isAuthorizedUserCard
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHighnotePaymentCardsQueryVariables,
  APITypes.ListHighnotePaymentCardsQuery
>;
export const listHighnotePaymentCardsByPaidolId = /* GraphQL */ `query ListHighnotePaymentCardsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelHighnotePaymentCardFilterInput
  $limit: Int
  $nextToken: String
) {
  listHighnotePaymentCardsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      paymentCardId
      paidolId
      authPaidolId
      name
      cardGroupId
      status
      bin
      last4
      network
      formFactor
      expirationDate
      hasPin
      cardholderId
      cardholderName
      isAdminLocked
      lastActionByRole
      lastActionByPaidolUserId
      lastActionByName
      lastActionByEmail
      lastActionAt
      merchantSpendRuleId
      isAuthorizedUserCard
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHighnotePaymentCardsByPaidolIdQueryVariables,
  APITypes.ListHighnotePaymentCardsByPaidolIdQuery
>;
export const searchHighnotePaymentCards = /* GraphQL */ `query SearchHighnotePaymentCards(
  $filter: SearchableHighnotePaymentCardFilterInput
  $sort: [SearchableHighnotePaymentCardSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableHighnotePaymentCardAggregationInput]
) {
  searchHighnotePaymentCards(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      paymentCardId
      paidolId
      authPaidolId
      name
      cardGroupId
      status
      bin
      last4
      network
      formFactor
      expirationDate
      hasPin
      cardholderId
      cardholderName
      isAdminLocked
      lastActionByRole
      lastActionByPaidolUserId
      lastActionByName
      lastActionByEmail
      lastActionAt
      merchantSpendRuleId
      isAuthorizedUserCard
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchHighnotePaymentCardsQueryVariables,
  APITypes.SearchHighnotePaymentCardsQuery
>;
export const getSpendRules = /* GraphQL */ `query GetSpendRules($spendRuleId: ID!) {
  getSpendRules(spendRuleId: $spendRuleId) {
    spendRuleId
    paidolId
    authPaidolId
    name
    maximumAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    merchantCategoryAllowed
    merchantCategoryBlocked
    merchantCountryAllowed
    merchantCountryBlocked
    streetAddressAllowed
    streetAddressBlocked
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSpendRulesQueryVariables,
  APITypes.GetSpendRulesQuery
>;
export const listSpendRules = /* GraphQL */ `query ListSpendRules(
  $spendRuleId: ID
  $filter: ModelSpendRulesFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSpendRules(
    spendRuleId: $spendRuleId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      spendRuleId
      paidolId
      authPaidolId
      name
      merchantCategoryAllowed
      merchantCategoryBlocked
      merchantCountryAllowed
      merchantCountryBlocked
      streetAddressAllowed
      streetAddressBlocked
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSpendRulesQueryVariables,
  APITypes.ListSpendRulesQuery
>;
export const listSpendRulesByPaidolId = /* GraphQL */ `query ListSpendRulesByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSpendRulesFilterInput
  $limit: Int
  $nextToken: String
) {
  listSpendRulesByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      spendRuleId
      paidolId
      authPaidolId
      name
      merchantCategoryAllowed
      merchantCategoryBlocked
      merchantCountryAllowed
      merchantCountryBlocked
      streetAddressAllowed
      streetAddressBlocked
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSpendRulesByPaidolIdQueryVariables,
  APITypes.ListSpendRulesByPaidolIdQuery
>;
export const getVelocityRules = /* GraphQL */ `query GetVelocityRules($velocityRuleId: ID!) {
  getVelocityRules(velocityRuleId: $velocityRuleId) {
    velocityRuleId
    paidolId
    authPaidolId
    name
    maximumAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    cumulativeRuleId
    monthlyLimitResetTimestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetVelocityRulesQueryVariables,
  APITypes.GetVelocityRulesQuery
>;
export const listVelocityRules = /* GraphQL */ `query ListVelocityRules(
  $velocityRuleId: ID
  $filter: ModelVelocityRulesFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listVelocityRules(
    velocityRuleId: $velocityRuleId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      velocityRuleId
      paidolId
      authPaidolId
      name
      cumulativeRuleId
      monthlyLimitResetTimestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVelocityRulesQueryVariables,
  APITypes.ListVelocityRulesQuery
>;
export const listVelocityRulesByPaidolId = /* GraphQL */ `query ListVelocityRulesByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelVelocityRulesFilterInput
  $limit: Int
  $nextToken: String
) {
  listVelocityRulesByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      velocityRuleId
      paidolId
      authPaidolId
      name
      cumulativeRuleId
      monthlyLimitResetTimestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVelocityRulesByPaidolIdQueryVariables,
  APITypes.ListVelocityRulesByPaidolIdQuery
>;
export const getBudgetSpendByMonth = /* GraphQL */ `query GetBudgetSpendByMonth($paidolId: ID!, $yearAndMonth: String!) {
  getBudgetSpendByMonth(paidolId: $paidolId, yearAndMonth: $yearAndMonth) {
    paidolId
    authPaidolId
    yearAndMonth
    amount
    transactionCount
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBudgetSpendByMonthQueryVariables,
  APITypes.GetBudgetSpendByMonthQuery
>;
export const listBudgetSpendByMonths = /* GraphQL */ `query ListBudgetSpendByMonths(
  $paidolId: ID
  $yearAndMonth: ModelStringKeyConditionInput
  $filter: ModelBudgetSpendByMonthFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listBudgetSpendByMonths(
    paidolId: $paidolId
    yearAndMonth: $yearAndMonth
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      paidolId
      authPaidolId
      yearAndMonth
      amount
      transactionCount
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBudgetSpendByMonthsQueryVariables,
  APITypes.ListBudgetSpendByMonthsQuery
>;
export const getBudgetSpendByMonthAndMerchant = /* GraphQL */ `query GetBudgetSpendByMonthAndMerchant(
  $paidolId: ID!
  $yearAndMonth: String!
  $merchantName: String!
) {
  getBudgetSpendByMonthAndMerchant(
    paidolId: $paidolId
    yearAndMonth: $yearAndMonth
    merchantName: $merchantName
  ) {
    paidolId
    authPaidolId
    yearAndMonth
    merchantName
    amount
    transactionCount
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBudgetSpendByMonthAndMerchantQueryVariables,
  APITypes.GetBudgetSpendByMonthAndMerchantQuery
>;
export const listBudgetSpendByMonthAndMerchants = /* GraphQL */ `query ListBudgetSpendByMonthAndMerchants(
  $paidolId: ID
  $yearAndMonthMerchantName: ModelBudgetSpendByMonthAndMerchantPrimaryCompositeKeyConditionInput
  $filter: ModelBudgetSpendByMonthAndMerchantFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listBudgetSpendByMonthAndMerchants(
    paidolId: $paidolId
    yearAndMonthMerchantName: $yearAndMonthMerchantName
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      paidolId
      authPaidolId
      yearAndMonth
      merchantName
      amount
      transactionCount
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBudgetSpendByMonthAndMerchantsQueryVariables,
  APITypes.ListBudgetSpendByMonthAndMerchantsQuery
>;
export const listBudgetSpendByMonthAndMerchantByAmount = /* GraphQL */ `query ListBudgetSpendByMonthAndMerchantByAmount(
  $paidolId: ID!
  $yearAndMonthAmount: ModelBudgetSpendByMonthAndMerchantByYearAndMonthAndAmountCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelBudgetSpendByMonthAndMerchantFilterInput
  $limit: Int
  $nextToken: String
) {
  listBudgetSpendByMonthAndMerchantByAmount(
    paidolId: $paidolId
    yearAndMonthAmount: $yearAndMonthAmount
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      paidolId
      authPaidolId
      yearAndMonth
      merchantName
      amount
      transactionCount
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBudgetSpendByMonthAndMerchantByAmountQueryVariables,
  APITypes.ListBudgetSpendByMonthAndMerchantByAmountQuery
>;
export const getBudgetSpendByMonthAndCategory = /* GraphQL */ `query GetBudgetSpendByMonthAndCategory(
  $paidolId: ID!
  $yearAndMonth: String!
  $category: String!
) {
  getBudgetSpendByMonthAndCategory(
    paidolId: $paidolId
    yearAndMonth: $yearAndMonth
    category: $category
  ) {
    paidolId
    authPaidolId
    yearAndMonth
    category
    amount
    transactionCount
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBudgetSpendByMonthAndCategoryQueryVariables,
  APITypes.GetBudgetSpendByMonthAndCategoryQuery
>;
export const listBudgetSpendByMonthAndCategories = /* GraphQL */ `query ListBudgetSpendByMonthAndCategories(
  $paidolId: ID
  $yearAndMonthCategory: ModelBudgetSpendByMonthAndCategoryPrimaryCompositeKeyConditionInput
  $filter: ModelBudgetSpendByMonthAndCategoryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listBudgetSpendByMonthAndCategories(
    paidolId: $paidolId
    yearAndMonthCategory: $yearAndMonthCategory
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      paidolId
      authPaidolId
      yearAndMonth
      category
      amount
      transactionCount
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBudgetSpendByMonthAndCategoriesQueryVariables,
  APITypes.ListBudgetSpendByMonthAndCategoriesQuery
>;
export const listBudgetSpendByMonthAndCategoryByAmount = /* GraphQL */ `query ListBudgetSpendByMonthAndCategoryByAmount(
  $paidolId: ID!
  $yearAndMonthAmount: ModelBudgetSpendByMonthAndCategoryByYearAndMonthAndAmountCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelBudgetSpendByMonthAndCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listBudgetSpendByMonthAndCategoryByAmount(
    paidolId: $paidolId
    yearAndMonthAmount: $yearAndMonthAmount
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      paidolId
      authPaidolId
      yearAndMonth
      category
      amount
      transactionCount
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBudgetSpendByMonthAndCategoryByAmountQueryVariables,
  APITypes.ListBudgetSpendByMonthAndCategoryByAmountQuery
>;
export const getBudgetSpendByMonthAndPaymentCard = /* GraphQL */ `query GetBudgetSpendByMonthAndPaymentCard(
  $paidolId: ID!
  $yearAndMonth: String!
  $paymentCardId: ID!
) {
  getBudgetSpendByMonthAndPaymentCard(
    paidolId: $paidolId
    yearAndMonth: $yearAndMonth
    paymentCardId: $paymentCardId
  ) {
    paidolId
    authPaidolId
    yearAndMonth
    paymentCardId
    amount
    transactionCount
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBudgetSpendByMonthAndPaymentCardQueryVariables,
  APITypes.GetBudgetSpendByMonthAndPaymentCardQuery
>;
export const listBudgetSpendByMonthAndPaymentCards = /* GraphQL */ `query ListBudgetSpendByMonthAndPaymentCards(
  $paidolId: ID
  $yearAndMonthPaymentCardId: ModelBudgetSpendByMonthAndPaymentCardPrimaryCompositeKeyConditionInput
  $filter: ModelBudgetSpendByMonthAndPaymentCardFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listBudgetSpendByMonthAndPaymentCards(
    paidolId: $paidolId
    yearAndMonthPaymentCardId: $yearAndMonthPaymentCardId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      paidolId
      authPaidolId
      yearAndMonth
      paymentCardId
      amount
      transactionCount
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBudgetSpendByMonthAndPaymentCardsQueryVariables,
  APITypes.ListBudgetSpendByMonthAndPaymentCardsQuery
>;
export const getBudgetSpendByMonthAndJobCodeId = /* GraphQL */ `query GetBudgetSpendByMonthAndJobCodeId(
  $paidolId: ID!
  $yearAndMonth: String!
  $jobCodeId: ID!
) {
  getBudgetSpendByMonthAndJobCodeId(
    paidolId: $paidolId
    yearAndMonth: $yearAndMonth
    jobCodeId: $jobCodeId
  ) {
    paidolId
    authPaidolId
    yearAndMonth
    jobCodeId
    amount
    transactionCount
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBudgetSpendByMonthAndJobCodeIdQueryVariables,
  APITypes.GetBudgetSpendByMonthAndJobCodeIdQuery
>;
export const listBudgetSpendByMonthAndJobCodeIds = /* GraphQL */ `query ListBudgetSpendByMonthAndJobCodeIds(
  $paidolId: ID
  $yearAndMonthJobCodeId: ModelBudgetSpendByMonthAndJobCodeIdPrimaryCompositeKeyConditionInput
  $filter: ModelBudgetSpendByMonthAndJobCodeIdFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listBudgetSpendByMonthAndJobCodeIds(
    paidolId: $paidolId
    yearAndMonthJobCodeId: $yearAndMonthJobCodeId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      paidolId
      authPaidolId
      yearAndMonth
      jobCodeId
      amount
      transactionCount
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBudgetSpendByMonthAndJobCodeIdsQueryVariables,
  APITypes.ListBudgetSpendByMonthAndJobCodeIdsQuery
>;
export const listBudgetSpendByMonthAndJobCodeIdByAmount = /* GraphQL */ `query ListBudgetSpendByMonthAndJobCodeIdByAmount(
  $paidolId: ID!
  $yearAndMonthAmount: ModelBudgetSpendByMonthAndJobCodeIdByYearAndMonthAndJobCodeIdCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelBudgetSpendByMonthAndJobCodeIdFilterInput
  $limit: Int
  $nextToken: String
) {
  listBudgetSpendByMonthAndJobCodeIdByAmount(
    paidolId: $paidolId
    yearAndMonthAmount: $yearAndMonthAmount
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      paidolId
      authPaidolId
      yearAndMonth
      jobCodeId
      amount
      transactionCount
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBudgetSpendByMonthAndJobCodeIdByAmountQueryVariables,
  APITypes.ListBudgetSpendByMonthAndJobCodeIdByAmountQuery
>;
export const getMcc = /* GraphQL */ `query GetMcc($id: ID!) {
  getMcc(id: $id) {
    id
    code
    highnoteDescription
    highnoteCategoryDescription
    speedchainDescription
    expenseTypes {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetMccQueryVariables, APITypes.GetMccQuery>;
export const listMccs = /* GraphQL */ `query ListMccs(
  $id: ID
  $filter: ModelMccFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listMccs(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      code
      highnoteDescription
      highnoteCategoryDescription
      speedchainDescription
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListMccsQueryVariables, APITypes.ListMccsQuery>;
export const getExpenseType = /* GraphQL */ `query GetExpenseType($id: ID!) {
  getExpenseType(id: $id) {
    id
    name
    codes {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetExpenseTypeQueryVariables,
  APITypes.GetExpenseTypeQuery
>;
export const listExpenseTypes = /* GraphQL */ `query ListExpenseTypes(
  $id: ID
  $filter: ModelExpenseTypeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listExpenseTypes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListExpenseTypesQueryVariables,
  APITypes.ListExpenseTypesQuery
>;
export const getReceiptSummaryField = /* GraphQL */ `query GetReceiptSummaryField($id: ID!) {
  getReceiptSummaryField(id: $id) {
    id
    paidolId
    authPaidolId
    receiptUploadId
    type
    typeConfidenceScore
    label
    labelConfidenceScore
    value
    valueConfidenceScore
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReceiptSummaryFieldQueryVariables,
  APITypes.GetReceiptSummaryFieldQuery
>;
export const listReceiptSummaryFields = /* GraphQL */ `query ListReceiptSummaryFields(
  $id: ID
  $filter: ModelReceiptSummaryFieldFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listReceiptSummaryFields(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      receiptUploadId
      type
      typeConfidenceScore
      label
      labelConfidenceScore
      value
      valueConfidenceScore
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReceiptSummaryFieldsQueryVariables,
  APITypes.ListReceiptSummaryFieldsQuery
>;
export const listReceiptSummaryFieldsByPaidolId = /* GraphQL */ `query ListReceiptSummaryFieldsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelReceiptSummaryFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  listReceiptSummaryFieldsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      receiptUploadId
      type
      typeConfidenceScore
      label
      labelConfidenceScore
      value
      valueConfidenceScore
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReceiptSummaryFieldsByPaidolIdQueryVariables,
  APITypes.ListReceiptSummaryFieldsByPaidolIdQuery
>;
export const searchReceiptSummaryFields = /* GraphQL */ `query SearchReceiptSummaryFields(
  $filter: SearchableReceiptSummaryFieldFilterInput
  $sort: [SearchableReceiptSummaryFieldSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableReceiptSummaryFieldAggregationInput]
) {
  searchReceiptSummaryFields(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      paidolId
      authPaidolId
      receiptUploadId
      type
      typeConfidenceScore
      label
      labelConfidenceScore
      value
      valueConfidenceScore
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchReceiptSummaryFieldsQueryVariables,
  APITypes.SearchReceiptSummaryFieldsQuery
>;
export const getReceiptLineItem = /* GraphQL */ `query GetReceiptLineItem($id: ID!) {
  getReceiptLineItem(id: $id) {
    id
    paidolId
    authPaidolId
    receiptUploadId
    lineItemFields {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReceiptLineItemQueryVariables,
  APITypes.GetReceiptLineItemQuery
>;
export const listReceiptLineItems = /* GraphQL */ `query ListReceiptLineItems(
  $id: ID
  $filter: ModelReceiptLineItemFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listReceiptLineItems(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      receiptUploadId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReceiptLineItemsQueryVariables,
  APITypes.ListReceiptLineItemsQuery
>;
export const listReceiptLineItemByPaidolId = /* GraphQL */ `query ListReceiptLineItemByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelReceiptLineItemFilterInput
  $limit: Int
  $nextToken: String
) {
  listReceiptLineItemByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      receiptUploadId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReceiptLineItemByPaidolIdQueryVariables,
  APITypes.ListReceiptLineItemByPaidolIdQuery
>;
export const searchReceiptLineItems = /* GraphQL */ `query SearchReceiptLineItems(
  $filter: SearchableReceiptLineItemFilterInput
  $sort: [SearchableReceiptLineItemSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableReceiptLineItemAggregationInput]
) {
  searchReceiptLineItems(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      paidolId
      authPaidolId
      receiptUploadId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchReceiptLineItemsQueryVariables,
  APITypes.SearchReceiptLineItemsQuery
>;
export const getReceiptLineItemField = /* GraphQL */ `query GetReceiptLineItemField($id: ID!) {
  getReceiptLineItemField(id: $id) {
    id
    paidolId
    authPaidolId
    receiptLineItemId
    type
    typeConfidenceScore
    label
    labelConfidenceScore
    value
    valueConfidenceScore
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReceiptLineItemFieldQueryVariables,
  APITypes.GetReceiptLineItemFieldQuery
>;
export const listReceiptLineItemFields = /* GraphQL */ `query ListReceiptLineItemFields(
  $id: ID
  $filter: ModelReceiptLineItemFieldFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listReceiptLineItemFields(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      receiptLineItemId
      type
      typeConfidenceScore
      label
      labelConfidenceScore
      value
      valueConfidenceScore
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReceiptLineItemFieldsQueryVariables,
  APITypes.ListReceiptLineItemFieldsQuery
>;
export const listReceiptLineItemFieldsByPaidolId = /* GraphQL */ `query ListReceiptLineItemFieldsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelReceiptLineItemFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  listReceiptLineItemFieldsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      receiptLineItemId
      type
      typeConfidenceScore
      label
      labelConfidenceScore
      value
      valueConfidenceScore
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReceiptLineItemFieldsByPaidolIdQueryVariables,
  APITypes.ListReceiptLineItemFieldsByPaidolIdQuery
>;
export const searchReceiptLineItemFields = /* GraphQL */ `query SearchReceiptLineItemFields(
  $filter: SearchableReceiptLineItemFieldFilterInput
  $sort: [SearchableReceiptLineItemFieldSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableReceiptLineItemFieldAggregationInput]
) {
  searchReceiptLineItemFields(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      paidolId
      authPaidolId
      receiptLineItemId
      type
      typeConfidenceScore
      label
      labelConfidenceScore
      value
      valueConfidenceScore
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchReceiptLineItemFieldsQueryVariables,
  APITypes.SearchReceiptLineItemFieldsQuery
>;
export const getReceiptUpload = /* GraphQL */ `query GetReceiptUpload($id: ID!) {
  getReceiptUpload(id: $id) {
    id
    paidolId
    authPaidolId
    document
    status
    summaryFields {
      nextToken
      __typename
    }
    lineItems {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReceiptUploadQueryVariables,
  APITypes.GetReceiptUploadQuery
>;
export const listReceiptUploads = /* GraphQL */ `query ListReceiptUploads(
  $id: ID
  $filter: ModelReceiptUploadFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listReceiptUploads(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReceiptUploadsQueryVariables,
  APITypes.ListReceiptUploadsQuery
>;
export const listReceiptUploadsByPaidolId = /* GraphQL */ `query ListReceiptUploadsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelReceiptUploadFilterInput
  $limit: Int
  $nextToken: String
) {
  listReceiptUploadsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReceiptUploadsByPaidolIdQueryVariables,
  APITypes.ListReceiptUploadsByPaidolIdQuery
>;
export const searchReceiptUploads = /* GraphQL */ `query SearchReceiptUploads(
  $filter: SearchableReceiptUploadFilterInput
  $sort: [SearchableReceiptUploadSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableReceiptUploadAggregationInput]
) {
  searchReceiptUploads(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchReceiptUploadsQueryVariables,
  APITypes.SearchReceiptUploadsQuery
>;
export const getTransactionToReceiptUpload = /* GraphQL */ `query GetTransactionToReceiptUpload($id: ID!) {
  getTransactionToReceiptUpload(id: $id) {
    id
    highnoteTransactionEventId
    reimbursementTransactionId
    receiptUploadId
    receiptUpload {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    createdAt
    authPaidolId
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTransactionToReceiptUploadQueryVariables,
  APITypes.GetTransactionToReceiptUploadQuery
>;
export const listTransactionToReceiptUploads = /* GraphQL */ `query ListTransactionToReceiptUploads(
  $id: ID
  $filter: ModelTransactionToReceiptUploadFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTransactionToReceiptUploads(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      highnoteTransactionEventId
      reimbursementTransactionId
      receiptUploadId
      createdAt
      authPaidolId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTransactionToReceiptUploadsQueryVariables,
  APITypes.ListTransactionToReceiptUploadsQuery
>;
export const listTransactionToReceiptUploadsByHighnoteTransactionEventId = /* GraphQL */ `query ListTransactionToReceiptUploadsByHighnoteTransactionEventId(
  $highnoteTransactionEventId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTransactionToReceiptUploadFilterInput
  $limit: Int
  $nextToken: String
) {
  listTransactionToReceiptUploadsByHighnoteTransactionEventId(
    highnoteTransactionEventId: $highnoteTransactionEventId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      highnoteTransactionEventId
      reimbursementTransactionId
      receiptUploadId
      createdAt
      authPaidolId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTransactionToReceiptUploadsByHighnoteTransactionEventIdQueryVariables,
  APITypes.ListTransactionToReceiptUploadsByHighnoteTransactionEventIdQuery
>;
export const listTransactionToReceiptUploadsByReimbursementTransactionId = /* GraphQL */ `query ListTransactionToReceiptUploadsByReimbursementTransactionId(
  $reimbursementTransactionId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTransactionToReceiptUploadFilterInput
  $limit: Int
  $nextToken: String
) {
  listTransactionToReceiptUploadsByReimbursementTransactionId(
    reimbursementTransactionId: $reimbursementTransactionId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      highnoteTransactionEventId
      reimbursementTransactionId
      receiptUploadId
      createdAt
      authPaidolId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTransactionToReceiptUploadsByReimbursementTransactionIdQueryVariables,
  APITypes.ListTransactionToReceiptUploadsByReimbursementTransactionIdQuery
>;
export const searchTransactionToReceiptUploads = /* GraphQL */ `query SearchTransactionToReceiptUploads(
  $filter: SearchableTransactionToReceiptUploadFilterInput
  $sort: [SearchableTransactionToReceiptUploadSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableTransactionToReceiptUploadAggregationInput]
) {
  searchTransactionToReceiptUploads(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      highnoteTransactionEventId
      reimbursementTransactionId
      receiptUploadId
      createdAt
      authPaidolId
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchTransactionToReceiptUploadsQueryVariables,
  APITypes.SearchTransactionToReceiptUploadsQuery
>;
export const getTransaction = /* GraphQL */ `query GetTransaction($id: ID!) {
  getTransaction(id: $id) {
    id
    paidolId
    authPaidolId
    transactionDate
    reimbursementTransactionId
    reimbursementTransaction {
      id
      paidolId
      authPaidolId
      dwollaTransferId
      transactionDate
      status
      checkrunStatus
      note
      contestNote
      deniedNote
      merchantName
      receiptLineItems
      jobCodeId
      reimbursementDate
      decisionDate
      reviewedByPaidolUserId
      reviewedByName
      reviewedByRole
      reviewedAt
      paidolUserId
      transactionType
      expenseTypeId
      receiptId
      procoreProjectId
      procoreWBSCodeId
      agaveGlCodeId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveVendorId
      agaveSubJobId
      agaveLocationId
      agaveDepartmentId
      agaveSubaccountId
      agaveEmployeeId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      flexGlCodeId
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexVendorId
      createdAt
      updatedAt
      __typename
    }
    highnoteTransactionId
    highnoteTransaction {
      transactionId
      paymentCardId
      paidolId
      authPaidolId
      cardGroupId
      status
      transactionDate
      merchantName
      merchantCategoryCode
      merchantCategory
      transactionEvents
      note
      jobCodeId
      procoreCompanyId
      procoreProjectId
      procoreWBSCodeId
      procoreDirectCostId
      procoreDirectCostLineItemId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveExpenseId
      agaveVendorId
      agaveGlCodeId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      receiptPath
      receiptId
      erpApprovalStatus
      erpBypassStatus
      last4
      userId
      email
      approvedAmountValue
      approvedAmountCurrencyCode
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      selectedCodingOption
      agaveGlCostTypeId
      flexCodeTransactionStatus
      approveWithoutNotes
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTransactionQueryVariables,
  APITypes.GetTransactionQuery
>;
export const listTransactions = /* GraphQL */ `query ListTransactions(
  $id: ID
  $filter: ModelTransactionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTransactions(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      transactionDate
      reimbursementTransactionId
      highnoteTransactionId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTransactionsQueryVariables,
  APITypes.ListTransactionsQuery
>;
export const listTransactionsByPaidolId = /* GraphQL */ `query ListTransactionsByPaidolId(
  $paidolId: ID!
  $transactionDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  listTransactionsByPaidolId(
    paidolId: $paidolId
    transactionDate: $transactionDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      transactionDate
      reimbursementTransactionId
      highnoteTransactionId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTransactionsByPaidolIdQueryVariables,
  APITypes.ListTransactionsByPaidolIdQuery
>;
export const searchTransactions = /* GraphQL */ `query SearchTransactions(
  $filter: SearchableTransactionFilterInput
  $sort: [SearchableTransactionSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableTransactionAggregationInput]
) {
  searchTransactions(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      paidolId
      authPaidolId
      transactionDate
      reimbursementTransactionId
      highnoteTransactionId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchTransactionsQueryVariables,
  APITypes.SearchTransactionsQuery
>;
export const getReimbursementTransaction = /* GraphQL */ `query GetReimbursementTransaction($id: ID!) {
  getReimbursementTransaction(id: $id) {
    id
    paidolId
    authPaidolId
    dwollaTransferId
    transactionDate
    amount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    status
    checkrunStatus
    note
    contestNote
    deniedNote
    merchantName
    receiptLineItems
    jobCodeId
    jobCode {
      id
      paidolId
      authPaidolId
      description
      code
      isActive
      budget
      jobCodeImportId
      createdAt
      updatedAt
      __typename
    }
    reimbursementDate
    decisionDate
    reviewedByPaidolUserId
    reviewedByName
    reviewedByRole
    reviewedAt
    paidolUserId
    paidolUser {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    transactionType
    expenseTypeId
    expenseType {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    receiptId
    receipt {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    procoreProjectId
    procoreProject {
      id
      active
      display_name
      name
      created_at
      start_date
      completion_date
      project_number
      total_value
      __typename
    }
    procoreWBSCodeId
    procoreWBSCode {
      id
      flat_code
      flat_name
      description
      status
      __typename
    }
    agaveGlCodeId
    agaveGlCode {
      id
      paidolId
      authPaidolId
      source_id
      classification
      currency_code
      current_balance
      description
      name
      number
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveProjectId
    agaveProject {
      id
      paidolId
      authPaidolId
      source_id
      amount
      completion_date
      name
      number
      start_date
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveCostCodeId
    agaveCostCode {
      id
      paidolId
      authPaidolId
      asset_account_id
      source_id
      formatted_full_code
      code
      full_code
      cost_unit_of_measure
      description
      expense_account_id
      income_account_id
      name
      parent_id
      project_id
      price_unit_of_measure
      source_create_time
      source_update_time
      status
      type
      unit_cost
      unit_price
      vendor_id
      sub_job_id
      createdAt
      updatedAt
      projectId
      paidolProject
      projectIds
      cost_type_ids
      fullName
      __typename
    }
    agaveCostTypeId
    agaveCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      project_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      paidolProject
      __typename
    }
    agaveVendorId
    agaveVendor {
      id
      paidolId
      authPaidolId
      source_id
      code
      email
      fax
      name
      phone
      status
      tax_number
      terms
      type
      website
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      __typename
    }
    agaveSubJobId
    agaveSubJob {
      id
      agaveSubJobId
      paidolId
      authPaidolId
      source_id
      name
      number
      code
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      fullName
      cost_code_ids
      __typename
    }
    agaveLocationId
    agaveLocation {
      id
      paidolId
      authPaidolId
      name
      fullName
      parent_id
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveDepartmentId
    agaveDepartment {
      id
      paidolId
      authPaidolId
      code
      name
      fullName
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveSubaccountId
    agaveSubaccount {
      id
      paidolId
      authPaidolId
      code
      name
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveEmployeeId
    agaveEmployee {
      id
      paidolId
      authPaidolId
      name
      fullName
      firstName
      lastName
      email
      status
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveEquipmentId
    agaveEquipment {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCo
      category
      department
      status
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostCodeId
    agaveEmCostCode {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCostTypeCodes
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostTypeId
    agaveEmCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      abbreviation
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    codingType
    accountingDate
    flexGlCodeId
    flexGlCode {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCodeId
    flexCode {
      id
      paidolId
      authPaidolId
      projectName
      projectCode
      isActive
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostCodeId
    flexCostCode {
      id
      paidolId
      authPaidolId
      code
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostTypeId
    flexCostType {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexVendorId
    flexVendor {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReimbursementTransactionQueryVariables,
  APITypes.GetReimbursementTransactionQuery
>;
export const listReimbursementTransactions = /* GraphQL */ `query ListReimbursementTransactions(
  $id: ID
  $filter: ModelReimbursementTransactionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listReimbursementTransactions(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      dwollaTransferId
      transactionDate
      status
      checkrunStatus
      note
      contestNote
      deniedNote
      merchantName
      receiptLineItems
      jobCodeId
      reimbursementDate
      decisionDate
      reviewedByPaidolUserId
      reviewedByName
      reviewedByRole
      reviewedAt
      paidolUserId
      transactionType
      expenseTypeId
      receiptId
      procoreProjectId
      procoreWBSCodeId
      agaveGlCodeId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveVendorId
      agaveSubJobId
      agaveLocationId
      agaveDepartmentId
      agaveSubaccountId
      agaveEmployeeId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      flexGlCodeId
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexVendorId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReimbursementTransactionsQueryVariables,
  APITypes.ListReimbursementTransactionsQuery
>;
export const listReimbursementTransactionsByPaidolId = /* GraphQL */ `query ListReimbursementTransactionsByPaidolId(
  $paidolId: ID!
  $transactionDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelReimbursementTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  listReimbursementTransactionsByPaidolId(
    paidolId: $paidolId
    transactionDate: $transactionDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      dwollaTransferId
      transactionDate
      status
      checkrunStatus
      note
      contestNote
      deniedNote
      merchantName
      receiptLineItems
      jobCodeId
      reimbursementDate
      decisionDate
      reviewedByPaidolUserId
      reviewedByName
      reviewedByRole
      reviewedAt
      paidolUserId
      transactionType
      expenseTypeId
      receiptId
      procoreProjectId
      procoreWBSCodeId
      agaveGlCodeId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveVendorId
      agaveSubJobId
      agaveLocationId
      agaveDepartmentId
      agaveSubaccountId
      agaveEmployeeId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      flexGlCodeId
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexVendorId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReimbursementTransactionsByPaidolIdQueryVariables,
  APITypes.ListReimbursementTransactionsByPaidolIdQuery
>;
export const reimbursementTransactionByPaidolUserId = /* GraphQL */ `query ReimbursementTransactionByPaidolUserId(
  $paidolUserId: ID!
  $paidolId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelReimbursementTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  reimbursementTransactionByPaidolUserId(
    paidolUserId: $paidolUserId
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      dwollaTransferId
      transactionDate
      status
      checkrunStatus
      note
      contestNote
      deniedNote
      merchantName
      receiptLineItems
      jobCodeId
      reimbursementDate
      decisionDate
      reviewedByPaidolUserId
      reviewedByName
      reviewedByRole
      reviewedAt
      paidolUserId
      transactionType
      expenseTypeId
      receiptId
      procoreProjectId
      procoreWBSCodeId
      agaveGlCodeId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveVendorId
      agaveSubJobId
      agaveLocationId
      agaveDepartmentId
      agaveSubaccountId
      agaveEmployeeId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      flexGlCodeId
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexVendorId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ReimbursementTransactionByPaidolUserIdQueryVariables,
  APITypes.ReimbursementTransactionByPaidolUserIdQuery
>;
export const reimbursementTransactionByExpenseTypeId = /* GraphQL */ `query ReimbursementTransactionByExpenseTypeId(
  $expenseTypeId: ID!
  $paidolId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelReimbursementTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  reimbursementTransactionByExpenseTypeId(
    expenseTypeId: $expenseTypeId
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      dwollaTransferId
      transactionDate
      status
      checkrunStatus
      note
      contestNote
      deniedNote
      merchantName
      receiptLineItems
      jobCodeId
      reimbursementDate
      decisionDate
      reviewedByPaidolUserId
      reviewedByName
      reviewedByRole
      reviewedAt
      paidolUserId
      transactionType
      expenseTypeId
      receiptId
      procoreProjectId
      procoreWBSCodeId
      agaveGlCodeId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveVendorId
      agaveSubJobId
      agaveLocationId
      agaveDepartmentId
      agaveSubaccountId
      agaveEmployeeId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      flexGlCodeId
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexVendorId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ReimbursementTransactionByExpenseTypeIdQueryVariables,
  APITypes.ReimbursementTransactionByExpenseTypeIdQuery
>;
export const reimbursementTransactionByReceiptId = /* GraphQL */ `query ReimbursementTransactionByReceiptId(
  $receiptId: ID!
  $paidolId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelReimbursementTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  reimbursementTransactionByReceiptId(
    receiptId: $receiptId
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      dwollaTransferId
      transactionDate
      status
      checkrunStatus
      note
      contestNote
      deniedNote
      merchantName
      receiptLineItems
      jobCodeId
      reimbursementDate
      decisionDate
      reviewedByPaidolUserId
      reviewedByName
      reviewedByRole
      reviewedAt
      paidolUserId
      transactionType
      expenseTypeId
      receiptId
      procoreProjectId
      procoreWBSCodeId
      agaveGlCodeId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveVendorId
      agaveSubJobId
      agaveLocationId
      agaveDepartmentId
      agaveSubaccountId
      agaveEmployeeId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      flexGlCodeId
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexVendorId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ReimbursementTransactionByReceiptIdQueryVariables,
  APITypes.ReimbursementTransactionByReceiptIdQuery
>;
export const searchReimbursementTransactions = /* GraphQL */ `query SearchReimbursementTransactions(
  $filter: SearchableReimbursementTransactionFilterInput
  $sort: [SearchableReimbursementTransactionSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableReimbursementTransactionAggregationInput]
) {
  searchReimbursementTransactions(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      paidolId
      authPaidolId
      dwollaTransferId
      transactionDate
      status
      checkrunStatus
      note
      contestNote
      deniedNote
      merchantName
      receiptLineItems
      jobCodeId
      reimbursementDate
      decisionDate
      reviewedByPaidolUserId
      reviewedByName
      reviewedByRole
      reviewedAt
      paidolUserId
      transactionType
      expenseTypeId
      receiptId
      procoreProjectId
      procoreWBSCodeId
      agaveGlCodeId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveVendorId
      agaveSubJobId
      agaveLocationId
      agaveDepartmentId
      agaveSubaccountId
      agaveEmployeeId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      flexGlCodeId
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexVendorId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchReimbursementTransactionsQueryVariables,
  APITypes.SearchReimbursementTransactionsQuery
>;
export const getHighnoteTransaction = /* GraphQL */ `query GetHighnoteTransaction($transactionId: ID!) {
  getHighnoteTransaction(transactionId: $transactionId) {
    transactionId
    paymentCardId
    paymentCard {
      paymentCardId
      paidolId
      authPaidolId
      name
      cardGroupId
      status
      bin
      last4
      network
      formFactor
      expirationDate
      hasPin
      cardholderId
      cardholderName
      isAdminLocked
      lastActionByRole
      lastActionByPaidolUserId
      lastActionByName
      lastActionByEmail
      lastActionAt
      merchantSpendRuleId
      isAuthorizedUserCard
      createdAt
      updatedAt
      __typename
    }
    paidolId
    authPaidolId
    cardGroupId
    cardGroup {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    status
    transactionDate
    approvedAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    merchantName
    merchantCategoryCode
    merchantCategory
    transactionEvents
    note
    jobCodeId
    jobCode {
      id
      paidolId
      authPaidolId
      description
      code
      isActive
      budget
      jobCodeImportId
      createdAt
      updatedAt
      __typename
    }
    procoreCompanyId
    procoreCompany {
      id
      name
      is_active
      logo_url
      __typename
    }
    procoreProjectId
    procoreProject {
      id
      active
      display_name
      name
      created_at
      start_date
      completion_date
      project_number
      total_value
      __typename
    }
    procoreWBSCodeId
    procoreWBSCode {
      id
      flat_code
      flat_name
      description
      status
      __typename
    }
    procoreDirectCostId
    procoreDirectCostLineItemId
    agaveProjectId
    agaveProject {
      id
      paidolId
      authPaidolId
      source_id
      amount
      completion_date
      name
      number
      start_date
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveCostCodeId
    agaveCostCode {
      id
      paidolId
      authPaidolId
      asset_account_id
      source_id
      formatted_full_code
      code
      full_code
      cost_unit_of_measure
      description
      expense_account_id
      income_account_id
      name
      parent_id
      project_id
      price_unit_of_measure
      source_create_time
      source_update_time
      status
      type
      unit_cost
      unit_price
      vendor_id
      sub_job_id
      createdAt
      updatedAt
      projectId
      paidolProject
      projectIds
      cost_type_ids
      fullName
      __typename
    }
    agaveCostTypeId
    agaveCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      project_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      paidolProject
      __typename
    }
    agaveExpenseId
    agaveExpense {
      id
      source_id
      amount
      amount_due
      ap_payment_ids
      batch
      batch_id
      creator_id
      currency_code
      description
      discount_amount
      discount_date
      due_date
      issue_date
      misc_amount
      net_amount
      number
      project_id
      retention_amount
      retention_percent
      status
      subtotal_amount
      tax_amount
      total_amount
      type
      vendor_id
      source_create_time
      source_update_time
      __typename
    }
    agaveVendor {
      id
      paidolId
      authPaidolId
      source_id
      code
      email
      fax
      name
      phone
      status
      tax_number
      terms
      type
      website
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      __typename
    }
    agaveVendorId
    agaveGlCodeId
    agaveGlCode {
      id
      paidolId
      authPaidolId
      source_id
      classification
      currency_code
      current_balance
      description
      name
      number
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveDepartmentId
    agaveLocationId
    agaveSubaccountId
    agaveSubaccount {
      id
      paidolId
      authPaidolId
      code
      name
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    receiptPath
    receiptId
    receipt {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    erpApprovalStatus
    erpBypassStatus
    last4
    userId
    user {
      id
      username
      email
      first_name
      middle_name
      last_name
      suffix
      picture
      is_speedster
      birthdate
      address
      phone_number
      phone_extension
      password_updated_at
      finicityCustomerId
      dwollaCustomerId
      is_support
      deletedAt
      createdAt
      updatedAt
      __typename
    }
    email
    approvedAmountValue
    approvedAmountCurrencyCode
    flexCodeId
    flexCode {
      id
      paidolId
      authPaidolId
      projectName
      projectCode
      isActive
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostCodeId
    flexCostCode {
      id
      paidolId
      authPaidolId
      code
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostTypeId
    flexCostType {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexGlCodeId
    flexGlCode {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexVendorId
    flexVendor {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    selectedCodingOption
    card {
      paymentCardId
      paidolId
      authPaidolId
      name
      cardGroupId
      status
      bin
      last4
      network
      formFactor
      expirationDate
      hasPin
      cardholderId
      cardholderName
      isAdminLocked
      lastActionByRole
      lastActionByPaidolUserId
      lastActionByName
      lastActionByEmail
      lastActionAt
      merchantSpendRuleId
      isAuthorizedUserCard
      createdAt
      updatedAt
      __typename
    }
    agaveGlCostTypeId
    agaveGlCostType {
      id
      source_id
      code
      name
      project_id
      source_create_time
      source_update_time
      __typename
    }
    flexCodeTransactionStatus
    approveWithoutNotes
    approveWithoutReceipts
    fuelVehicleId
    fuelOdometerReading
    fuelGallons
    fuelCostPerGallon
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetHighnoteTransactionQueryVariables,
  APITypes.GetHighnoteTransactionQuery
>;
export const listHighnoteTransactions = /* GraphQL */ `query ListHighnoteTransactions(
  $transactionId: ID
  $filter: ModelHighnoteTransactionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listHighnoteTransactions(
    transactionId: $transactionId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      transactionId
      paymentCardId
      paidolId
      authPaidolId
      cardGroupId
      status
      transactionDate
      merchantName
      merchantCategoryCode
      merchantCategory
      transactionEvents
      note
      jobCodeId
      procoreCompanyId
      procoreProjectId
      procoreWBSCodeId
      procoreDirectCostId
      procoreDirectCostLineItemId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveExpenseId
      agaveVendorId
      agaveGlCodeId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      receiptPath
      receiptId
      erpApprovalStatus
      erpBypassStatus
      last4
      userId
      email
      approvedAmountValue
      approvedAmountCurrencyCode
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      selectedCodingOption
      agaveGlCostTypeId
      flexCodeTransactionStatus
      approveWithoutNotes
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHighnoteTransactionsQueryVariables,
  APITypes.ListHighnoteTransactionsQuery
>;
export const listHighnoteTransactionsByPaymentCardId = /* GraphQL */ `query ListHighnoteTransactionsByPaymentCardId(
  $paymentCardId: ID!
  $transactionDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelHighnoteTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  listHighnoteTransactionsByPaymentCardId(
    paymentCardId: $paymentCardId
    transactionDate: $transactionDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      transactionId
      paymentCardId
      paidolId
      authPaidolId
      cardGroupId
      status
      transactionDate
      merchantName
      merchantCategoryCode
      merchantCategory
      transactionEvents
      note
      jobCodeId
      procoreCompanyId
      procoreProjectId
      procoreWBSCodeId
      procoreDirectCostId
      procoreDirectCostLineItemId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveExpenseId
      agaveVendorId
      agaveGlCodeId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      receiptPath
      receiptId
      erpApprovalStatus
      erpBypassStatus
      last4
      userId
      email
      approvedAmountValue
      approvedAmountCurrencyCode
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      selectedCodingOption
      agaveGlCostTypeId
      flexCodeTransactionStatus
      approveWithoutNotes
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHighnoteTransactionsByPaymentCardIdQueryVariables,
  APITypes.ListHighnoteTransactionsByPaymentCardIdQuery
>;
export const listHighnoteTransactionsByPaidolId = /* GraphQL */ `query ListHighnoteTransactionsByPaidolId(
  $paidolId: ID!
  $transactionDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelHighnoteTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  listHighnoteTransactionsByPaidolId(
    paidolId: $paidolId
    transactionDate: $transactionDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      transactionId
      paymentCardId
      paidolId
      authPaidolId
      cardGroupId
      status
      transactionDate
      merchantName
      merchantCategoryCode
      merchantCategory
      transactionEvents
      note
      jobCodeId
      procoreCompanyId
      procoreProjectId
      procoreWBSCodeId
      procoreDirectCostId
      procoreDirectCostLineItemId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveExpenseId
      agaveVendorId
      agaveGlCodeId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      receiptPath
      receiptId
      erpApprovalStatus
      erpBypassStatus
      last4
      userId
      email
      approvedAmountValue
      approvedAmountCurrencyCode
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      selectedCodingOption
      agaveGlCostTypeId
      flexCodeTransactionStatus
      approveWithoutNotes
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHighnoteTransactionsByPaidolIdQueryVariables,
  APITypes.ListHighnoteTransactionsByPaidolIdQuery
>;
export const listHighnoteTransactionsByCardGroupId = /* GraphQL */ `query ListHighnoteTransactionsByCardGroupId(
  $cardGroupId: ID!
  $transactionDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelHighnoteTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  listHighnoteTransactionsByCardGroupId(
    cardGroupId: $cardGroupId
    transactionDate: $transactionDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      transactionId
      paymentCardId
      paidolId
      authPaidolId
      cardGroupId
      status
      transactionDate
      merchantName
      merchantCategoryCode
      merchantCategory
      transactionEvents
      note
      jobCodeId
      procoreCompanyId
      procoreProjectId
      procoreWBSCodeId
      procoreDirectCostId
      procoreDirectCostLineItemId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveExpenseId
      agaveVendorId
      agaveGlCodeId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      receiptPath
      receiptId
      erpApprovalStatus
      erpBypassStatus
      last4
      userId
      email
      approvedAmountValue
      approvedAmountCurrencyCode
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      selectedCodingOption
      agaveGlCostTypeId
      flexCodeTransactionStatus
      approveWithoutNotes
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHighnoteTransactionsByCardGroupIdQueryVariables,
  APITypes.ListHighnoteTransactionsByCardGroupIdQuery
>;
export const listHighnoteTransactionsByAgaveVendorId = /* GraphQL */ `query ListHighnoteTransactionsByAgaveVendorId(
  $agaveVendorId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelHighnoteTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  listHighnoteTransactionsByAgaveVendorId(
    agaveVendorId: $agaveVendorId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      transactionId
      paymentCardId
      paidolId
      authPaidolId
      cardGroupId
      status
      transactionDate
      merchantName
      merchantCategoryCode
      merchantCategory
      transactionEvents
      note
      jobCodeId
      procoreCompanyId
      procoreProjectId
      procoreWBSCodeId
      procoreDirectCostId
      procoreDirectCostLineItemId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveExpenseId
      agaveVendorId
      agaveGlCodeId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      receiptPath
      receiptId
      erpApprovalStatus
      erpBypassStatus
      last4
      userId
      email
      approvedAmountValue
      approvedAmountCurrencyCode
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      selectedCodingOption
      agaveGlCostTypeId
      flexCodeTransactionStatus
      approveWithoutNotes
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHighnoteTransactionsByAgaveVendorIdQueryVariables,
  APITypes.ListHighnoteTransactionsByAgaveVendorIdQuery
>;
export const highnoteTransactionByReceiptId = /* GraphQL */ `query HighnoteTransactionByReceiptId(
  $receiptId: ID!
  $paidolId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelHighnoteTransactionFilterInput
  $limit: Int
  $nextToken: String
) {
  highnoteTransactionByReceiptId(
    receiptId: $receiptId
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      transactionId
      paymentCardId
      paidolId
      authPaidolId
      cardGroupId
      status
      transactionDate
      merchantName
      merchantCategoryCode
      merchantCategory
      transactionEvents
      note
      jobCodeId
      procoreCompanyId
      procoreProjectId
      procoreWBSCodeId
      procoreDirectCostId
      procoreDirectCostLineItemId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveExpenseId
      agaveVendorId
      agaveGlCodeId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      receiptPath
      receiptId
      erpApprovalStatus
      erpBypassStatus
      last4
      userId
      email
      approvedAmountValue
      approvedAmountCurrencyCode
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      selectedCodingOption
      agaveGlCostTypeId
      flexCodeTransactionStatus
      approveWithoutNotes
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.HighnoteTransactionByReceiptIdQueryVariables,
  APITypes.HighnoteTransactionByReceiptIdQuery
>;
export const searchHighnoteTransactions = /* GraphQL */ `query SearchHighnoteTransactions(
  $filter: SearchableHighnoteTransactionFilterInput
  $sort: [SearchableHighnoteTransactionSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableHighnoteTransactionAggregationInput]
) {
  searchHighnoteTransactions(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      transactionId
      paymentCardId
      paidolId
      authPaidolId
      cardGroupId
      status
      transactionDate
      merchantName
      merchantCategoryCode
      merchantCategory
      transactionEvents
      note
      jobCodeId
      procoreCompanyId
      procoreProjectId
      procoreWBSCodeId
      procoreDirectCostId
      procoreDirectCostLineItemId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveExpenseId
      agaveVendorId
      agaveGlCodeId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      receiptPath
      receiptId
      erpApprovalStatus
      erpBypassStatus
      last4
      userId
      email
      approvedAmountValue
      approvedAmountCurrencyCode
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      selectedCodingOption
      agaveGlCostTypeId
      flexCodeTransactionStatus
      approveWithoutNotes
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchHighnoteTransactionsQueryVariables,
  APITypes.SearchHighnoteTransactionsQuery
>;
export const getProjectGroup = /* GraphQL */ `query GetProjectGroup($id: ID!) {
  getProjectGroup(id: $id) {
    id
    paidolId
    authPaidolId
    name
    groupProjects
    paymentCards {
      nextToken
      __typename
    }
    monthlyBudget {
      value
      currency
      __typename
    }
    isMonthlyBudgetUnlimited
    spendGroupId
    spendGroup {
      id
      paidolId
      authPaidolId
      name
      paymentCards
      merchantCountrySpendRuleId
      merchantCategorySpendRuleId
      amountLimitSpendRuleId
      monthlyLimitSpendRuleId
      monthlyLimitCumulativeRuleId
      merchantCategoryAllowed
      merchantCategoryBlocked
      merchantCountryAllowed
      merchantCountryBlocked
      monthlyLimitResetTimestamp
      createdAt
      updatedAt
      __typename
    }
    monthlyBudgetSpend {
      nextToken
      __typename
    }
    transactions {
      nextToken
      __typename
    }
    groupAdmins {
      nextToken
      __typename
    }
    deletedAt
    glCodeVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    projectVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    hasReviewers
    spentThisMonth {
      amount
      yearAndMonth
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProjectGroupQueryVariables,
  APITypes.GetProjectGroupQuery
>;
export const listProjectGroups = /* GraphQL */ `query ListProjectGroups(
  $id: ID
  $filter: ModelProjectGroupFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listProjectGroups(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectGroupsQueryVariables,
  APITypes.ListProjectGroupsQuery
>;
export const listProjectGroupsByPaidolId = /* GraphQL */ `query ListProjectGroupsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelProjectGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  listProjectGroupsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectGroupsByPaidolIdQueryVariables,
  APITypes.ListProjectGroupsByPaidolIdQuery
>;
export const getCardGroup = /* GraphQL */ `query GetCardGroup($id: ID!) {
  getCardGroup(id: $id) {
    id
    paidolId
    authPaidolId
    name
    groupProjects
    paymentCards {
      nextToken
      __typename
    }
    monthlyBudget {
      value
      currency
      __typename
    }
    isMonthlyBudgetUnlimited
    spendGroupId
    spendGroup {
      id
      paidolId
      authPaidolId
      name
      paymentCards
      merchantCountrySpendRuleId
      merchantCategorySpendRuleId
      amountLimitSpendRuleId
      monthlyLimitSpendRuleId
      monthlyLimitCumulativeRuleId
      merchantCategoryAllowed
      merchantCategoryBlocked
      merchantCountryAllowed
      merchantCountryBlocked
      monthlyLimitResetTimestamp
      createdAt
      updatedAt
      __typename
    }
    monthlyBudgetSpend {
      nextToken
      __typename
    }
    transactions {
      nextToken
      __typename
    }
    groupAdmins {
      nextToken
      __typename
    }
    deletedAt
    glCodeVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    projectVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    hasReviewers
    spentThisMonth {
      amount
      yearAndMonth
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCardGroupQueryVariables,
  APITypes.GetCardGroupQuery
>;
export const listCardGroups = /* GraphQL */ `query ListCardGroups(
  $id: ID
  $filter: ModelCardGroupFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCardGroups(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCardGroupsQueryVariables,
  APITypes.ListCardGroupsQuery
>;
export const listCardGroupsByPaidolId = /* GraphQL */ `query ListCardGroupsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelCardGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  listCardGroupsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCardGroupsByPaidolIdQueryVariables,
  APITypes.ListCardGroupsByPaidolIdQuery
>;
export const getPaidolUserToProjectGroup = /* GraphQL */ `query GetPaidolUserToProjectGroup($id: ID!) {
  getPaidolUserToProjectGroup(id: $id) {
    id
    paidolId
    paidolUserId
    projectGroupId
    paidolUser {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    projectGroup {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    approvalLevels
    isReviewer
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPaidolUserToProjectGroupQueryVariables,
  APITypes.GetPaidolUserToProjectGroupQuery
>;
export const listPaidolUserToProjectGroups = /* GraphQL */ `query ListPaidolUserToProjectGroups(
  $id: ID
  $filter: ModelPaidolUserToProjectGroupFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPaidolUserToProjectGroups(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      paidolUserId
      projectGroupId
      approvalLevels
      isReviewer
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPaidolUserToProjectGroupsQueryVariables,
  APITypes.ListPaidolUserToProjectGroupsQuery
>;
export const getPaidolUserToCardGroup = /* GraphQL */ `query GetPaidolUserToCardGroup($id: ID!) {
  getPaidolUserToCardGroup(id: $id) {
    id
    paidolId
    paidolUserId
    cardGroupId
    paidolUser {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    cardGroup {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    approvalLevels
    isReviewer
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPaidolUserToCardGroupQueryVariables,
  APITypes.GetPaidolUserToCardGroupQuery
>;
export const listPaidolUserToCardGroups = /* GraphQL */ `query ListPaidolUserToCardGroups(
  $id: ID
  $filter: ModelPaidolUserToCardGroupFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPaidolUserToCardGroups(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      paidolUserId
      cardGroupId
      approvalLevels
      isReviewer
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPaidolUserToCardGroupsQueryVariables,
  APITypes.ListPaidolUserToCardGroupsQuery
>;
export const getProjectGroupBudgetSpendByMonth = /* GraphQL */ `query GetProjectGroupBudgetSpendByMonth(
  $cardGroupId: ID!
  $yearAndMonth: String!
) {
  getProjectGroupBudgetSpendByMonth(
    cardGroupId: $cardGroupId
    yearAndMonth: $yearAndMonth
  ) {
    cardGroupId
    paidolId
    yearAndMonth
    amount
    transactionCount
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProjectGroupBudgetSpendByMonthQueryVariables,
  APITypes.GetProjectGroupBudgetSpendByMonthQuery
>;
export const listProjectGroupBudgetSpendByMonths = /* GraphQL */ `query ListProjectGroupBudgetSpendByMonths(
  $cardGroupId: ID
  $yearAndMonth: ModelStringKeyConditionInput
  $filter: ModelProjectGroupBudgetSpendByMonthFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listProjectGroupBudgetSpendByMonths(
    cardGroupId: $cardGroupId
    yearAndMonth: $yearAndMonth
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      cardGroupId
      paidolId
      yearAndMonth
      amount
      transactionCount
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProjectGroupBudgetSpendByMonthsQueryVariables,
  APITypes.ListProjectGroupBudgetSpendByMonthsQuery
>;
export const getCardGroupBudgetSpendByMonth = /* GraphQL */ `query GetCardGroupBudgetSpendByMonth(
  $cardGroupId: ID!
  $yearAndMonth: String!
) {
  getCardGroupBudgetSpendByMonth(
    cardGroupId: $cardGroupId
    yearAndMonth: $yearAndMonth
  ) {
    cardGroupId
    paidolId
    yearAndMonth
    amount
    transactionCount
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCardGroupBudgetSpendByMonthQueryVariables,
  APITypes.GetCardGroupBudgetSpendByMonthQuery
>;
export const listCardGroupBudgetSpendByMonths = /* GraphQL */ `query ListCardGroupBudgetSpendByMonths(
  $cardGroupId: ID
  $yearAndMonth: ModelStringKeyConditionInput
  $filter: ModelCardGroupBudgetSpendByMonthFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCardGroupBudgetSpendByMonths(
    cardGroupId: $cardGroupId
    yearAndMonth: $yearAndMonth
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      cardGroupId
      paidolId
      yearAndMonth
      amount
      transactionCount
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCardGroupBudgetSpendByMonthsQueryVariables,
  APITypes.ListCardGroupBudgetSpendByMonthsQuery
>;
export const getPaidolUserToHighnotePaymentCard = /* GraphQL */ `query GetPaidolUserToHighnotePaymentCard($id: ID!) {
  getPaidolUserToHighnotePaymentCard(id: $id) {
    id
    paidolUserID
    highnotePaymentCardID
    paidolUser {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    highnotePaymentCard {
      paymentCardId
      paidolId
      authPaidolId
      name
      cardGroupId
      status
      bin
      last4
      network
      formFactor
      expirationDate
      hasPin
      cardholderId
      cardholderName
      isAdminLocked
      lastActionByRole
      lastActionByPaidolUserId
      lastActionByName
      lastActionByEmail
      lastActionAt
      merchantSpendRuleId
      isAuthorizedUserCard
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPaidolUserToHighnotePaymentCardQueryVariables,
  APITypes.GetPaidolUserToHighnotePaymentCardQuery
>;
export const listPaidolUserToHighnotePaymentCards = /* GraphQL */ `query ListPaidolUserToHighnotePaymentCards(
  $filter: ModelPaidolUserToHighnotePaymentCardFilterInput
  $limit: Int
  $nextToken: String
) {
  listPaidolUserToHighnotePaymentCards(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolUserID
      highnotePaymentCardID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPaidolUserToHighnotePaymentCardsQueryVariables,
  APITypes.ListPaidolUserToHighnotePaymentCardsQuery
>;
export const getUserNotificationPreferences = /* GraphQL */ `query GetUserNotificationPreferences($id: ID!) {
  getUserNotificationPreferences(id: $id) {
    id
    userId
    paidolId
    transactionAlertSms
    transactionAlertEmail
    cardLockedSms
    cardLockedEmail
    manualCardActionSms
    manualCardActionEmail
    lowBalanceAlertSms
    lowBalanceAlertEmail
    cardActivationSms
    cardActivationEmail
    statementReadySms
    statementReadyEmail
    txnReviewFrequency
    txnReviewCodeUpdateSms
    txnReviewCodeUpdateEmail
    txnReviewNoteUpdateSms
    txnReviewNoteUpdateEmail
    txnReviewReceiptUpdateSms
    txnReviewReceiptUpdateEmail
    txnReviewResubmissionSms
    txnReviewResubmissionEmail
    txnReviewReadySms
    txnReviewReadyEmail
    returnedTransactionSms
    returnedTransactionEmail
    smsConsentAccepted
    smsConsentAcceptedAt
    platformAgreementVersion
    hasReceivedWelcomeSms
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserNotificationPreferencesQueryVariables,
  APITypes.GetUserNotificationPreferencesQuery
>;
export const listUserNotificationPreferences = /* GraphQL */ `query ListUserNotificationPreferences(
  $filter: ModelUserNotificationPreferencesFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserNotificationPreferences(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      paidolId
      transactionAlertSms
      transactionAlertEmail
      cardLockedSms
      cardLockedEmail
      manualCardActionSms
      manualCardActionEmail
      lowBalanceAlertSms
      lowBalanceAlertEmail
      cardActivationSms
      cardActivationEmail
      statementReadySms
      statementReadyEmail
      txnReviewFrequency
      txnReviewCodeUpdateSms
      txnReviewCodeUpdateEmail
      txnReviewNoteUpdateSms
      txnReviewNoteUpdateEmail
      txnReviewReceiptUpdateSms
      txnReviewReceiptUpdateEmail
      txnReviewResubmissionSms
      txnReviewResubmissionEmail
      txnReviewReadySms
      txnReviewReadyEmail
      returnedTransactionSms
      returnedTransactionEmail
      smsConsentAccepted
      smsConsentAcceptedAt
      platformAgreementVersion
      hasReceivedWelcomeSms
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserNotificationPreferencesQueryVariables,
  APITypes.ListUserNotificationPreferencesQuery
>;
export const getMerchantSpendRule = /* GraphQL */ `query GetMerchantSpendRule($id: ID!) {
  getMerchantSpendRule(id: $id) {
    id
    paidolId
    authPaidolId
    name
    paymentCards
    merchantCountrySpendRuleId
    merchantCategorySpendRuleId
    amountLimitSpendRuleId
    monthlyLimitSpendRuleId
    monthlyLimitCumulativeRuleId
    maximumAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    monthlyLimitAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    merchantCategoryAllowed
    merchantCategoryBlocked
    merchantCountryAllowed
    merchantCountryBlocked
    monthlyLimitResetTimestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMerchantSpendRuleQueryVariables,
  APITypes.GetMerchantSpendRuleQuery
>;
export const listMerchantSpendRules = /* GraphQL */ `query ListMerchantSpendRules(
  $id: ID
  $filter: ModelMerchantSpendRuleFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listMerchantSpendRules(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      paymentCards
      merchantCountrySpendRuleId
      merchantCategorySpendRuleId
      amountLimitSpendRuleId
      monthlyLimitSpendRuleId
      monthlyLimitCumulativeRuleId
      merchantCategoryAllowed
      merchantCategoryBlocked
      merchantCountryAllowed
      merchantCountryBlocked
      monthlyLimitResetTimestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMerchantSpendRulesQueryVariables,
  APITypes.ListMerchantSpendRulesQuery
>;
export const listMerchantSpendRulesByPaidolId = /* GraphQL */ `query ListMerchantSpendRulesByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelMerchantSpendRuleFilterInput
  $limit: Int
  $nextToken: String
) {
  listMerchantSpendRulesByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      paymentCards
      merchantCountrySpendRuleId
      merchantCategorySpendRuleId
      amountLimitSpendRuleId
      monthlyLimitSpendRuleId
      monthlyLimitCumulativeRuleId
      merchantCategoryAllowed
      merchantCategoryBlocked
      merchantCountryAllowed
      merchantCountryBlocked
      monthlyLimitResetTimestamp
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMerchantSpendRulesByPaidolIdQueryVariables,
  APITypes.ListMerchantSpendRulesByPaidolIdQuery
>;
export const getTransactionsDownloadQueue = /* GraphQL */ `query GetTransactionsDownloadQueue($id: ID!) {
  getTransactionsDownloadQueue(id: $id) {
    id
    user_id
    paidol_id
    range_option
    start_date
    end_date
    columns
    s3_key
    cron_status
    createdAt
    paidolUserId
    mark_as_exported
    exported_count
    skipped_count
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTransactionsDownloadQueueQueryVariables,
  APITypes.GetTransactionsDownloadQueueQuery
>;
export const listTransactionsDownloadQueues = /* GraphQL */ `query ListTransactionsDownloadQueues(
  $filter: ModelTransactionsDownloadQueueFilterInput
  $limit: Int
  $nextToken: String
) {
  listTransactionsDownloadQueues(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      user_id
      paidol_id
      range_option
      start_date
      end_date
      columns
      s3_key
      cron_status
      createdAt
      paidolUserId
      mark_as_exported
      exported_count
      skipped_count
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTransactionsDownloadQueuesQueryVariables,
  APITypes.ListTransactionsDownloadQueuesQuery
>;
export const transactionsDownloadByPaidolId = /* GraphQL */ `query TransactionsDownloadByPaidolId(
  $paidol_id: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTransactionsDownloadQueueFilterInput
  $limit: Int
  $nextToken: String
) {
  transactionsDownloadByPaidolId(
    paidol_id: $paidol_id
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      user_id
      paidol_id
      range_option
      start_date
      end_date
      columns
      s3_key
      cron_status
      createdAt
      paidolUserId
      mark_as_exported
      exported_count
      skipped_count
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TransactionsDownloadByPaidolIdQueryVariables,
  APITypes.TransactionsDownloadByPaidolIdQuery
>;
export const getTransactionsReceiptsDownloadQueue = /* GraphQL */ `query GetTransactionsReceiptsDownloadQueue($id: ID!) {
  getTransactionsReceiptsDownloadQueue(id: $id) {
    id
    user_id
    paidol_id
    paidolUserId
    s3_key
    range_option
    start_date
    end_date
    cron_status
    error_code
    createdAt
    filteredTransactionIds
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTransactionsReceiptsDownloadQueueQueryVariables,
  APITypes.GetTransactionsReceiptsDownloadQueueQuery
>;
export const listTransactionsReceiptsDownloadQueues = /* GraphQL */ `query ListTransactionsReceiptsDownloadQueues(
  $filter: ModelTransactionsReceiptsDownloadQueueFilterInput
  $limit: Int
  $nextToken: String
) {
  listTransactionsReceiptsDownloadQueues(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      user_id
      paidol_id
      paidolUserId
      s3_key
      range_option
      start_date
      end_date
      cron_status
      error_code
      createdAt
      filteredTransactionIds
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTransactionsReceiptsDownloadQueuesQueryVariables,
  APITypes.ListTransactionsReceiptsDownloadQueuesQuery
>;
export const transactionsReceiptsDownloadByPaidolId = /* GraphQL */ `query TransactionsReceiptsDownloadByPaidolId(
  $paidol_id: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTransactionsReceiptsDownloadQueueFilterInput
  $limit: Int
  $nextToken: String
) {
  transactionsReceiptsDownloadByPaidolId(
    paidol_id: $paidol_id
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      user_id
      paidol_id
      paidolUserId
      s3_key
      range_option
      start_date
      end_date
      cron_status
      error_code
      createdAt
      filteredTransactionIds
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TransactionsReceiptsDownloadByPaidolIdQueryVariables,
  APITypes.TransactionsReceiptsDownloadByPaidolIdQuery
>;
export const getSpendRuleConfig = /* GraphQL */ `query GetSpendRuleConfig($id: ID!) {
  getSpendRuleConfig(id: $id) {
    id
    paidolId
    authPaidolId
    ruleId
    ruleType
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSpendRuleConfigQueryVariables,
  APITypes.GetSpendRuleConfigQuery
>;
export const listSpendRuleConfigs = /* GraphQL */ `query ListSpendRuleConfigs(
  $id: ID
  $filter: ModelSpendRuleConfigFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSpendRuleConfigs(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      ruleId
      ruleType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSpendRuleConfigsQueryVariables,
  APITypes.ListSpendRuleConfigsQuery
>;
export const listSpendRulesConfigByPaidolId = /* GraphQL */ `query ListSpendRulesConfigByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSpendRuleConfigFilterInput
  $limit: Int
  $nextToken: String
) {
  listSpendRulesConfigByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      ruleId
      ruleType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSpendRulesConfigByPaidolIdQueryVariables,
  APITypes.ListSpendRulesConfigByPaidolIdQuery
>;
export const getJobCodeImport = /* GraphQL */ `query GetJobCodeImport($id: ID!) {
  getJobCodeImport(id: $id) {
    id
    paidolId
    authPaidolId
    createdAt
    storageFileKey
    fileName
    status
    errors
    jobCodes {
      nextToken
      __typename
    }
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetJobCodeImportQueryVariables,
  APITypes.GetJobCodeImportQuery
>;
export const listJobCodeImports = /* GraphQL */ `query ListJobCodeImports(
  $id: ID
  $filter: ModelJobCodeImportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listJobCodeImports(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      createdAt
      storageFileKey
      fileName
      status
      errors
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListJobCodeImportsQueryVariables,
  APITypes.ListJobCodeImportsQuery
>;
export const jobCodeImportByPaidolId = /* GraphQL */ `query JobCodeImportByPaidolId(
  $paidolId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelJobCodeImportFilterInput
  $limit: Int
  $nextToken: String
) {
  jobCodeImportByPaidolId(
    paidolId: $paidolId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      createdAt
      storageFileKey
      fileName
      status
      errors
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.JobCodeImportByPaidolIdQueryVariables,
  APITypes.JobCodeImportByPaidolIdQuery
>;
export const getJobCode = /* GraphQL */ `query GetJobCode($id: ID!) {
  getJobCode(id: $id) {
    id
    paidolId
    authPaidolId
    description
    code
    isActive
    budget
    jobCodeImportId
    jobCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      storageFileKey
      fileName
      status
      errors
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetJobCodeQueryVariables,
  APITypes.GetJobCodeQuery
>;
export const listJobCodes = /* GraphQL */ `query ListJobCodes(
  $id: ID
  $filter: ModelJobCodeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listJobCodes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      description
      code
      isActive
      budget
      jobCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListJobCodesQueryVariables,
  APITypes.ListJobCodesQuery
>;
export const jobCodeByJobCodeImportId = /* GraphQL */ `query JobCodeByJobCodeImportId(
  $jobCodeImportId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelJobCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  jobCodeByJobCodeImportId(
    jobCodeImportId: $jobCodeImportId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      description
      code
      isActive
      budget
      jobCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.JobCodeByJobCodeImportIdQueryVariables,
  APITypes.JobCodeByJobCodeImportIdQuery
>;
export const getFlexCodeImport = /* GraphQL */ `query GetFlexCodeImport($id: ID!) {
  getFlexCodeImport(id: $id) {
    id
    paidolId
    authPaidolId
    createdAt
    updatedAt
    storageFileKey
    fileName
    status
    errors
    searchSynced
    flexCodes {
      nextToken
      __typename
    }
    type
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFlexCodeImportQueryVariables,
  APITypes.GetFlexCodeImportQuery
>;
export const listFlexCodeImports = /* GraphQL */ `query ListFlexCodeImports(
  $id: ID
  $filter: ModelFlexCodeImportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listFlexCodeImports(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFlexCodeImportsQueryVariables,
  APITypes.ListFlexCodeImportsQuery
>;
export const flexCodeImportByPaidolId = /* GraphQL */ `query FlexCodeImportByPaidolId(
  $paidolId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFlexCodeImportFilterInput
  $limit: Int
  $nextToken: String
) {
  flexCodeImportByPaidolId(
    paidolId: $paidolId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FlexCodeImportByPaidolIdQueryVariables,
  APITypes.FlexCodeImportByPaidolIdQuery
>;
export const getFlexTransactionExport = /* GraphQL */ `query GetFlexTransactionExport($id: ID!) {
  getFlexTransactionExport(id: $id) {
    id
    paidolId
    authPaidolId
    createdAt
    updatedAt
    fileName
    s3Key
    transactionCount
    baselineTransactionCount
    firstEventDate
    lastEventDate
    status
    errors
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFlexTransactionExportQueryVariables,
  APITypes.GetFlexTransactionExportQuery
>;
export const listFlexTransactionExports = /* GraphQL */ `query ListFlexTransactionExports(
  $id: ID
  $filter: ModelFlexTransactionExportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listFlexTransactionExports(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      fileName
      s3Key
      transactionCount
      baselineTransactionCount
      firstEventDate
      lastEventDate
      status
      errors
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFlexTransactionExportsQueryVariables,
  APITypes.ListFlexTransactionExportsQuery
>;
export const flexTransactionExportByPaidolId = /* GraphQL */ `query FlexTransactionExportByPaidolId(
  $paidolId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFlexTransactionExportFilterInput
  $limit: Int
  $nextToken: String
) {
  flexTransactionExportByPaidolId(
    paidolId: $paidolId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      fileName
      s3Key
      transactionCount
      baselineTransactionCount
      firstEventDate
      lastEventDate
      status
      errors
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FlexTransactionExportByPaidolIdQueryVariables,
  APITypes.FlexTransactionExportByPaidolIdQuery
>;
export const getV2FlexRelationships = /* GraphQL */ `query GetV2FlexRelationships($id: ID!) {
  getV2FlexRelationships(id: $id) {
    id
    paidolId
    authPaidolId
    flexGlCodeId
    flexCodeId
    flexCostCodeId
    flexCostTypeId
    flexVendorId
    flexCodeImportId
    flexGlCodeName
    projectName
    projectCode
    flexCostCodeName
    flexCostTypeName
    flexVendorName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetV2FlexRelationshipsQueryVariables,
  APITypes.GetV2FlexRelationshipsQuery
>;
export const listV2FlexRelationships = /* GraphQL */ `query ListV2FlexRelationships(
  $id: ID
  $filter: ModelV2FlexRelationshipsFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listV2FlexRelationships(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      flexGlCodeId
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexVendorId
      flexCodeImportId
      flexGlCodeName
      projectName
      projectCode
      flexCostCodeName
      flexCostTypeName
      flexVendorName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListV2FlexRelationshipsQueryVariables,
  APITypes.ListV2FlexRelationshipsQuery
>;
export const listFlexRelationshipsByPaidolId = /* GraphQL */ `query ListFlexRelationshipsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelV2FlexRelationshipsFilterInput
  $limit: Int
  $nextToken: String
) {
  listFlexRelationshipsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      flexGlCodeId
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexVendorId
      flexCodeImportId
      flexGlCodeName
      projectName
      projectCode
      flexCostCodeName
      flexCostTypeName
      flexVendorName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFlexRelationshipsByPaidolIdQueryVariables,
  APITypes.ListFlexRelationshipsByPaidolIdQuery
>;
export const flexRelationshipsByFlexCodeImportId = /* GraphQL */ `query FlexRelationshipsByFlexCodeImportId(
  $flexCodeImportId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelV2FlexRelationshipsFilterInput
  $limit: Int
  $nextToken: String
) {
  flexRelationshipsByFlexCodeImportId(
    flexCodeImportId: $flexCodeImportId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      flexGlCodeId
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexVendorId
      flexCodeImportId
      flexGlCodeName
      projectName
      projectCode
      flexCostCodeName
      flexCostTypeName
      flexVendorName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FlexRelationshipsByFlexCodeImportIdQueryVariables,
  APITypes.FlexRelationshipsByFlexCodeImportIdQuery
>;
export const searchV2FlexRelationships = /* GraphQL */ `query SearchV2FlexRelationships(
  $filter: SearchableV2FlexRelationshipsFilterInput
  $sort: [SearchableV2FlexRelationshipsSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableV2FlexRelationshipsAggregationInput]
) {
  searchV2FlexRelationships(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      paidolId
      authPaidolId
      flexGlCodeId
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexVendorId
      flexCodeImportId
      flexGlCodeName
      projectName
      projectCode
      flexCostCodeName
      flexCostTypeName
      flexVendorName
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchV2FlexRelationshipsQueryVariables,
  APITypes.SearchV2FlexRelationshipsQuery
>;
export const getFlexGlCode = /* GraphQL */ `query GetFlexGlCode($id: ID!) {
  getFlexGlCode(id: $id) {
    id
    paidolId
    authPaidolId
    name
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFlexGlCodeQueryVariables,
  APITypes.GetFlexGlCodeQuery
>;
export const listFlexGlCodes = /* GraphQL */ `query ListFlexGlCodes(
  $id: ID
  $filter: ModelFlexGlCodeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listFlexGlCodes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFlexGlCodesQueryVariables,
  APITypes.ListFlexGlCodesQuery
>;
export const listFlexGlCodeByPaidolId = /* GraphQL */ `query ListFlexGlCodeByPaidolId(
  $paidolId: ID!
  $name: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFlexGlCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listFlexGlCodeByPaidolId(
    paidolId: $paidolId
    name: $name
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFlexGlCodeByPaidolIdQueryVariables,
  APITypes.ListFlexGlCodeByPaidolIdQuery
>;
export const flexGlCodeByFlexCodeImportId = /* GraphQL */ `query FlexGlCodeByFlexCodeImportId(
  $flexCodeImportId: ID!
  $name: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFlexGlCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  flexGlCodeByFlexCodeImportId(
    flexCodeImportId: $flexCodeImportId
    name: $name
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FlexGlCodeByFlexCodeImportIdQueryVariables,
  APITypes.FlexGlCodeByFlexCodeImportIdQuery
>;
export const searchFlexGlCodes = /* GraphQL */ `query SearchFlexGlCodes(
  $filter: SearchableFlexGlCodeFilterInput
  $sort: [SearchableFlexGlCodeSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableFlexGlCodeAggregationInput]
) {
  searchFlexGlCodes(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchFlexGlCodesQueryVariables,
  APITypes.SearchFlexGlCodesQuery
>;
export const getFlexCode = /* GraphQL */ `query GetFlexCode($id: ID!) {
  getFlexCode(id: $id) {
    id
    paidolId
    authPaidolId
    projectName
    projectCode
    isActive
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFlexCodeQueryVariables,
  APITypes.GetFlexCodeQuery
>;
export const listFlexCodes = /* GraphQL */ `query ListFlexCodes(
  $id: ID
  $filter: ModelFlexCodeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listFlexCodes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectName
      projectCode
      isActive
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFlexCodesQueryVariables,
  APITypes.ListFlexCodesQuery
>;
export const listFlexCodesByPaidolId = /* GraphQL */ `query ListFlexCodesByPaidolId(
  $paidolId: ID!
  $projectName: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFlexCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listFlexCodesByPaidolId(
    paidolId: $paidolId
    projectName: $projectName
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectName
      projectCode
      isActive
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFlexCodesByPaidolIdQueryVariables,
  APITypes.ListFlexCodesByPaidolIdQuery
>;
export const flexCodesByFlexCodeImportId = /* GraphQL */ `query FlexCodesByFlexCodeImportId(
  $flexCodeImportId: ID!
  $projectName: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFlexCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  flexCodesByFlexCodeImportId(
    flexCodeImportId: $flexCodeImportId
    projectName: $projectName
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectName
      projectCode
      isActive
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FlexCodesByFlexCodeImportIdQueryVariables,
  APITypes.FlexCodesByFlexCodeImportIdQuery
>;
export const searchFlexCodes = /* GraphQL */ `query SearchFlexCodes(
  $filter: SearchableFlexCodeFilterInput
  $sort: [SearchableFlexCodeSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableFlexCodeAggregationInput]
) {
  searchFlexCodes(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      paidolId
      authPaidolId
      projectName
      projectCode
      isActive
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchFlexCodesQueryVariables,
  APITypes.SearchFlexCodesQuery
>;
export const getFlexCostCode = /* GraphQL */ `query GetFlexCostCode($id: ID!) {
  getFlexCostCode(id: $id) {
    id
    paidolId
    authPaidolId
    code
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFlexCostCodeQueryVariables,
  APITypes.GetFlexCostCodeQuery
>;
export const listFlexCostCodes = /* GraphQL */ `query ListFlexCostCodes(
  $id: ID
  $filter: ModelFlexCostCodeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listFlexCostCodes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      code
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFlexCostCodesQueryVariables,
  APITypes.ListFlexCostCodesQuery
>;
export const listFlexCostCodesByPaidolId = /* GraphQL */ `query ListFlexCostCodesByPaidolId(
  $paidolId: ID!
  $code: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFlexCostCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listFlexCostCodesByPaidolId(
    paidolId: $paidolId
    code: $code
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      code
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFlexCostCodesByPaidolIdQueryVariables,
  APITypes.ListFlexCostCodesByPaidolIdQuery
>;
export const flexCostCodesByFlexCodeImportId = /* GraphQL */ `query FlexCostCodesByFlexCodeImportId(
  $flexCodeImportId: ID!
  $code: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFlexCostCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  flexCostCodesByFlexCodeImportId(
    flexCodeImportId: $flexCodeImportId
    code: $code
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      code
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FlexCostCodesByFlexCodeImportIdQueryVariables,
  APITypes.FlexCostCodesByFlexCodeImportIdQuery
>;
export const searchFlexCostCodes = /* GraphQL */ `query SearchFlexCostCodes(
  $filter: SearchableFlexCostCodeFilterInput
  $sort: [SearchableFlexCostCodeSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableFlexCostCodeAggregationInput]
) {
  searchFlexCostCodes(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      paidolId
      authPaidolId
      code
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchFlexCostCodesQueryVariables,
  APITypes.SearchFlexCostCodesQuery
>;
export const getFlexCostType = /* GraphQL */ `query GetFlexCostType($id: ID!) {
  getFlexCostType(id: $id) {
    id
    paidolId
    authPaidolId
    name
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFlexCostTypeQueryVariables,
  APITypes.GetFlexCostTypeQuery
>;
export const listFlexCostTypes = /* GraphQL */ `query ListFlexCostTypes(
  $id: ID
  $filter: ModelFlexCostTypeFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listFlexCostTypes(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFlexCostTypesQueryVariables,
  APITypes.ListFlexCostTypesQuery
>;
export const listFlexCostTypesByPaidolId = /* GraphQL */ `query ListFlexCostTypesByPaidolId(
  $paidolId: ID!
  $name: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFlexCostTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  listFlexCostTypesByPaidolId(
    paidolId: $paidolId
    name: $name
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFlexCostTypesByPaidolIdQueryVariables,
  APITypes.ListFlexCostTypesByPaidolIdQuery
>;
export const flexCostTypesByFlexCodeImportId = /* GraphQL */ `query FlexCostTypesByFlexCodeImportId(
  $flexCodeImportId: ID!
  $name: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFlexCostTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  flexCostTypesByFlexCodeImportId(
    flexCodeImportId: $flexCodeImportId
    name: $name
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FlexCostTypesByFlexCodeImportIdQueryVariables,
  APITypes.FlexCostTypesByFlexCodeImportIdQuery
>;
export const searchFlexCostTypes = /* GraphQL */ `query SearchFlexCostTypes(
  $filter: SearchableFlexCostTypeFilterInput
  $sort: [SearchableFlexCostTypeSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableFlexCostTypeAggregationInput]
) {
  searchFlexCostTypes(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchFlexCostTypesQueryVariables,
  APITypes.SearchFlexCostTypesQuery
>;
export const getFlexVendor = /* GraphQL */ `query GetFlexVendor($id: ID!) {
  getFlexVendor(id: $id) {
    id
    paidolId
    authPaidolId
    name
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFlexVendorQueryVariables,
  APITypes.GetFlexVendorQuery
>;
export const listFlexVendors = /* GraphQL */ `query ListFlexVendors(
  $id: ID
  $filter: ModelFlexVendorFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listFlexVendors(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFlexVendorsQueryVariables,
  APITypes.ListFlexVendorsQuery
>;
export const listFlexVendorsByPaidolId = /* GraphQL */ `query ListFlexVendorsByPaidolId(
  $paidolId: ID!
  $name: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFlexVendorFilterInput
  $limit: Int
  $nextToken: String
) {
  listFlexVendorsByPaidolId(
    paidolId: $paidolId
    name: $name
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFlexVendorsByPaidolIdQueryVariables,
  APITypes.ListFlexVendorsByPaidolIdQuery
>;
export const flexVendorsByFlexCodeImportId = /* GraphQL */ `query FlexVendorsByFlexCodeImportId(
  $flexCodeImportId: ID!
  $name: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFlexVendorFilterInput
  $limit: Int
  $nextToken: String
) {
  flexVendorsByFlexCodeImportId(
    flexCodeImportId: $flexCodeImportId
    name: $name
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FlexVendorsByFlexCodeImportIdQueryVariables,
  APITypes.FlexVendorsByFlexCodeImportIdQuery
>;
export const searchFlexVendors = /* GraphQL */ `query SearchFlexVendors(
  $filter: SearchableFlexVendorFilterInput
  $sort: [SearchableFlexVendorSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableFlexVendorAggregationInput]
) {
  searchFlexVendors(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchFlexVendorsQueryVariables,
  APITypes.SearchFlexVendorsQuery
>;
export const getFlexField = /* GraphQL */ `query GetFlexField($id: ID!) {
  getFlexField(id: $id) {
    id
    paidolId
    authPaidolId
    name
    alias
    order
    source
    createdBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFlexFieldQueryVariables,
  APITypes.GetFlexFieldQuery
>;
export const listFlexFields = /* GraphQL */ `query ListFlexFields(
  $id: ID
  $filter: ModelFlexFieldFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listFlexFields(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      alias
      order
      source
      createdBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFlexFieldsQueryVariables,
  APITypes.ListFlexFieldsQuery
>;
export const flexFieldsByPaidolId = /* GraphQL */ `query FlexFieldsByPaidolId(
  $paidolId: ID!
  $name: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFlexFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  flexFieldsByPaidolId(
    paidolId: $paidolId
    name: $name
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      alias
      order
      source
      createdBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FlexFieldsByPaidolIdQueryVariables,
  APITypes.FlexFieldsByPaidolIdQuery
>;
export const searchFlexFields = /* GraphQL */ `query SearchFlexFields(
  $filter: SearchableFlexFieldFilterInput
  $sort: [SearchableFlexFieldSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableFlexFieldAggregationInput]
) {
  searchFlexFields(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      paidolId
      authPaidolId
      name
      alias
      order
      source
      createdBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchFlexFieldsQueryVariables,
  APITypes.SearchFlexFieldsQuery
>;
export const getFlexFieldValue = /* GraphQL */ `query GetFlexFieldValue($id: ID!) {
  getFlexFieldValue(id: $id) {
    id
    paidolId
    authPaidolId
    flexFieldId
    externalId
    value
    status
    flexFieldUploadId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFlexFieldValueQueryVariables,
  APITypes.GetFlexFieldValueQuery
>;
export const listFlexFieldValues = /* GraphQL */ `query ListFlexFieldValues(
  $id: ID
  $filter: ModelFlexFieldValueFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listFlexFieldValues(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      flexFieldId
      externalId
      value
      status
      flexFieldUploadId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFlexFieldValuesQueryVariables,
  APITypes.ListFlexFieldValuesQuery
>;
export const listFlexFieldValuesByPaidolId = /* GraphQL */ `query ListFlexFieldValuesByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelFlexFieldValueFilterInput
  $limit: Int
  $nextToken: String
) {
  listFlexFieldValuesByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      flexFieldId
      externalId
      value
      status
      flexFieldUploadId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFlexFieldValuesByPaidolIdQueryVariables,
  APITypes.ListFlexFieldValuesByPaidolIdQuery
>;
export const flexFieldValuesByFlexFieldId = /* GraphQL */ `query FlexFieldValuesByFlexFieldId(
  $flexFieldId: ID!
  $value: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFlexFieldValueFilterInput
  $limit: Int
  $nextToken: String
) {
  flexFieldValuesByFlexFieldId(
    flexFieldId: $flexFieldId
    value: $value
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      flexFieldId
      externalId
      value
      status
      flexFieldUploadId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FlexFieldValuesByFlexFieldIdQueryVariables,
  APITypes.FlexFieldValuesByFlexFieldIdQuery
>;
export const flexFieldValuesByUploadId = /* GraphQL */ `query FlexFieldValuesByUploadId(
  $flexFieldUploadId: ID!
  $value: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFlexFieldValueFilterInput
  $limit: Int
  $nextToken: String
) {
  flexFieldValuesByUploadId(
    flexFieldUploadId: $flexFieldUploadId
    value: $value
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      flexFieldId
      externalId
      value
      status
      flexFieldUploadId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FlexFieldValuesByUploadIdQueryVariables,
  APITypes.FlexFieldValuesByUploadIdQuery
>;
export const searchFlexFieldValues = /* GraphQL */ `query SearchFlexFieldValues(
  $filter: SearchableFlexFieldValueFilterInput
  $sort: [SearchableFlexFieldValueSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableFlexFieldValueAggregationInput]
) {
  searchFlexFieldValues(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      paidolId
      authPaidolId
      flexFieldId
      externalId
      value
      status
      flexFieldUploadId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchFlexFieldValuesQueryVariables,
  APITypes.SearchFlexFieldValuesQuery
>;
export const getFlexFieldUpload = /* GraphQL */ `query GetFlexFieldUpload($id: ID!) {
  getFlexFieldUpload(id: $id) {
    id
    paidolId
    authPaidolId
    flexFieldId
    storageFileKey
    fileName
    status
    errors
    rowCount
    createdBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFlexFieldUploadQueryVariables,
  APITypes.GetFlexFieldUploadQuery
>;
export const listFlexFieldUploads = /* GraphQL */ `query ListFlexFieldUploads(
  $id: ID
  $filter: ModelFlexFieldUploadFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listFlexFieldUploads(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      flexFieldId
      storageFileKey
      fileName
      status
      errors
      rowCount
      createdBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFlexFieldUploadsQueryVariables,
  APITypes.ListFlexFieldUploadsQuery
>;
export const flexFieldUploadsByPaidolId = /* GraphQL */ `query FlexFieldUploadsByPaidolId(
  $paidolId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFlexFieldUploadFilterInput
  $limit: Int
  $nextToken: String
) {
  flexFieldUploadsByPaidolId(
    paidolId: $paidolId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      flexFieldId
      storageFileKey
      fileName
      status
      errors
      rowCount
      createdBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FlexFieldUploadsByPaidolIdQueryVariables,
  APITypes.FlexFieldUploadsByPaidolIdQuery
>;
export const flexFieldUploadsByFlexFieldId = /* GraphQL */ `query FlexFieldUploadsByFlexFieldId(
  $flexFieldId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelFlexFieldUploadFilterInput
  $limit: Int
  $nextToken: String
) {
  flexFieldUploadsByFlexFieldId(
    flexFieldId: $flexFieldId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      flexFieldId
      storageFileKey
      fileName
      status
      errors
      rowCount
      createdBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FlexFieldUploadsByFlexFieldIdQueryVariables,
  APITypes.FlexFieldUploadsByFlexFieldIdQuery
>;
export const getStatementSummary = /* GraphQL */ `query GetStatementSummary($id: ID!) {
  getStatementSummary(id: $id) {
    id
    paidolId
    authPaidolId
    startDate
    endDate
    statementBalance
    paymentDueDate
    pdfLink
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetStatementSummaryQueryVariables,
  APITypes.GetStatementSummaryQuery
>;
export const listStatementSummaries = /* GraphQL */ `query ListStatementSummaries(
  $id: ID
  $filter: ModelStatementSummaryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listStatementSummaries(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      startDate
      endDate
      statementBalance
      paymentDueDate
      pdfLink
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStatementSummariesQueryVariables,
  APITypes.ListStatementSummariesQuery
>;
export const listStatementSummariesByPaidolId = /* GraphQL */ `query ListStatementSummariesByPaidolId(
  $paidolId: ID!
  $startDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelStatementSummaryFilterInput
  $limit: Int
  $nextToken: String
) {
  listStatementSummariesByPaidolId(
    paidolId: $paidolId
    startDate: $startDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      startDate
      endDate
      statementBalance
      paymentDueDate
      pdfLink
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStatementSummariesByPaidolIdQueryVariables,
  APITypes.ListStatementSummariesByPaidolIdQuery
>;
export const getAutoPayment = /* GraphQL */ `query GetAutoPayment($id: ID!) {
  getAutoPayment(id: $id) {
    id
    paidolId
    authPaidolId
    amountType
    fixedAmountCents
    paymentDayOfMonth
    externalBankAccountId
    financialAccountId
    active
    createdBy
    updatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAutoPaymentQueryVariables,
  APITypes.GetAutoPaymentQuery
>;
export const listAutoPayments = /* GraphQL */ `query ListAutoPayments(
  $id: ID
  $filter: ModelAutoPaymentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAutoPayments(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      amountType
      fixedAmountCents
      paymentDayOfMonth
      externalBankAccountId
      financialAccountId
      active
      createdBy
      updatedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAutoPaymentsQueryVariables,
  APITypes.ListAutoPaymentsQuery
>;
export const listAutoPaymentsByPaidolId = /* GraphQL */ `query ListAutoPaymentsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelAutoPaymentFilterInput
  $limit: Int
  $nextToken: String
) {
  listAutoPaymentsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      amountType
      fixedAmountCents
      paymentDayOfMonth
      externalBankAccountId
      financialAccountId
      active
      createdBy
      updatedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAutoPaymentsByPaidolIdQueryVariables,
  APITypes.ListAutoPaymentsByPaidolIdQuery
>;
export const getTransactionFilterOptions = /* GraphQL */ `query GetTransactionFilterOptions($paidolId: ID!) {
  getTransactionFilterOptions(paidolId: $paidolId) {
    paidolId
    authPaidolId
    last4
    userId {
      id
      label
      projectId
      __typename
    }
    merchantName {
      id
      label
      projectId
      __typename
    }
    merchantCategory {
      id
      label
      projectId
      __typename
    }
    cardGroup {
      id
      label
      projectId
      __typename
    }
    projectGroup {
      id
      label
      projectId
      __typename
    }
    receiptStatus {
      id
      label
      projectId
      __typename
    }
    highnoteTransactionStatus {
      id
      label
      projectId
      __typename
    }
    flexCodeTransactionStatus {
      id
      label
      projectId
      __typename
    }
    flexGlCodeIds {
      id
      label
      projectId
      __typename
    }
    flexCodeIds {
      id
      label
      projectId
      __typename
    }
    flexCostCodeIds {
      id
      label
      projectId
      __typename
    }
    flexCostTypeIds {
      id
      label
      projectId
      __typename
    }
    flexVendorIds {
      id
      label
      projectId
      __typename
    }
    agaveTransactionStatus {
      id
      label
      projectId
      __typename
    }
    agaveGlCodeIds {
      id
      label
      projectId
      __typename
    }
    agaveProjectIds {
      id
      label
      projectId
      __typename
    }
    agaveCostCodeIds {
      id
      label
      projectId
      __typename
    }
    agaveCostTypeIds {
      id
      label
      projectId
      __typename
    }
    agaveVendorIds {
      id
      label
      projectId
      __typename
    }
    agaveLocationIds {
      id
      label
      projectId
      __typename
    }
    agaveDepartmentIds {
      id
      label
      projectId
      __typename
    }
    agaveSubaccountIds {
      id
      label
      projectId
      __typename
    }
    agaveSubJobIds {
      id
      label
      projectId
      __typename
    }
    agaveEquipmentIds {
      id
      label
      projectId
      __typename
    }
    agaveEmCostCodeIds {
      id
      label
      projectId
      __typename
    }
    agaveEmCostTypeIds {
      id
      label
      projectId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTransactionFilterOptionsQueryVariables,
  APITypes.GetTransactionFilterOptionsQuery
>;
export const listTransactionFilterOptions = /* GraphQL */ `query ListTransactionFilterOptions(
  $paidolId: ID
  $filter: ModelTransactionFilterOptionsFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTransactionFilterOptions(
    paidolId: $paidolId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      paidolId
      authPaidolId
      last4
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTransactionFilterOptionsQueryVariables,
  APITypes.ListTransactionFilterOptionsQuery
>;
export const getHighnoteDisputeEvent = /* GraphQL */ `query GetHighnoteDisputeEvent($id: ID!) {
  getHighnoteDisputeEvent(id: $id) {
    id
    disputeId
    paidolId
    paymentCardId
    transactionEventId
    amount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    enableListing
    status
    creditStatus
    category
    liability
    eventType
    eventDate
    source
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetHighnoteDisputeEventQueryVariables,
  APITypes.GetHighnoteDisputeEventQuery
>;
export const listHighnoteDisputeEvents = /* GraphQL */ `query ListHighnoteDisputeEvents(
  $id: ID
  $filter: ModelHighnoteDisputeEventFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listHighnoteDisputeEvents(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      disputeId
      paidolId
      paymentCardId
      transactionEventId
      enableListing
      status
      creditStatus
      category
      liability
      eventType
      eventDate
      source
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHighnoteDisputeEventsQueryVariables,
  APITypes.ListHighnoteDisputeEventsQuery
>;
export const listHighnoteDisputeEventsByPaidolId = /* GraphQL */ `query ListHighnoteDisputeEventsByPaidolId(
  $paidolId: ID!
  $eventDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelHighnoteDisputeEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listHighnoteDisputeEventsByPaidolId(
    paidolId: $paidolId
    eventDate: $eventDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      disputeId
      paidolId
      paymentCardId
      transactionEventId
      enableListing
      status
      creditStatus
      category
      liability
      eventType
      eventDate
      source
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHighnoteDisputeEventsByPaidolIdQueryVariables,
  APITypes.ListHighnoteDisputeEventsByPaidolIdQuery
>;
export const getHighnoteTransactionEvent = /* GraphQL */ `query GetHighnoteTransactionEvent($id: ID!) {
  getHighnoteTransactionEvent(id: $id) {
    id
    transactionId
    transaction {
      transactionId
      paymentCardId
      paidolId
      authPaidolId
      cardGroupId
      status
      transactionDate
      merchantName
      merchantCategoryCode
      merchantCategory
      transactionEvents
      note
      jobCodeId
      procoreCompanyId
      procoreProjectId
      procoreWBSCodeId
      procoreDirectCostId
      procoreDirectCostLineItemId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveExpenseId
      agaveVendorId
      agaveGlCodeId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      receiptPath
      receiptId
      erpApprovalStatus
      erpBypassStatus
      last4
      userId
      email
      approvedAmountValue
      approvedAmountCurrencyCode
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      selectedCodingOption
      agaveGlCostTypeId
      flexCodeTransactionStatus
      approveWithoutNotes
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      createdAt
      updatedAt
      __typename
    }
    paymentCardId
    paymentCard {
      paymentCardId
      paidolId
      authPaidolId
      name
      cardGroupId
      status
      bin
      last4
      network
      formFactor
      expirationDate
      hasPin
      cardholderId
      cardholderName
      isAdminLocked
      lastActionByRole
      lastActionByPaidolUserId
      lastActionByName
      lastActionByEmail
      lastActionAt
      merchantSpendRuleId
      isAuthorizedUserCard
      createdAt
      updatedAt
      __typename
    }
    paidolId
    reconciliationId
    authPaidolId
    eventDate
    processedAt
    origin
    status
    partial
    settlementImpact
    approvedAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    fees {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    approvedAmountValue
    approvedAmountCurrencyCode
    eventData
    transactionOldState
    transactionNewState
    enableListing
    email
    userId
    user {
      id
      username
      email
      first_name
      middle_name
      last_name
      suffix
      picture
      is_speedster
      birthdate
      address
      phone_number
      phone_extension
      password_updated_at
      finicityCustomerId
      dwollaCustomerId
      is_support
      deletedAt
      createdAt
      updatedAt
      __typename
    }
    last4
    card {
      paymentCardId
      paidolId
      authPaidolId
      name
      cardGroupId
      status
      bin
      last4
      network
      formFactor
      expirationDate
      hasPin
      cardholderId
      cardholderName
      isAdminLocked
      lastActionByRole
      lastActionByPaidolUserId
      lastActionByName
      lastActionByEmail
      lastActionAt
      merchantSpendRuleId
      isAuthorizedUserCard
      createdAt
      updatedAt
      __typename
    }
    groupApprovalLevels
    owningProjectGroupIds
    cardGroupId
    cardGroup {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    merchantCategory
    merchantCategoryCode
    merchantName
    jobCodeId
    jobCode {
      id
      paidolId
      authPaidolId
      description
      code
      isActive
      budget
      jobCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCodeTransactionStatus
    workflowStatus
    returnedStatus
    flexCodeId
    flexCode {
      id
      paidolId
      authPaidolId
      projectName
      projectCode
      isActive
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostCodeId
    flexCostCode {
      id
      paidolId
      authPaidolId
      code
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostTypeId
    flexCostType {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexGlCodeId
    flexGlCode {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexVendorId
    flexVendor {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    agaveDepartment {
      id
      paidolId
      authPaidolId
      code
      name
      fullName
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveDepartmentId
    agaveLocation {
      id
      paidolId
      authPaidolId
      name
      fullName
      parent_id
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveLocationId
    agaveSubaccount {
      id
      paidolId
      authPaidolId
      code
      name
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveSubaccountId
    agaveEmployee {
      id
      paidolId
      authPaidolId
      name
      fullName
      firstName
      lastName
      email
      status
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveEmployeeId
    agaveExpense {
      id
      source_id
      amount
      amount_due
      ap_payment_ids
      batch
      batch_id
      creator_id
      currency_code
      description
      discount_amount
      discount_date
      due_date
      issue_date
      misc_amount
      net_amount
      number
      project_id
      retention_amount
      retention_percent
      status
      subtotal_amount
      tax_amount
      total_amount
      type
      vendor_id
      source_create_time
      source_update_time
      __typename
    }
    agaveExpenseId
    agaveProject {
      id
      paidolId
      authPaidolId
      source_id
      amount
      completion_date
      name
      number
      start_date
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveProjectId
    agaveCostCode {
      id
      paidolId
      authPaidolId
      asset_account_id
      source_id
      formatted_full_code
      code
      full_code
      cost_unit_of_measure
      description
      expense_account_id
      income_account_id
      name
      parent_id
      project_id
      price_unit_of_measure
      source_create_time
      source_update_time
      status
      type
      unit_cost
      unit_price
      vendor_id
      sub_job_id
      createdAt
      updatedAt
      projectId
      paidolProject
      projectIds
      cost_type_ids
      fullName
      __typename
    }
    agaveCostCodeId
    agaveCostTypeId
    agaveCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      project_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      paidolProject
      __typename
    }
    agaveGlCode {
      id
      paidolId
      authPaidolId
      source_id
      classification
      currency_code
      current_balance
      description
      name
      number
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveGlCodeId
    agaveVendor {
      id
      paidolId
      authPaidolId
      source_id
      code
      email
      fax
      name
      phone
      status
      tax_number
      terms
      type
      website
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      __typename
    }
    agaveVendorId
    agaveSubJob {
      id
      agaveSubJobId
      paidolId
      authPaidolId
      source_id
      name
      number
      code
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      fullName
      cost_code_ids
      __typename
    }
    agaveSubJobId
    agaveEquipment {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCo
      category
      department
      status
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEquipmentId
    agaveEmCostCode {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCostTypeCodes
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostCodeId
    agaveEmCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      abbreviation
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostTypeId
    codingType
    accountingDate
    procoreDirectCostId
    procoreDirectCostLineItemId
    procoreProject {
      id
      active
      display_name
      name
      created_at
      start_date
      completion_date
      project_number
      total_value
      __typename
    }
    procoreProjectId
    procoreWBSCode {
      id
      flat_code
      flat_name
      description
      status
      __typename
    }
    procoreWBSCodeId
    erpApprovalStatus
    erpBypassStatus
    erpBillableItemId
    erpBillableItemName
    erpBillable
    erpPostingStatus
    erpPostingError
    erpPostingWarning
    sage300APInvoiceStatus
    sage300APInvoiceError
    note
    approveWithoutNotes
    receiptPath
    receiptId
    receipt {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    hasReceipt
    approveWithoutReceipts
    fuelVehicleId
    fuelOdometerReading
    fuelGallons
    fuelCostPerGallon
    codedAt
    codingMethod
    receiptUploadedAt
    receiptUploadMethod
    erpExportedAt
    erpExportBatchId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetHighnoteTransactionEventQueryVariables,
  APITypes.GetHighnoteTransactionEventQuery
>;
export const listHighnoteTransactionEvents = /* GraphQL */ `query ListHighnoteTransactionEvents(
  $id: ID
  $filter: ModelHighnoteTransactionEventFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listHighnoteTransactionEvents(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      transactionId
      paymentCardId
      paidolId
      reconciliationId
      authPaidolId
      eventDate
      processedAt
      origin
      status
      partial
      settlementImpact
      approvedAmountValue
      approvedAmountCurrencyCode
      eventData
      transactionOldState
      transactionNewState
      enableListing
      email
      userId
      last4
      groupApprovalLevels
      owningProjectGroupIds
      cardGroupId
      merchantCategory
      merchantCategoryCode
      merchantName
      jobCodeId
      flexCodeTransactionStatus
      workflowStatus
      returnedStatus
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      agaveEmployeeId
      agaveExpenseId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveGlCodeId
      agaveVendorId
      agaveSubJobId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      procoreDirectCostId
      procoreDirectCostLineItemId
      procoreProjectId
      procoreWBSCodeId
      erpApprovalStatus
      erpBypassStatus
      erpBillableItemId
      erpBillableItemName
      erpBillable
      erpPostingStatus
      erpPostingError
      erpPostingWarning
      sage300APInvoiceStatus
      sage300APInvoiceError
      note
      approveWithoutNotes
      receiptPath
      receiptId
      hasReceipt
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      codedAt
      codingMethod
      receiptUploadedAt
      receiptUploadMethod
      erpExportedAt
      erpExportBatchId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHighnoteTransactionEventsQueryVariables,
  APITypes.ListHighnoteTransactionEventsQuery
>;
export const listHighnoteTransactionEventsByTransactionId = /* GraphQL */ `query ListHighnoteTransactionEventsByTransactionId(
  $transactionId: ID!
  $eventDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelHighnoteTransactionEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listHighnoteTransactionEventsByTransactionId(
    transactionId: $transactionId
    eventDate: $eventDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      transactionId
      paymentCardId
      paidolId
      reconciliationId
      authPaidolId
      eventDate
      processedAt
      origin
      status
      partial
      settlementImpact
      approvedAmountValue
      approvedAmountCurrencyCode
      eventData
      transactionOldState
      transactionNewState
      enableListing
      email
      userId
      last4
      groupApprovalLevels
      owningProjectGroupIds
      cardGroupId
      merchantCategory
      merchantCategoryCode
      merchantName
      jobCodeId
      flexCodeTransactionStatus
      workflowStatus
      returnedStatus
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      agaveEmployeeId
      agaveExpenseId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveGlCodeId
      agaveVendorId
      agaveSubJobId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      procoreDirectCostId
      procoreDirectCostLineItemId
      procoreProjectId
      procoreWBSCodeId
      erpApprovalStatus
      erpBypassStatus
      erpBillableItemId
      erpBillableItemName
      erpBillable
      erpPostingStatus
      erpPostingError
      erpPostingWarning
      sage300APInvoiceStatus
      sage300APInvoiceError
      note
      approveWithoutNotes
      receiptPath
      receiptId
      hasReceipt
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      codedAt
      codingMethod
      receiptUploadedAt
      receiptUploadMethod
      erpExportedAt
      erpExportBatchId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHighnoteTransactionEventsByTransactionIdQueryVariables,
  APITypes.ListHighnoteTransactionEventsByTransactionIdQuery
>;
export const listHighnoteTransactionEventsByPaymentCardId = /* GraphQL */ `query ListHighnoteTransactionEventsByPaymentCardId(
  $paymentCardId: ID!
  $eventDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelHighnoteTransactionEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listHighnoteTransactionEventsByPaymentCardId(
    paymentCardId: $paymentCardId
    eventDate: $eventDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      transactionId
      paymentCardId
      paidolId
      reconciliationId
      authPaidolId
      eventDate
      processedAt
      origin
      status
      partial
      settlementImpact
      approvedAmountValue
      approvedAmountCurrencyCode
      eventData
      transactionOldState
      transactionNewState
      enableListing
      email
      userId
      last4
      groupApprovalLevels
      owningProjectGroupIds
      cardGroupId
      merchantCategory
      merchantCategoryCode
      merchantName
      jobCodeId
      flexCodeTransactionStatus
      workflowStatus
      returnedStatus
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      agaveEmployeeId
      agaveExpenseId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveGlCodeId
      agaveVendorId
      agaveSubJobId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      procoreDirectCostId
      procoreDirectCostLineItemId
      procoreProjectId
      procoreWBSCodeId
      erpApprovalStatus
      erpBypassStatus
      erpBillableItemId
      erpBillableItemName
      erpBillable
      erpPostingStatus
      erpPostingError
      erpPostingWarning
      sage300APInvoiceStatus
      sage300APInvoiceError
      note
      approveWithoutNotes
      receiptPath
      receiptId
      hasReceipt
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      codedAt
      codingMethod
      receiptUploadedAt
      receiptUploadMethod
      erpExportedAt
      erpExportBatchId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHighnoteTransactionEventsByPaymentCardIdQueryVariables,
  APITypes.ListHighnoteTransactionEventsByPaymentCardIdQuery
>;
export const listHighnoteTransactionEventsByPaidolId = /* GraphQL */ `query ListHighnoteTransactionEventsByPaidolId(
  $paidolId: ID!
  $eventDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelHighnoteTransactionEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listHighnoteTransactionEventsByPaidolId(
    paidolId: $paidolId
    eventDate: $eventDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      transactionId
      paymentCardId
      paidolId
      reconciliationId
      authPaidolId
      eventDate
      processedAt
      origin
      status
      partial
      settlementImpact
      approvedAmountValue
      approvedAmountCurrencyCode
      eventData
      transactionOldState
      transactionNewState
      enableListing
      email
      userId
      last4
      groupApprovalLevels
      owningProjectGroupIds
      cardGroupId
      merchantCategory
      merchantCategoryCode
      merchantName
      jobCodeId
      flexCodeTransactionStatus
      workflowStatus
      returnedStatus
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      agaveEmployeeId
      agaveExpenseId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveGlCodeId
      agaveVendorId
      agaveSubJobId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      procoreDirectCostId
      procoreDirectCostLineItemId
      procoreProjectId
      procoreWBSCodeId
      erpApprovalStatus
      erpBypassStatus
      erpBillableItemId
      erpBillableItemName
      erpBillable
      erpPostingStatus
      erpPostingError
      erpPostingWarning
      sage300APInvoiceStatus
      sage300APInvoiceError
      note
      approveWithoutNotes
      receiptPath
      receiptId
      hasReceipt
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      codedAt
      codingMethod
      receiptUploadedAt
      receiptUploadMethod
      erpExportedAt
      erpExportBatchId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHighnoteTransactionEventsByPaidolIdQueryVariables,
  APITypes.ListHighnoteTransactionEventsByPaidolIdQuery
>;
export const listHighnoteTransactionEventsByReconciliationId = /* GraphQL */ `query ListHighnoteTransactionEventsByReconciliationId(
  $reconciliationId: ID!
  $eventDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelHighnoteTransactionEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listHighnoteTransactionEventsByReconciliationId(
    reconciliationId: $reconciliationId
    eventDate: $eventDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      transactionId
      paymentCardId
      paidolId
      reconciliationId
      authPaidolId
      eventDate
      processedAt
      origin
      status
      partial
      settlementImpact
      approvedAmountValue
      approvedAmountCurrencyCode
      eventData
      transactionOldState
      transactionNewState
      enableListing
      email
      userId
      last4
      groupApprovalLevels
      owningProjectGroupIds
      cardGroupId
      merchantCategory
      merchantCategoryCode
      merchantName
      jobCodeId
      flexCodeTransactionStatus
      workflowStatus
      returnedStatus
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      agaveEmployeeId
      agaveExpenseId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveGlCodeId
      agaveVendorId
      agaveSubJobId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      procoreDirectCostId
      procoreDirectCostLineItemId
      procoreProjectId
      procoreWBSCodeId
      erpApprovalStatus
      erpBypassStatus
      erpBillableItemId
      erpBillableItemName
      erpBillable
      erpPostingStatus
      erpPostingError
      erpPostingWarning
      sage300APInvoiceStatus
      sage300APInvoiceError
      note
      approveWithoutNotes
      receiptPath
      receiptId
      hasReceipt
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      codedAt
      codingMethod
      receiptUploadedAt
      receiptUploadMethod
      erpExportedAt
      erpExportBatchId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHighnoteTransactionEventsByReconciliationIdQueryVariables,
  APITypes.ListHighnoteTransactionEventsByReconciliationIdQuery
>;
export const listHighnoteTransactionEventsByCardGroupId = /* GraphQL */ `query ListHighnoteTransactionEventsByCardGroupId(
  $cardGroupId: ID!
  $eventDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelHighnoteTransactionEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listHighnoteTransactionEventsByCardGroupId(
    cardGroupId: $cardGroupId
    eventDate: $eventDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      transactionId
      paymentCardId
      paidolId
      reconciliationId
      authPaidolId
      eventDate
      processedAt
      origin
      status
      partial
      settlementImpact
      approvedAmountValue
      approvedAmountCurrencyCode
      eventData
      transactionOldState
      transactionNewState
      enableListing
      email
      userId
      last4
      groupApprovalLevels
      owningProjectGroupIds
      cardGroupId
      merchantCategory
      merchantCategoryCode
      merchantName
      jobCodeId
      flexCodeTransactionStatus
      workflowStatus
      returnedStatus
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      agaveEmployeeId
      agaveExpenseId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveGlCodeId
      agaveVendorId
      agaveSubJobId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      procoreDirectCostId
      procoreDirectCostLineItemId
      procoreProjectId
      procoreWBSCodeId
      erpApprovalStatus
      erpBypassStatus
      erpBillableItemId
      erpBillableItemName
      erpBillable
      erpPostingStatus
      erpPostingError
      erpPostingWarning
      sage300APInvoiceStatus
      sage300APInvoiceError
      note
      approveWithoutNotes
      receiptPath
      receiptId
      hasReceipt
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      codedAt
      codingMethod
      receiptUploadedAt
      receiptUploadMethod
      erpExportedAt
      erpExportBatchId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHighnoteTransactionEventsByCardGroupIdQueryVariables,
  APITypes.ListHighnoteTransactionEventsByCardGroupIdQuery
>;
export const searchHighnoteTransactionEvents = /* GraphQL */ `query SearchHighnoteTransactionEvents(
  $filter: SearchableHighnoteTransactionEventFilterInput
  $sort: [SearchableHighnoteTransactionEventSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableHighnoteTransactionEventAggregationInput]
) {
  searchHighnoteTransactionEvents(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      transactionId
      paymentCardId
      paidolId
      reconciliationId
      authPaidolId
      eventDate
      processedAt
      origin
      status
      partial
      settlementImpact
      approvedAmountValue
      approvedAmountCurrencyCode
      eventData
      transactionOldState
      transactionNewState
      enableListing
      email
      userId
      last4
      groupApprovalLevels
      owningProjectGroupIds
      cardGroupId
      merchantCategory
      merchantCategoryCode
      merchantName
      jobCodeId
      flexCodeTransactionStatus
      workflowStatus
      returnedStatus
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      agaveEmployeeId
      agaveExpenseId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveGlCodeId
      agaveVendorId
      agaveSubJobId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      procoreDirectCostId
      procoreDirectCostLineItemId
      procoreProjectId
      procoreWBSCodeId
      erpApprovalStatus
      erpBypassStatus
      erpBillableItemId
      erpBillableItemName
      erpBillable
      erpPostingStatus
      erpPostingError
      erpPostingWarning
      sage300APInvoiceStatus
      sage300APInvoiceError
      note
      approveWithoutNotes
      receiptPath
      receiptId
      hasReceipt
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      codedAt
      codingMethod
      receiptUploadedAt
      receiptUploadMethod
      erpExportedAt
      erpExportBatchId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchHighnoteTransactionEventsQueryVariables,
  APITypes.SearchHighnoteTransactionEventsQuery
>;
export const getSyncBalanceCurrentCycle = /* GraphQL */ `query GetSyncBalanceCurrentCycle($id: ID!) {
  getSyncBalanceCurrentCycle(id: $id) {
    id
    paidolId
    authPaidolId
    startDate
    endDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSyncBalanceCurrentCycleQueryVariables,
  APITypes.GetSyncBalanceCurrentCycleQuery
>;
export const listSyncBalanceCurrentCycles = /* GraphQL */ `query ListSyncBalanceCurrentCycles(
  $id: ID
  $filter: ModelSyncBalanceCurrentCycleFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSyncBalanceCurrentCycles(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      paidolId
      authPaidolId
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSyncBalanceCurrentCyclesQueryVariables,
  APITypes.ListSyncBalanceCurrentCyclesQuery
>;
export const syncBalanceCurrentCycleByPaidolId = /* GraphQL */ `query SyncBalanceCurrentCycleByPaidolId(
  $paidolId: ID!
  $startDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSyncBalanceCurrentCycleFilterInput
  $limit: Int
  $nextToken: String
) {
  syncBalanceCurrentCycleByPaidolId(
    paidolId: $paidolId
    startDate: $startDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      paidolId
      authPaidolId
      startDate
      endDate
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncBalanceCurrentCycleByPaidolIdQueryVariables,
  APITypes.SyncBalanceCurrentCycleByPaidolIdQuery
>;
export const getSyncBalanceCurrentCyclePaymentCards = /* GraphQL */ `query GetSyncBalanceCurrentCyclePaymentCards($id: ID!) {
  getSyncBalanceCurrentCyclePaymentCards(id: $id) {
    id
    authPaidolId
    paidolId
    syncBalanceCurrentCycleId
    paymentCardId
    balance {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    syncedAt
    error
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSyncBalanceCurrentCyclePaymentCardsQueryVariables,
  APITypes.GetSyncBalanceCurrentCyclePaymentCardsQuery
>;
export const listSyncBalanceCurrentCyclePaymentCards = /* GraphQL */ `query ListSyncBalanceCurrentCyclePaymentCards(
  $id: ID
  $filter: ModelSyncBalanceCurrentCyclePaymentCardsFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSyncBalanceCurrentCyclePaymentCards(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      authPaidolId
      paidolId
      syncBalanceCurrentCycleId
      paymentCardId
      syncedAt
      error
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSyncBalanceCurrentCyclePaymentCardsQueryVariables,
  APITypes.ListSyncBalanceCurrentCyclePaymentCardsQuery
>;
export const syncBalanceCurrentCyclePaymentCardsByPaidolId = /* GraphQL */ `query SyncBalanceCurrentCyclePaymentCardsByPaidolId(
  $paidolId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelSyncBalanceCurrentCyclePaymentCardsFilterInput
  $limit: Int
  $nextToken: String
) {
  syncBalanceCurrentCyclePaymentCardsByPaidolId(
    paidolId: $paidolId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      authPaidolId
      paidolId
      syncBalanceCurrentCycleId
      paymentCardId
      syncedAt
      error
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncBalanceCurrentCyclePaymentCardsByPaidolIdQueryVariables,
  APITypes.SyncBalanceCurrentCyclePaymentCardsByPaidolIdQuery
>;
export const syncBalanceCurrentCyclePaymentCardsBySyncBalanceCurrentCycleId = /* GraphQL */ `query SyncBalanceCurrentCyclePaymentCardsBySyncBalanceCurrentCycleId(
  $syncBalanceCurrentCycleId: ID!
  $syncedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSyncBalanceCurrentCyclePaymentCardsFilterInput
  $limit: Int
  $nextToken: String
) {
  syncBalanceCurrentCyclePaymentCardsBySyncBalanceCurrentCycleId(
    syncBalanceCurrentCycleId: $syncBalanceCurrentCycleId
    syncedAt: $syncedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      authPaidolId
      paidolId
      syncBalanceCurrentCycleId
      paymentCardId
      syncedAt
      error
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncBalanceCurrentCyclePaymentCardsBySyncBalanceCurrentCycleIdQueryVariables,
  APITypes.SyncBalanceCurrentCyclePaymentCardsBySyncBalanceCurrentCycleIdQuery
>;
export const syncBalanceCurrentCyclePaymentCardsByPaymentCardId = /* GraphQL */ `query SyncBalanceCurrentCyclePaymentCardsByPaymentCardId(
  $paymentCardId: String!
  $syncBalanceCurrentCycleId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelSyncBalanceCurrentCyclePaymentCardsFilterInput
  $limit: Int
  $nextToken: String
) {
  syncBalanceCurrentCyclePaymentCardsByPaymentCardId(
    paymentCardId: $paymentCardId
    syncBalanceCurrentCycleId: $syncBalanceCurrentCycleId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      authPaidolId
      paidolId
      syncBalanceCurrentCycleId
      paymentCardId
      syncedAt
      error
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncBalanceCurrentCyclePaymentCardsByPaymentCardIdQueryVariables,
  APITypes.SyncBalanceCurrentCyclePaymentCardsByPaymentCardIdQuery
>;
export const getExpenseTypeToMCC = /* GraphQL */ `query GetExpenseTypeToMCC($id: ID!) {
  getExpenseTypeToMCC(id: $id) {
    id
    mccID
    expenseTypeID
    mcc {
      id
      code
      highnoteDescription
      highnoteCategoryDescription
      speedchainDescription
      createdAt
      updatedAt
      __typename
    }
    expenseType {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetExpenseTypeToMCCQueryVariables,
  APITypes.GetExpenseTypeToMCCQuery
>;
export const listExpenseTypeToMCCS = /* GraphQL */ `query ListExpenseTypeToMCCS(
  $filter: ModelExpenseTypeToMCCFilterInput
  $limit: Int
  $nextToken: String
) {
  listExpenseTypeToMCCS(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      mccID
      expenseTypeID
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListExpenseTypeToMCCSQueryVariables,
  APITypes.ListExpenseTypeToMCCSQuery
>;
export const getPlaidLinkedBankAccountsByPaidolId = /* GraphQL */ `query GetPlaidLinkedBankAccountsByPaidolId($paidolId: ID!, $status: String) {
  getPlaidLinkedBankAccountsByPaidolId(paidolId: $paidolId, status: $status) {
    items {
      id
      paidolId
      plaidAccountId
      plaidItemId
      highnoteAccountId
      accountName
      accountMask
      accountType
      verificationMethod
      status
      linkedAt
      verifiedAt
      closedAt
      failureReason
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPlaidLinkedBankAccountsByPaidolIdQueryVariables,
  APITypes.GetPlaidLinkedBankAccountsByPaidolIdQuery
>;
export const userList = /* GraphQL */ `query UserList($user_id: ID!, $paidol_id: ID!) {
  userList(user_id: $user_id, paidol_id: $paidol_id) {
    userId
    nickname
    __typename
  }
}
` as GeneratedQuery<APITypes.UserListQueryVariables, APITypes.UserListQuery>;
export const unreadMessages = /* GraphQL */ `query UnreadMessages($userId: ID!) {
  unreadMessages(userId: $userId) {
    unread_count
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UnreadMessagesQueryVariables,
  APITypes.UnreadMessagesQuery
>;
export const dispatchMessage = /* GraphQL */ `query DispatchMessage($userId: ID!, $message: String!, $paidolId: String!) {
  dispatchMessage(userId: $userId, message: $message, paidolId: $paidolId) {
    channel_url
    message
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DispatchMessageQueryVariables,
  APITypes.DispatchMessageQuery
>;
export const hnGetBusinessAccountHolder = /* GraphQL */ `query HnGetBusinessAccountHolder($id: String!) {
  hnGetBusinessAccountHolder(id: $id) {
    id
    primaryAuthorizedPerson {
      id
      percentageOwnership
      authorizingPersonTitle
      email
      dateOfBirth
      createdAt
      updatedAt
      __typename
    }
    businessProfile {
      id
      businessType
      website
      createdAt
      updatedAt
      __typename
    }
    externalId
    createdAt
    updatedAt
    cardProductApplications {
      __typename
    }
    paymentCards {
      __typename
    }
    externalFinancialAccounts {
      __typename
    }
    financialAccounts {
      __typename
    }
    globalNotes {
      ... on HNAccessDeniedError {
        message
      }
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.HnGetBusinessAccountHolderQueryVariables,
  APITypes.HnGetBusinessAccountHolderQuery
>;
export const hnGetPaymentCardsForBusinessId = /* GraphQL */ `query HnGetPaymentCardsForBusinessId(
  $id: ID!
  $first: Int = 20
  $after: String
  $filterBy: HNAccountHolderPaymentCardsFilterInput
) {
  hnGetPaymentCardsForBusinessId(
    id: $id
    first: $first
    after: $after
    filterBy: $filterBy
  ) {
    id
    primaryAuthorizedPerson {
      id
      percentageOwnership
      authorizingPersonTitle
      email
      dateOfBirth
      createdAt
      updatedAt
      __typename
    }
    businessProfile {
      id
      businessType
      website
      createdAt
      updatedAt
      __typename
    }
    externalId
    createdAt
    updatedAt
    cardProductApplications {
      __typename
    }
    paymentCards {
      __typename
    }
    externalFinancialAccounts {
      __typename
    }
    financialAccounts {
      __typename
    }
    globalNotes {
      ... on HNAccessDeniedError {
        message
      }
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.HnGetPaymentCardsForBusinessIdQueryVariables,
  APITypes.HnGetPaymentCardsForBusinessIdQuery
>;
export const hnGetDetailsForPaymentCard = /* GraphQL */ `query HnGetDetailsForPaymentCard($id: ID!) {
  hnGetDetailsForPaymentCard(id: $id) {
    id
    externalId
    bin
    last4
    expirationDate
    expirationMonth
    expirationYear
    network
    cardProduct {
      id
      name
      usage
      vertical
      commercial
      sourceTemplateId
      __typename
    }
    cardProductApplication {
      ... on HNAccountHolderCardProductApplication {
        id
        applicationDenialReason
        createdAt
        updatedAt
      }
      ... on HNAuthorizedUserCardProductApplication {
        id
        applicationDenialReason
        createdAt
        updatedAt
      }
    }
    application {
      id
      applicationDenialReason
      createdAt
      updatedAt
      __typename
    }
    status
    formFactor
    originalPaymentCard {
      id
      externalId
      bin
      last4
      expirationDate
      expirationMonth
      expirationYear
      network
      status
      formFactor
      suspensionFlags
      __typename
    }
    restrictedDetails {
      ... on HNPaymentCardRestrictedDetails {
        number
        cvv
      }
      ... on HNAccessDeniedError {
        message
      }
    }
    atmLocations {
      ... on HNAccessDeniedError {
        message
      }
    }
    transactionEvents {
      __typename
    }
    financialAccounts {
      id
      externalId
      name
      createdAt
      updatedAt
      accountClosureBlockers
      accountStatus
      accountAttributes
      partnerBankName
      __typename
    }
    physicalPaymentCardOrders {
      id
      createdAt
      updatedAt
      __typename
    }
    attachedSpendRules {
      __typename
    }
    cardDigitalWalletTokens {
      __typename
    }
    velocityRuleBalances {
      __typename
    }
    velocitySpendRuleBalances {
      ... on HNVelocitySpendRuleAmountBalance {
        asOfDate
        attachedLevel
      }
      ... on HNVelocitySpendRuleCountBalance {
        currentCountBalance
        remainingCountBalance
        computedCurrentCountBalance
        computedRemainingCountBalance
        asOfDate
        attachedLevel
      }
    }
    attachedVelocityRules {
      __typename
    }
    paymentCardHolderDetails {
      __typename
    }
    customFields {
      key

      ... on HNCustomStringField {
        value
      }
    }
    revisionSnapshots {
      __typename
    }
    cardProfileSet {
      id
      status
      name
      intent
      network
      preferredConfiguration
      createdAt
      updatedAt
      description
      __typename
    }
    pinDetails {
      isSet
      __typename
    }
    suspensionFlags
    __typename
  }
}
` as GeneratedQuery<
  APITypes.HnGetDetailsForPaymentCardQueryVariables,
  APITypes.HnGetDetailsForPaymentCardQuery
>;
export const hnGetAccountHolderCardProductApplication = /* GraphQL */ `query HnGetAccountHolderCardProductApplication($id: ID!) {
  hnGetAccountHolderCardProductApplication(id: $id) {
    id
    applicationState {
      status
      __typename
    }
    adverseActionReasons {
      code
      description
      __typename
    }
    applicationDenialReason
    accountHolderSnapshot {
      ... on HNUSPersonAccountHolderSnapshot {
        email
        dateOfBirth
      }
    }
    cardProduct {
      id
      name
      usage
      vertical
      commercial
      sourceTemplateId
      __typename
    }
    applicationHistory {
      __typename
    }
    createdAt
    updatedAt
    financialAccounts {
      __typename
    }
    offers {
      __typename
    }
    creditReportFraudAlertVerificationResult {
      accountHolderInitiatedApplication
      name
      dateOfBirth
      address
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.HnGetAccountHolderCardProductApplicationQueryVariables,
  APITypes.HnGetAccountHolderCardProductApplicationQuery
>;
export const hnGetSpendRuleById = /* GraphQL */ `query HnGetSpendRuleById($ruleId: ID!) {
  hnGetSpendRuleById(ruleId: $ruleId) {
    id
    name
    blockedCountry
    allowedCategory
    blockedCategory
    allowedCountry
    maximumAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.HnGetSpendRuleByIdQueryVariables,
  APITypes.HnGetSpendRuleByIdQuery
>;
export const hnGetPaymentCardDetails = /* GraphQL */ `query HnGetPaymentCardDetails($id: ID!) {
  hnGetPaymentCardDetails(id: $id) {
    id
    externalId
    bin
    last4
    expirationDate
    expirationMonth
    expirationYear
    network
    cardProduct {
      id
      name
      usage
      vertical
      commercial
      sourceTemplateId
      __typename
    }
    cardProductApplication {
      ... on HNAccountHolderCardProductApplication {
        id
        applicationDenialReason
        createdAt
        updatedAt
      }
      ... on HNAuthorizedUserCardProductApplication {
        id
        applicationDenialReason
        createdAt
        updatedAt
      }
    }
    application {
      id
      applicationDenialReason
      createdAt
      updatedAt
      __typename
    }
    status
    formFactor
    originalPaymentCard {
      id
      externalId
      bin
      last4
      expirationDate
      expirationMonth
      expirationYear
      network
      status
      formFactor
      suspensionFlags
      __typename
    }
    restrictedDetails {
      ... on HNPaymentCardRestrictedDetails {
        number
        cvv
      }
      ... on HNAccessDeniedError {
        message
      }
    }
    atmLocations {
      ... on HNAccessDeniedError {
        message
      }
    }
    transactionEvents {
      __typename
    }
    financialAccounts {
      id
      externalId
      name
      createdAt
      updatedAt
      accountClosureBlockers
      accountStatus
      accountAttributes
      partnerBankName
      __typename
    }
    physicalPaymentCardOrders {
      id
      createdAt
      updatedAt
      __typename
    }
    attachedSpendRules {
      __typename
    }
    cardDigitalWalletTokens {
      __typename
    }
    velocityRuleBalances {
      __typename
    }
    velocitySpendRuleBalances {
      ... on HNVelocitySpendRuleAmountBalance {
        asOfDate
        attachedLevel
      }
      ... on HNVelocitySpendRuleCountBalance {
        currentCountBalance
        remainingCountBalance
        computedCurrentCountBalance
        computedRemainingCountBalance
        asOfDate
        attachedLevel
      }
    }
    attachedVelocityRules {
      __typename
    }
    paymentCardHolderDetails {
      __typename
    }
    customFields {
      key

      ... on HNCustomStringField {
        value
      }
    }
    revisionSnapshots {
      __typename
    }
    cardProfileSet {
      id
      status
      name
      intent
      network
      preferredConfiguration
      createdAt
      updatedAt
      description
      __typename
    }
    pinDetails {
      isSet
      __typename
    }
    suspensionFlags
    __typename
  }
}
` as GeneratedQuery<
  APITypes.HnGetPaymentCardDetailsQueryVariables,
  APITypes.HnGetPaymentCardDetailsQuery
>;
export const hnViewDirectDepositDetails = /* GraphQL */ `query HnViewDirectDepositDetails($id: ID!) {
  hnViewDirectDepositDetails(id: $id) {
    id
    restrictedDetails {
      ... on HNDirectDepositDetailRestrictedDetails {
        number
        routingNumber
        type
      }
      ... on HNAccessDeniedError {
        message
      }
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.HnViewDirectDepositDetailsQueryVariables,
  APITypes.HnViewDirectDepositDetailsQuery
>;
export const hnFindFinancialAccountTransfers = /* GraphQL */ `query HnFindFinancialAccountTransfers(
  $id: ID!
  $firstScheduledTransfers: Int = 20
  $scheduledTransfersAfterCursor: String
  $firstIntegratorTransfers: Int = 20
  $integratorTransfersAfterCursor: String
  $firstExternalTransfers: Int = 20
  $externalTransfersAfterCursor: String
) {
  hnFindFinancialAccountTransfers(
    id: $id
    firstScheduledTransfers: $firstScheduledTransfers
    scheduledTransfersAfterCursor: $scheduledTransfersAfterCursor
    firstIntegratorTransfers: $firstIntegratorTransfers
    integratorTransfersAfterCursor: $integratorTransfersAfterCursor
    firstExternalTransfers: $firstExternalTransfers
    externalTransfersAfterCursor: $externalTransfersAfterCursor
  ) {
    paymentCardTransactionChargebacks {
      __typename
    }
    globalNotes {
      ... on HNAccessDeniedError {
        message
      }
    }
    accountReviewHistory {
      ... on HNAccessDeniedError {
        message
      }
    }
    id
    externalId
    ledgers {
      id
      name
      description
      normalBalance
      asOf
      __typename
    }
    owner {
      ... on HNOrganization {
        id
      }
      ... on HNPaymentCard {
        id
        externalId
        bin
        last4
        expirationDate
        expirationMonth
        expirationYear
        network
        status
        formFactor
        suspensionFlags
      }
      ... on HNUSPersonAccountHolder {
        id
        email
        dateOfBirth
        externalId
        createdAt
        updatedAt
      }
      ... on HNUSBusinessAccountHolder {
        id
        externalId
        createdAt
        updatedAt
      }
    }
    name
    cardProduct {
      id
      name
      usage
      vertical
      commercial
      sourceTemplateId
      __typename
    }
    application {
      id
      applicationDenialReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    features {
      enabled
      createdAt
      updatedAt
      effectiveFrom
      effectiveThrough

      ... on HNOnDemandFundingFinancialAccountFeature {
        sourceFinancialAccountId
        pseudoBalanceEnabled
      }
    }
    directDepositDetails {
      id
      createdAt
      updatedAt
      __typename
    }
    activeBillingCycleConfiguration {
      id
      paymentDueDayOfMonth
      billingCycleStartDayOfMonth
      billingCycleEndDayOfMonth
      from
      through
      __typename
    }
    statementSnapshot {
      asOf
      updatedAt
    }
    statements {
      __typename
    }
    financialAccountActivities {
      __typename
    }
    integratorInitiatedAchTransfers {
      __typename
    }
    integratorInitiatedACHTransfer {
      __typename
    }
    integratorACHTransfers {
      __typename
    }
    externallyInitiatedAchTransfers {
      __typename
    }
    externallyInitiatedACHTransfer {
      __typename
    }
    externalACHTransfers {
      __typename
    }
    originatedAchTransfers {
      ... on HNAccessDeniedError {
        message
      }
    }
    nonOriginatedAchTransfers {
      ... on HNAccessDeniedError {
        message
      }
    }
    incomingScheduledTransfers {
      __typename
    }
    transactionEvents {
      __typename
    }
    interFinancialAccountTransfers {
      __typename
    }
    accountClosureBlockers
    accountStatus
    accountAttributes
    financialAccountAttributesWithReason {
      attribute
      reason
      __typename
    }
    paymentCards {
      __typename
    }
    velocityRuleBalances {
      __typename
    }
    velocitySpendRuleBalances {
      ... on HNVelocitySpendRuleAmountBalance {
        asOfDate
        attachedLevel
      }
      ... on HNVelocitySpendRuleCountBalance {
        currentCountBalance
        remainingCountBalance
        computedCurrentCountBalance
        computedRemainingCountBalance
        asOfDate
        attachedLevel
      }
    }
    partnerBankName
    delinquency {
      delinquencyStartedOn
      totalDaysDelinquent
      numberOfCycles
    }
    delinquencyState {
      state
      updatedAt
      __typename
    }
    billingCycleHistory {
      __typename
    }
    creditConfiguration {
      __typename
    }
    feeTransferEvents {
      __typename
    }
    paymentCardTransactionDisputes {
      ... on HNAccessDeniedError {
        message
      }
    }
    customFields {
      key

      ... on HNCustomStringField {
        value
      }
    }
    revisionSnapshots {
      __typename
    }
    rewardPointsTransfers {
      ... on HNAccessDeniedError {
        message
      }
    }
    attachedSpendRules {
      __typename
    }
    attachedVelocityRules {
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.HnFindFinancialAccountTransfersQueryVariables,
  APITypes.HnFindFinancialAccountTransfersQuery
>;
export const hnFindFinancialAccountLedgerActivity = /* GraphQL */ `query HnFindFinancialAccountLedgerActivity(
  $id: ID!
  $firstActivities: Int = 20
  $activitiesAfterCursor: String
) {
  hnFindFinancialAccountLedgerActivity(
    id: $id
    firstActivities: $firstActivities
    activitiesAfterCursor: $activitiesAfterCursor
  ) {
    paymentCardTransactionChargebacks {
      __typename
    }
    globalNotes {
      ... on HNAccessDeniedError {
        message
      }
    }
    accountReviewHistory {
      ... on HNAccessDeniedError {
        message
      }
    }
    id
    externalId
    ledgers {
      id
      name
      description
      normalBalance
      asOf
      __typename
    }
    owner {
      ... on HNOrganization {
        id
      }
      ... on HNPaymentCard {
        id
        externalId
        bin
        last4
        expirationDate
        expirationMonth
        expirationYear
        network
        status
        formFactor
        suspensionFlags
      }
      ... on HNUSPersonAccountHolder {
        id
        email
        dateOfBirth
        externalId
        createdAt
        updatedAt
      }
      ... on HNUSBusinessAccountHolder {
        id
        externalId
        createdAt
        updatedAt
      }
    }
    name
    cardProduct {
      id
      name
      usage
      vertical
      commercial
      sourceTemplateId
      __typename
    }
    application {
      id
      applicationDenialReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    features {
      enabled
      createdAt
      updatedAt
      effectiveFrom
      effectiveThrough

      ... on HNOnDemandFundingFinancialAccountFeature {
        sourceFinancialAccountId
        pseudoBalanceEnabled
      }
    }
    directDepositDetails {
      id
      createdAt
      updatedAt
      __typename
    }
    activeBillingCycleConfiguration {
      id
      paymentDueDayOfMonth
      billingCycleStartDayOfMonth
      billingCycleEndDayOfMonth
      from
      through
      __typename
    }
    statementSnapshot {
      asOf
      updatedAt
    }
    statements {
      __typename
    }
    financialAccountActivities {
      __typename
    }
    integratorInitiatedAchTransfers {
      __typename
    }
    integratorInitiatedACHTransfer {
      __typename
    }
    integratorACHTransfers {
      __typename
    }
    externallyInitiatedAchTransfers {
      __typename
    }
    externallyInitiatedACHTransfer {
      __typename
    }
    externalACHTransfers {
      __typename
    }
    originatedAchTransfers {
      ... on HNAccessDeniedError {
        message
      }
    }
    nonOriginatedAchTransfers {
      ... on HNAccessDeniedError {
        message
      }
    }
    incomingScheduledTransfers {
      __typename
    }
    transactionEvents {
      __typename
    }
    interFinancialAccountTransfers {
      __typename
    }
    accountClosureBlockers
    accountStatus
    accountAttributes
    financialAccountAttributesWithReason {
      attribute
      reason
      __typename
    }
    paymentCards {
      __typename
    }
    velocityRuleBalances {
      __typename
    }
    velocitySpendRuleBalances {
      ... on HNVelocitySpendRuleAmountBalance {
        asOfDate
        attachedLevel
      }
      ... on HNVelocitySpendRuleCountBalance {
        currentCountBalance
        remainingCountBalance
        computedCurrentCountBalance
        computedRemainingCountBalance
        asOfDate
        attachedLevel
      }
    }
    partnerBankName
    delinquency {
      delinquencyStartedOn
      totalDaysDelinquent
      numberOfCycles
    }
    delinquencyState {
      state
      updatedAt
      __typename
    }
    billingCycleHistory {
      __typename
    }
    creditConfiguration {
      __typename
    }
    feeTransferEvents {
      __typename
    }
    paymentCardTransactionDisputes {
      ... on HNAccessDeniedError {
        message
      }
    }
    customFields {
      key

      ... on HNCustomStringField {
        value
      }
    }
    revisionSnapshots {
      __typename
    }
    rewardPointsTransfers {
      ... on HNAccessDeniedError {
        message
      }
    }
    attachedSpendRules {
      __typename
    }
    attachedVelocityRules {
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.HnFindFinancialAccountLedgerActivityQueryVariables,
  APITypes.HnFindFinancialAccountLedgerActivityQuery
>;
export const hnFindFinancialAccountActivities = /* GraphQL */ `query HnFindFinancialAccountActivities(
  $id: ID!
  $firstActivities: Int = 20
  $filterBy: HNFinancialAccountActivitiesFilterInput
  $activitiesAfterCursor: String
) {
  hnFindFinancialAccountActivities(
    id: $id
    firstActivities: $firstActivities
    filterBy: $filterBy
    activitiesAfterCursor: $activitiesAfterCursor
  ) {
    paymentCardTransactionChargebacks {
      __typename
    }
    globalNotes {
      ... on HNAccessDeniedError {
        message
      }
    }
    accountReviewHistory {
      ... on HNAccessDeniedError {
        message
      }
    }
    id
    externalId
    ledgers {
      id
      name
      description
      normalBalance
      asOf
      __typename
    }
    owner {
      ... on HNOrganization {
        id
      }
      ... on HNPaymentCard {
        id
        externalId
        bin
        last4
        expirationDate
        expirationMonth
        expirationYear
        network
        status
        formFactor
        suspensionFlags
      }
      ... on HNUSPersonAccountHolder {
        id
        email
        dateOfBirth
        externalId
        createdAt
        updatedAt
      }
      ... on HNUSBusinessAccountHolder {
        id
        externalId
        createdAt
        updatedAt
      }
    }
    name
    cardProduct {
      id
      name
      usage
      vertical
      commercial
      sourceTemplateId
      __typename
    }
    application {
      id
      applicationDenialReason
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    features {
      enabled
      createdAt
      updatedAt
      effectiveFrom
      effectiveThrough

      ... on HNOnDemandFundingFinancialAccountFeature {
        sourceFinancialAccountId
        pseudoBalanceEnabled
      }
    }
    directDepositDetails {
      id
      createdAt
      updatedAt
      __typename
    }
    activeBillingCycleConfiguration {
      id
      paymentDueDayOfMonth
      billingCycleStartDayOfMonth
      billingCycleEndDayOfMonth
      from
      through
      __typename
    }
    statementSnapshot {
      asOf
      updatedAt
    }
    statements {
      __typename
    }
    financialAccountActivities {
      __typename
    }
    integratorInitiatedAchTransfers {
      __typename
    }
    integratorInitiatedACHTransfer {
      __typename
    }
    integratorACHTransfers {
      __typename
    }
    externallyInitiatedAchTransfers {
      __typename
    }
    externallyInitiatedACHTransfer {
      __typename
    }
    externalACHTransfers {
      __typename
    }
    originatedAchTransfers {
      ... on HNAccessDeniedError {
        message
      }
    }
    nonOriginatedAchTransfers {
      ... on HNAccessDeniedError {
        message
      }
    }
    incomingScheduledTransfers {
      __typename
    }
    transactionEvents {
      __typename
    }
    interFinancialAccountTransfers {
      __typename
    }
    accountClosureBlockers
    accountStatus
    accountAttributes
    financialAccountAttributesWithReason {
      attribute
      reason
      __typename
    }
    paymentCards {
      __typename
    }
    velocityRuleBalances {
      __typename
    }
    velocitySpendRuleBalances {
      ... on HNVelocitySpendRuleAmountBalance {
        asOfDate
        attachedLevel
      }
      ... on HNVelocitySpendRuleCountBalance {
        currentCountBalance
        remainingCountBalance
        computedCurrentCountBalance
        computedRemainingCountBalance
        asOfDate
        attachedLevel
      }
    }
    partnerBankName
    delinquency {
      delinquencyStartedOn
      totalDaysDelinquent
      numberOfCycles
    }
    delinquencyState {
      state
      updatedAt
      __typename
    }
    billingCycleHistory {
      __typename
    }
    creditConfiguration {
      __typename
    }
    feeTransferEvents {
      __typename
    }
    paymentCardTransactionDisputes {
      ... on HNAccessDeniedError {
        message
      }
    }
    customFields {
      key

      ... on HNCustomStringField {
        value
      }
    }
    revisionSnapshots {
      __typename
    }
    rewardPointsTransfers {
      ... on HNAccessDeniedError {
        message
      }
    }
    attachedSpendRules {
      __typename
    }
    attachedVelocityRules {
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.HnFindFinancialAccountActivitiesQueryVariables,
  APITypes.HnFindFinancialAccountActivitiesQuery
>;
export const getCards = /* GraphQL */ `query GetCards($input: GetCardsInput!) {
  getCards(input: $input) {
    nextToken
    total
    items {
      last4
      paymentCardId
      formFactor
      paidolId
      name
      status
      expirationDate
      createdAt
      updatedAt
      network
      isAdminLocked
      isAuthorizedUserCard
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.GetCardsQueryVariables, APITypes.GetCardsQuery>;
export const getCardsLite = /* GraphQL */ `query GetCardsLite($input: GetCardsInput!) {
  getCardsLite(input: $input) {
    nextToken
    total
    items {
      paymentCardId
      last4
      name
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCardsLiteQueryVariables,
  APITypes.GetCardsLiteQuery
>;
export const getJobCodes = /* GraphQL */ `query GetJobCodes($input: GetJobCodesInput!) {
  getJobCodes(input: $input) {
    jobCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      storageFileKey
      fileName
      status
      errors
      updatedAt
      __typename
    }
    paidolUsersMap {
      code
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetJobCodesQueryVariables,
  APITypes.GetJobCodesQuery
>;
export const getFinicityConnectUrl = /* GraphQL */ `query GetFinicityConnectUrl($input: GetFinicityConnectUrlInput!) {
  getFinicityConnectUrl(input: $input) {
    link
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFinicityConnectUrlQueryVariables,
  APITypes.GetFinicityConnectUrlQuery
>;
export const getFinicityCustomerAccounts = /* GraphQL */ `query GetFinicityCustomerAccounts($input: GetFinicityCustomerAccountsInput!) {
  getFinicityCustomerAccounts(input: $input) {
    id
    accountNumberDisplay
    name
    type
    balance
    status
    institutionId
    institution {
      name
      urlHomeApp
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFinicityCustomerAccountsQueryVariables,
  APITypes.GetFinicityCustomerAccountsQuery
>;
export const getProcoreCompanies = /* GraphQL */ `query GetProcoreCompanies($input: GetProcoreCompaniesInput!) {
  getProcoreCompanies(input: $input) {
    id
    name
    is_active
    logo_url
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProcoreCompaniesQueryVariables,
  APITypes.GetProcoreCompaniesQuery
>;
export const getProcoreProjects = /* GraphQL */ `query GetProcoreProjects($input: GetProcoreProjectsInput!) {
  getProcoreProjects(input: $input) {
    id
    active
    display_name
    name
    created_at
    start_date
    completion_date
    project_number
    project_stage {
      id
      name
      __typename
    }
    project_template {
      id
      name
      __typename
    }
    total_value
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProcoreProjectsQueryVariables,
  APITypes.GetProcoreProjectsQuery
>;
export const getProcoreProjectUsers = /* GraphQL */ `query GetProcoreProjectUsers($input: GetProcoreProjectUsersInput!) {
  getProcoreProjectUsers(input: $input) {
    id
    name
    email_address
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProcoreProjectUsersQueryVariables,
  APITypes.GetProcoreProjectUsersQuery
>;
export const getProcoreWBSCodes = /* GraphQL */ `query GetProcoreWBSCodes($input: GetProcoreWBSCodesInput!) {
  getProcoreWBSCodes(input: $input) {
    id
    flat_code
    flat_name
    description
    status
    segment_items {
      id
      code
      name
      status
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProcoreWBSCodesQueryVariables,
  APITypes.GetProcoreWBSCodesQuery
>;
export const getCardsManagementFilterOptions = /* GraphQL */ `query GetCardsManagementFilterOptions(
  $input: GetCardsManagementFilterOptionsInput!
) {
  getCardsManagementFilterOptions(input: $input) {
    cardGroupId {
      id
      label
      projectId
      __typename
    }
    cardNames {
      id
      label
      projectId
      __typename
    }
    cardholders {
      id
      label
      projectId
      __typename
    }
    last4 {
      id
      label
      projectId
      __typename
    }
    status {
      id
      label
      projectId
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCardsManagementFilterOptionsQueryVariables,
  APITypes.GetCardsManagementFilterOptionsQuery
>;
export const getAgaveProjects = /* GraphQL */ `query GetAgaveProjects($input: AgaveProjectsInput!) {
  getAgaveProjects(input: $input) {
    id
    paidolId
    authPaidolId
    source_id
    address {
      street_1
      street_2
      city
      state
      postal_code
      country
      __typename
    }
    amount
    completion_date
    name
    number
    start_date
    status
    type
    source_create_time
    source_update_time
    source_data {
      CreationDate
      data
      DeliveryAddressLine
      DeliveryCity
      DeliveryCountry
      DeliveryPostcode
      DeliveryState
      FaxNumber
      LogoPath
      ProjectOwnerOrganizationId
      ProjectOwnerOrganizationName
      PhoneNumber
      PostalAddressLine
      PostalCity
      PostalCountry
      PostalPostcode
      PostalState
      ProjectAddressLine
      ProjectCity
      ProjectCode
      ProjectCountry
      ProjectDescription
      ProjectId
      ProjectName
      ProjectPostcode
      ProjectShortName
      ProjectState
      ProjectType
      ProjectValue
      ProjectResponsibilities
      StartDate
      StopDate
      __typename
    }
    createdAt
    updatedAt
    fullName
    relatedIds
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveProjectsQueryVariables,
  APITypes.GetAgaveProjectsQuery
>;
export const getAgaveGlCodes = /* GraphQL */ `query GetAgaveGlCodes($input: AgaveGlCodesInput!) {
  getAgaveGlCodes(input: $input) {
    id
    paidolId
    authPaidolId
    source_id
    classification
    currency_code
    current_balance
    description
    name
    number
    status
    type
    source_create_time
    source_update_time
    source_data {
      CreationDate
      data
      DeliveryAddressLine
      DeliveryCity
      DeliveryCountry
      DeliveryPostcode
      DeliveryState
      FaxNumber
      LogoPath
      ProjectOwnerOrganizationId
      ProjectOwnerOrganizationName
      PhoneNumber
      PostalAddressLine
      PostalCity
      PostalCountry
      PostalPostcode
      PostalState
      ProjectAddressLine
      ProjectCity
      ProjectCode
      ProjectCountry
      ProjectDescription
      ProjectId
      ProjectName
      ProjectPostcode
      ProjectShortName
      ProjectState
      ProjectType
      ProjectValue
      ProjectResponsibilities
      StartDate
      StopDate
      __typename
    }
    createdAt
    updatedAt
    fullName
    relatedIds
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveGlCodesQueryVariables,
  APITypes.GetAgaveGlCodesQuery
>;
export const getAgaveCostCodes = /* GraphQL */ `query GetAgaveCostCodes($input: AgaveCostCodesInput!) {
  getAgaveCostCodes(input: $input) {
    id
    paidolId
    authPaidolId
    asset_account_id
    source_id
    formatted_full_code
    code
    full_code
    cost_unit_of_measure
    description
    expense_account_id
    income_account_id
    name
    parent_id
    project_id
    price_unit_of_measure
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    status
    type
    unit_cost
    unit_price
    vendor_id
    sub_job_id
    createdAt
    updatedAt
    projectId
    paidolProject
    projectIds
    cost_type_ids
    fullName
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveCostCodesQueryVariables,
  APITypes.GetAgaveCostCodesQuery
>;
export const getAgaveEmployees = /* GraphQL */ `query GetAgaveEmployees($input: AgaveEmployeesInput!) {
  getAgaveEmployees(input: $input) {
    id
    source_id
    address {
      city
      country
      postal_code
      state
      street_1
      street_2
      type
      __typename
    }
    company
    email
    first_name
    full_name
    gender
    hire_date
    industry
    job_title
    last_name
    mobile_phone
    phone
    source_create_time
    source_update_time
    status
    termination_date
    type
    source_data {
      path
      content_type
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveEmployeesQueryVariables,
  APITypes.GetAgaveEmployeesQuery
>;
export const getAgaveCostTypes = /* GraphQL */ `query GetAgaveCostTypes($input: AgaveCostTypesInput!) {
  getAgaveCostTypes(input: $input) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    project_id
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    createdAt
    updatedAt
    projectId
    paidolProject
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveCostTypesQueryVariables,
  APITypes.GetAgaveCostTypesQuery
>;
export const getAgaveGlCostTypes = /* GraphQL */ `query GetAgaveGlCostTypes($input: AgaveGlCostTypesInput!) {
  getAgaveGlCostTypes(input: $input) {
    id
    source_id
    code
    name
    project_id
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveGlCostTypesQueryVariables,
  APITypes.GetAgaveGlCostTypesQuery
>;
export const getAgaveVendors = /* GraphQL */ `query GetAgaveVendors($input: GetAgaveVendorsInput!) {
  getAgaveVendors(input: $input) {
    id
    paidolId
    authPaidolId
    source_id
    address {
      street_1
      street_2
      city
      state
      country
      postal_code
      __typename
    }
    code
    email
    fax
    name
    phone
    status
    tax_number
    terms
    type
    website
    source_create_time
    source_update_time
    source_data {
      V1099YN
      V1099Type
      V1099Box
      EFT
      data
      __typename
    }
    createdAt
    updatedAt
    fullName
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveVendorsQueryVariables,
  APITypes.GetAgaveVendorsQuery
>;
export const getAgaveBankAccounts = /* GraphQL */ `query GetAgaveBankAccounts($input: AgaveBankAccountsInput!) {
  getAgaveBankAccounts(input: $input) {
    id
    source_id
    bank_name
    currency_code
    current_balance
    description
    ledger_account_id
    name
    number
    source_create_time
    source_update_time
    status
    type
    source_data {
      path
      content_type
      data
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveBankAccountsQueryVariables,
  APITypes.GetAgaveBankAccountsQuery
>;
export const getAgaveVendorByName = /* GraphQL */ `query GetAgaveVendorByName($input: GetAgaveVendorInput!) {
  getAgaveVendorByName(input: $input) {
    id
    paidolId
    authPaidolId
    source_id
    address {
      street_1
      street_2
      city
      state
      country
      postal_code
      __typename
    }
    code
    email
    fax
    name
    phone
    status
    tax_number
    terms
    type
    website
    source_create_time
    source_update_time
    source_data {
      V1099YN
      V1099Type
      V1099Box
      EFT
      data
      __typename
    }
    createdAt
    updatedAt
    fullName
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveVendorByNameQueryVariables,
  APITypes.GetAgaveVendorByNameQuery
>;
export const getAgaveAccount = /* GraphQL */ `query GetAgaveAccount($input: AgaveAccountInput!) {
  getAgaveAccount(input: $input) {
    account_id
    connection {
      type
      __typename
    }
    created_at
    linked_company {
      id
      source_id
      name
      __typename
    }
    linked_user {
      id
      source_id
      name
      email
      __typename
    }
    reference_id
    source_system {
      name
      slug
      __typename
    }
    source_system_environment {
      name
      slug
      __typename
    }
    status
    supports_cross_account_uuid
    supports_cross_company_requests
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveAccountQueryVariables,
  APITypes.GetAgaveAccountQuery
>;
export const getAgavePassThrough = /* GraphQL */ `query GetAgavePassThrough($input: AgavePassThroughInput!) {
  getAgavePassThrough(input: $input) {
    status
    content_type
    body
    headers {
      raw
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgavePassThroughQueryVariables,
  APITypes.GetAgavePassThroughQuery
>;
export const getAgaveAPInvoiceByFilterSageIntacct = /* GraphQL */ `query GetAgaveAPInvoiceByFilterSageIntacct(
  $input: GetAgaveAPInvoiceByFilterSageIntacctInput!
) {
  getAgaveAPInvoiceByFilterSageIntacct(input: $input) {
    id
    source_id
    amount
    amount_due
    ap_payment_ids
    attachments {
      id
      source_id
      name
      url
      source_create_time
      source_update_time
      __typename
    }
    batch
    batch_id
    contract {
      id
      type
      __typename
    }
    creator_id
    currency_code
    description
    discount_amount
    discount_date
    due_date
    issue_date
    line_items {
      id
      source_id
      amount
      cost_code_id
      cost_type_id
      customer_id
      description
      discount_amount
      item_id
      ledger_account_id
      project_id
      quantity
      retention_amount
      status
      sub_job_id
      tax_amount
      tax_code_id
      type
      unit_cost
      unit_of_measure
      vendor_id
      wbs_id
      source_create_time
      source_update_time
      __typename
    }
    misc_amount
    net_amount
    number
    project_id
    retention_amount
    retention_percent
    status
    subtotal_amount
    tax_amount
    total_amount
    type
    vendor_id
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveAPInvoiceByFilterSageIntacctQueryVariables,
  APITypes.GetAgaveAPInvoiceByFilterSageIntacctQuery
>;
export const hnGetVelocityRuleById = /* GraphQL */ `query HnGetVelocityRuleById($ruleId: ID!) {
  hnGetVelocityRuleById(ruleId: $ruleId) {
    id
    name
    velocityRuleWindow
    cumulativeRule {
      id
      name
      version
      createdAt
      updatedAt

      ... on HNMerchantCategorySpendRule {
        allowed
        blocked
        allowedMcc
        blockedMcc
      }
      ... on HNCVVSpendRule {
        allowed
        blocked
      }
      ... on HNStreetAddressSpendRule {
        allowed
        blocked
      }
      ... on HNMerchantIdentifierSpendRule {
        allowed
        blocked
      }
      ... on HNMerchantCountrySpendRule {
        allowed
        blocked
      }
      ... on HNCountLimitSpendRule {
        maximumCount
      }
      ... on HNPointOfServiceCategorySpendRule {
        allowed
        blocked
      }
      ... on HNPostalCodeVerificationSpendRule {
        allowed
        blocked
      }
      ... on HNDepositProcessingNetworkSpendRule {
        allowed
        blocked
      }
      ... on HNDepositCountLimitSpendRule {
        maximumCount
      }
      ... on HNConditionalRuleSetSpendRule {
        allow
      }
      ... on HNCardTransactionProcessingTypeConditionSpendRule {
        allowed
        blocked
      }
      ... on HNRestrictedAccountHolderSpendRule {
        allowed
        blocked
      }
      ... on HNPanEntryModeSpendRule {
        allowed
        blocked
      }
      ... on HNCardDataInputCapabilitySpendRule {
        allowed
        blocked
      }
    }
    spendRules {
      id
      name
      version
      createdAt
      updatedAt

      ... on HNMerchantCategorySpendRule {
        allowed
        blocked
        allowedMcc
        blockedMcc
      }
      ... on HNCVVSpendRule {
        allowed
        blocked
      }
      ... on HNStreetAddressSpendRule {
        allowed
        blocked
      }
      ... on HNMerchantIdentifierSpendRule {
        allowed
        blocked
      }
      ... on HNMerchantCountrySpendRule {
        allowed
        blocked
      }
      ... on HNCountLimitSpendRule {
        maximumCount
      }
      ... on HNPointOfServiceCategorySpendRule {
        allowed
        blocked
      }
      ... on HNPostalCodeVerificationSpendRule {
        allowed
        blocked
      }
      ... on HNDepositProcessingNetworkSpendRule {
        allowed
        blocked
      }
      ... on HNDepositCountLimitSpendRule {
        maximumCount
      }
      ... on HNConditionalRuleSetSpendRule {
        allow
      }
      ... on HNCardTransactionProcessingTypeConditionSpendRule {
        allowed
        blocked
      }
      ... on HNRestrictedAccountHolderSpendRule {
        allowed
        blocked
      }
      ... on HNPanEntryModeSpendRule {
        allowed
        blocked
      }
      ... on HNCardDataInputCapabilitySpendRule {
        allowed
        blocked
      }
    }
    version
    createdAt
    updatedAt
    revisions {
      __typename
    }
    velocityConstraintLevelOverride
    __typename
  }
}
` as GeneratedQuery<
  APITypes.HnGetVelocityRuleByIdQueryVariables,
  APITypes.HnGetVelocityRuleByIdQuery
>;
export const searchSpxTransactions = /* GraphQL */ `query SearchSpxTransactions($input: SearchSpxTransactionsInput!) {
  searchSpxTransactions(input: $input) {
    items {
      id
      transactionId
      paymentCardId
      paidolId
      reconciliationId
      authPaidolId
      eventDate
      processedAt
      origin
      status
      partial
      settlementImpact
      approvedAmountValue
      approvedAmountCurrencyCode
      eventData
      transactionOldState
      transactionNewState
      enableListing
      email
      userId
      last4
      groupApprovalLevels
      owningProjectGroupIds
      cardGroupId
      merchantCategory
      merchantCategoryCode
      merchantName
      jobCodeId
      flexCodeTransactionStatus
      workflowStatus
      returnedStatus
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      agaveEmployeeId
      agaveExpenseId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveGlCodeId
      agaveVendorId
      agaveSubJobId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      procoreDirectCostId
      procoreDirectCostLineItemId
      procoreProjectId
      procoreWBSCodeId
      erpApprovalStatus
      erpBypassStatus
      erpBillableItemId
      erpBillableItemName
      erpBillable
      erpPostingStatus
      erpPostingError
      erpPostingWarning
      sage300APInvoiceStatus
      sage300APInvoiceError
      note
      approveWithoutNotes
      receiptPath
      receiptId
      hasReceipt
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      codedAt
      codingMethod
      receiptUploadedAt
      receiptUploadMethod
      erpExportedAt
      erpExportBatchId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchSpxTransactionsQueryVariables,
  APITypes.SearchSpxTransactionsQuery
>;
export const v2CardHealthCheck = /* GraphQL */ `query V2CardHealthCheck($input: String) {
  v2CardHealthCheck(input: $input)
}
` as GeneratedQuery<
  APITypes.V2CardHealthCheckQueryVariables,
  APITypes.V2CardHealthCheckQuery
>;
export const v2TransactionHealthCheck = /* GraphQL */ `query V2TransactionHealthCheck($input: String) {
  v2TransactionHealthCheck(input: $input)
}
` as GeneratedQuery<
  APITypes.V2TransactionHealthCheckQueryVariables,
  APITypes.V2TransactionHealthCheckQuery
>;
export const v2SearchFlexGlCodes = /* GraphQL */ `query V2SearchFlexGlCodes($input: SearchFlexCodingInput!) {
  v2SearchFlexGlCodes(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2SearchFlexGlCodesQueryVariables,
  APITypes.V2SearchFlexGlCodesQuery
>;
export const v2GetProjectGroup = /* GraphQL */ `query V2GetProjectGroup($input: GetProjectGroupInput!) {
  v2GetProjectGroup(input: $input) {
    projectGroup {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    projects {
      id
      name
      __typename
    }
    groupAdmins {
      id
      paidolId
      paidolUserId
      projectGroupId
      approvalLevels
      isReviewer
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2GetProjectGroupQueryVariables,
  APITypes.V2GetProjectGroupQuery
>;
export const v2SearchFlexCodes = /* GraphQL */ `query V2SearchFlexCodes($input: SearchFlexCodingInput!) {
  v2SearchFlexCodes(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      projectName
      projectCode
      isActive
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2SearchFlexCodesQueryVariables,
  APITypes.V2SearchFlexCodesQuery
>;
export const v2SearchFlexCostCodes = /* GraphQL */ `query V2SearchFlexCostCodes($input: SearchFlexCodingInput!) {
  v2SearchFlexCostCodes(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      code
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2SearchFlexCostCodesQueryVariables,
  APITypes.V2SearchFlexCostCodesQuery
>;
export const v2SearchFlexCostTypes = /* GraphQL */ `query V2SearchFlexCostTypes($input: SearchFlexCodingInput!) {
  v2SearchFlexCostTypes(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2SearchFlexCostTypesQueryVariables,
  APITypes.V2SearchFlexCostTypesQuery
>;
export const v2SearchFlexVendors = /* GraphQL */ `query V2SearchFlexVendors($input: SearchFlexCodingInput!) {
  v2SearchFlexVendors(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2SearchFlexVendorsQueryVariables,
  APITypes.V2SearchFlexVendorsQuery
>;
export const getAgaveSyncByPaidolId = /* GraphQL */ `query GetAgaveSyncByPaidolId($input: GetAgaveSyncByPaidolIdInput!) {
  getAgaveSyncByPaidolId(input: $input) {
    sync {
      id
      paidolId
      authPaidolId
      inProgress
      error
      lastRunStart
      lastRunEnd
      taskArn
      syncEntityFilter
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAgaveSyncByPaidolIdQueryVariables,
  APITypes.GetAgaveSyncByPaidolIdQuery
>;
export const migrateERPEndpointSettings = /* GraphQL */ `query MigrateERPEndpointSettings($input: String!) {
  migrateERPEndpointSettings(input: $input) {
    migrated
    paidol {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MigrateERPEndpointSettingsQueryVariables,
  APITypes.MigrateERPEndpointSettingsQuery
>;
export const listMerchantSpendRulesForPaidol = /* GraphQL */ `query ListMerchantSpendRulesForPaidol($input: ListMerchantSpendRulesInput!) {
  listMerchantSpendRulesForPaidol(input: $input) {
    id
    paidolId
    authPaidolId
    name
    paymentCards
    merchantCountrySpendRuleId
    merchantCategorySpendRuleId
    amountLimitSpendRuleId
    monthlyLimitSpendRuleId
    monthlyLimitCumulativeRuleId
    maximumAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    monthlyLimitAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    merchantCategoryAllowed
    merchantCategoryBlocked
    merchantCountryAllowed
    merchantCountryBlocked
    monthlyLimitResetTimestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMerchantSpendRulesForPaidolQueryVariables,
  APITypes.ListMerchantSpendRulesForPaidolQuery
>;
export const v2ListCardGroupsByPaidolId = /* GraphQL */ `query V2ListCardGroupsByPaidolId($input: v2ListCardGroupsByPaidolIdInput!) {
  v2ListCardGroupsByPaidolId(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2ListCardGroupsByPaidolIdQueryVariables,
  APITypes.V2ListCardGroupsByPaidolIdQuery
>;
export const v2ListProjectGroupsByPaidolId = /* GraphQL */ `query V2ListProjectGroupsByPaidolId(
  $input: v2ListProjectGroupsByPaidolIdInput!
) {
  v2ListProjectGroupsByPaidolId(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2ListProjectGroupsByPaidolIdQueryVariables,
  APITypes.V2ListProjectGroupsByPaidolIdQuery
>;
export const v2SearchAgaveGLCodes = /* GraphQL */ `query V2SearchAgaveGLCodes($input: SearchAgaveGLCodesInput!) {
  v2SearchAgaveGLCodes(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      classification
      currency_code
      current_balance
      description
      name
      number
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2SearchAgaveGLCodesQueryVariables,
  APITypes.V2SearchAgaveGLCodesQuery
>;
export const v2SearchAgaveProjects = /* GraphQL */ `query V2SearchAgaveProjects($input: SearchAgaveProjectsInput!) {
  v2SearchAgaveProjects(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      amount
      completion_date
      name
      number
      start_date
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2SearchAgaveProjectsQueryVariables,
  APITypes.V2SearchAgaveProjectsQuery
>;
export const v2SearchAgaveCostCodes = /* GraphQL */ `query V2SearchAgaveCostCodes($input: SearchAgaveCostCodesInput!) {
  v2SearchAgaveCostCodes(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      asset_account_id
      source_id
      formatted_full_code
      code
      full_code
      cost_unit_of_measure
      description
      expense_account_id
      income_account_id
      name
      parent_id
      project_id
      price_unit_of_measure
      source_create_time
      source_update_time
      status
      type
      unit_cost
      unit_price
      vendor_id
      sub_job_id
      createdAt
      updatedAt
      projectId
      paidolProject
      projectIds
      cost_type_ids
      fullName
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2SearchAgaveCostCodesQueryVariables,
  APITypes.V2SearchAgaveCostCodesQuery
>;
export const v2GetAgaveGlCodesByCosting = /* GraphQL */ `query V2GetAgaveGlCodesByCosting($input: GetAgaveGlCodesByCostingInput!) {
  v2GetAgaveGlCodesByCosting(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      classification
      currency_code
      current_balance
      description
      name
      number
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    total
    itemSourceId
    itemName
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2GetAgaveGlCodesByCostingQueryVariables,
  APITypes.V2GetAgaveGlCodesByCostingQuery
>;
export const v2SearchAgaveVendors = /* GraphQL */ `query V2SearchAgaveVendors($input: SearchAgaveVendorsInput!) {
  v2SearchAgaveVendors(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      code
      email
      fax
      name
      phone
      status
      tax_number
      terms
      type
      website
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2SearchAgaveVendorsQueryVariables,
  APITypes.V2SearchAgaveVendorsQuery
>;
export const v2SearchAgaveCostTypes = /* GraphQL */ `query V2SearchAgaveCostTypes($input: SearchAgaveCostTypesInput!) {
  v2SearchAgaveCostTypes(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      project_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      paidolProject
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2SearchAgaveCostTypesQueryVariables,
  APITypes.V2SearchAgaveCostTypesQuery
>;
export const v2SearchAgaveSubJobs = /* GraphQL */ `query V2SearchAgaveSubJobs($input: SearchAgaveSubJobsInput!) {
  v2SearchAgaveSubJobs(input: $input) {
    items {
      id
      agaveSubJobId
      paidolId
      authPaidolId
      source_id
      name
      number
      code
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      fullName
      cost_code_ids
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2SearchAgaveSubJobsQueryVariables,
  APITypes.V2SearchAgaveSubJobsQuery
>;
export const v2SearchAgaveLocations = /* GraphQL */ `query V2SearchAgaveLocations($input: SearchAgaveLocationsInput!) {
  v2SearchAgaveLocations(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      name
      fullName
      parent_id
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2SearchAgaveLocationsQueryVariables,
  APITypes.V2SearchAgaveLocationsQuery
>;
export const v2SearchAgaveDepartments = /* GraphQL */ `query V2SearchAgaveDepartments($input: SearchAgaveDepartmentsInput!) {
  v2SearchAgaveDepartments(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      code
      name
      fullName
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2SearchAgaveDepartmentsQueryVariables,
  APITypes.V2SearchAgaveDepartmentsQuery
>;
export const v2SearchAgaveSubaccounts = /* GraphQL */ `query V2SearchAgaveSubaccounts($input: SearchAgaveSubaccountsInput!) {
  v2SearchAgaveSubaccounts(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      code
      name
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2SearchAgaveSubaccountsQueryVariables,
  APITypes.V2SearchAgaveSubaccountsQuery
>;
export const v2SearchAgaveEmployees = /* GraphQL */ `query V2SearchAgaveEmployees($input: SearchAgaveEmployeesInput!) {
  v2SearchAgaveEmployees(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      name
      fullName
      firstName
      lastName
      email
      status
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    nextToken
    total
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2SearchAgaveEmployeesQueryVariables,
  APITypes.V2SearchAgaveEmployeesQuery
>;
export const v2ReimbursementsHealthCheck = /* GraphQL */ `query V2ReimbursementsHealthCheck($input: String) {
  v2ReimbursementsHealthCheck(input: $input)
}
` as GeneratedQuery<
  APITypes.V2ReimbursementsHealthCheckQueryVariables,
  APITypes.V2ReimbursementsHealthCheckQuery
>;
export const v2GetReimbursementTransaction = /* GraphQL */ `query V2GetReimbursementTransaction($input: GetReimbursementTransactionInput!) {
  v2GetReimbursementTransaction(input: $input) {
    id
    paidolId
    authPaidolId
    dwollaTransferId
    transactionDate
    amount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    status
    checkrunStatus
    note
    contestNote
    deniedNote
    merchantName
    receiptLineItems
    jobCodeId
    jobCode {
      id
      paidolId
      authPaidolId
      description
      code
      isActive
      budget
      jobCodeImportId
      createdAt
      updatedAt
      __typename
    }
    reimbursementDate
    decisionDate
    reviewedByPaidolUserId
    reviewedByName
    reviewedByRole
    reviewedAt
    paidolUserId
    paidolUser {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    transactionType
    expenseTypeId
    expenseType {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    receiptId
    receipt {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    procoreProjectId
    procoreProject {
      id
      active
      display_name
      name
      created_at
      start_date
      completion_date
      project_number
      total_value
      __typename
    }
    procoreWBSCodeId
    procoreWBSCode {
      id
      flat_code
      flat_name
      description
      status
      __typename
    }
    agaveGlCodeId
    agaveGlCode {
      id
      paidolId
      authPaidolId
      source_id
      classification
      currency_code
      current_balance
      description
      name
      number
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveProjectId
    agaveProject {
      id
      paidolId
      authPaidolId
      source_id
      amount
      completion_date
      name
      number
      start_date
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveCostCodeId
    agaveCostCode {
      id
      paidolId
      authPaidolId
      asset_account_id
      source_id
      formatted_full_code
      code
      full_code
      cost_unit_of_measure
      description
      expense_account_id
      income_account_id
      name
      parent_id
      project_id
      price_unit_of_measure
      source_create_time
      source_update_time
      status
      type
      unit_cost
      unit_price
      vendor_id
      sub_job_id
      createdAt
      updatedAt
      projectId
      paidolProject
      projectIds
      cost_type_ids
      fullName
      __typename
    }
    agaveCostTypeId
    agaveCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      project_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      paidolProject
      __typename
    }
    agaveVendorId
    agaveVendor {
      id
      paidolId
      authPaidolId
      source_id
      code
      email
      fax
      name
      phone
      status
      tax_number
      terms
      type
      website
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      __typename
    }
    agaveSubJobId
    agaveSubJob {
      id
      agaveSubJobId
      paidolId
      authPaidolId
      source_id
      name
      number
      code
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      fullName
      cost_code_ids
      __typename
    }
    agaveLocationId
    agaveLocation {
      id
      paidolId
      authPaidolId
      name
      fullName
      parent_id
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveDepartmentId
    agaveDepartment {
      id
      paidolId
      authPaidolId
      code
      name
      fullName
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveSubaccountId
    agaveSubaccount {
      id
      paidolId
      authPaidolId
      code
      name
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveEmployeeId
    agaveEmployee {
      id
      paidolId
      authPaidolId
      name
      fullName
      firstName
      lastName
      email
      status
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveEquipmentId
    agaveEquipment {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCo
      category
      department
      status
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostCodeId
    agaveEmCostCode {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCostTypeCodes
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostTypeId
    agaveEmCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      abbreviation
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    codingType
    accountingDate
    flexGlCodeId
    flexGlCode {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCodeId
    flexCode {
      id
      paidolId
      authPaidolId
      projectName
      projectCode
      isActive
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostCodeId
    flexCostCode {
      id
      paidolId
      authPaidolId
      code
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostTypeId
    flexCostType {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexVendorId
    flexVendor {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2GetReimbursementTransactionQueryVariables,
  APITypes.V2GetReimbursementTransactionQuery
>;
export const v2GetReimbursementTransactionsByPaidolId = /* GraphQL */ `query V2GetReimbursementTransactionsByPaidolId(
  $input: GetReimbursementTransactionsByPaidolIdInput!
) {
  v2GetReimbursementTransactionsByPaidolId(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      dwollaTransferId
      transactionDate
      status
      checkrunStatus
      note
      contestNote
      deniedNote
      merchantName
      receiptLineItems
      jobCodeId
      reimbursementDate
      decisionDate
      reviewedByPaidolUserId
      reviewedByName
      reviewedByRole
      reviewedAt
      paidolUserId
      transactionType
      expenseTypeId
      receiptId
      procoreProjectId
      procoreWBSCodeId
      agaveGlCodeId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveVendorId
      agaveSubJobId
      agaveLocationId
      agaveDepartmentId
      agaveSubaccountId
      agaveEmployeeId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      flexGlCodeId
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexVendorId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2GetReimbursementTransactionsByPaidolIdQueryVariables,
  APITypes.V2GetReimbursementTransactionsByPaidolIdQuery
>;
export const v2GetReceiptUpload = /* GraphQL */ `query V2GetReceiptUpload($input: GetReceiptUploadInput!) {
  v2GetReceiptUpload(input: $input) {
    id
    paidolId
    authPaidolId
    document
    status
    summaryFields {
      nextToken
      __typename
    }
    lineItems {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2GetReceiptUploadQueryVariables,
  APITypes.V2GetReceiptUploadQuery
>;
export const v2GetReceiptsByTransactionId = /* GraphQL */ `query V2GetReceiptsByTransactionId($input: GetReceiptsByTransactionIdInput!) {
  v2GetReceiptsByTransactionId(input: $input) {
    items {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2GetReceiptsByTransactionIdQueryVariables,
  APITypes.V2GetReceiptsByTransactionIdQuery
>;
export const v2ExportReimbursements = /* GraphQL */ `query V2ExportReimbursements($input: ExportReimbursementsInput!) {
  v2ExportReimbursements(input: $input) {
    csvContent
    filename
    success
    message
    exportedIds
    skippedIds
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2ExportReimbursementsQueryVariables,
  APITypes.V2ExportReimbursementsQuery
>;
export const getBudgetSpendByCurrentCycle = /* GraphQL */ `query GetBudgetSpendByCurrentCycle($paymentCardId: ID!) {
  getBudgetSpendByCurrentCycle(paymentCardId: $paymentCardId) {
    paymentCardId
    paidolId
    authPaidolId
    amount
    transactionCount
    lastResetAt
    lastTransactionAt
    processedTransactionIds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBudgetSpendByCurrentCycleQueryVariables,
  APITypes.GetBudgetSpendByCurrentCycleQuery
>;
export const v2GetTransactionFilterOptions = /* GraphQL */ `query V2GetTransactionFilterOptions(
  $input: V2GetTransactionFilterOptionsInput!
) {
  v2GetTransactionFilterOptions(input: $input) {
    paidolId
    authPaidolId
    last4
    userId {
      id
      label
      projectId
      __typename
    }
    merchantName {
      id
      label
      projectId
      __typename
    }
    merchantCategory {
      id
      label
      projectId
      __typename
    }
    cardGroup {
      id
      label
      projectId
      __typename
    }
    projectGroup {
      id
      label
      projectId
      __typename
    }
    receiptStatus {
      id
      label
      projectId
      __typename
    }
    highnoteTransactionStatus {
      id
      label
      projectId
      __typename
    }
    flexCodeTransactionStatus {
      id
      label
      projectId
      __typename
    }
    flexGlCodeIds {
      id
      label
      projectId
      __typename
    }
    flexCodeIds {
      id
      label
      projectId
      __typename
    }
    flexCostCodeIds {
      id
      label
      projectId
      __typename
    }
    flexCostTypeIds {
      id
      label
      projectId
      __typename
    }
    flexVendorIds {
      id
      label
      projectId
      __typename
    }
    agaveTransactionStatus {
      id
      label
      projectId
      __typename
    }
    agaveGlCodeIds {
      id
      label
      projectId
      __typename
    }
    agaveProjectIds {
      id
      label
      projectId
      __typename
    }
    agaveCostCodeIds {
      id
      label
      projectId
      __typename
    }
    agaveCostTypeIds {
      id
      label
      projectId
      __typename
    }
    agaveVendorIds {
      id
      label
      projectId
      __typename
    }
    agaveLocationIds {
      id
      label
      projectId
      __typename
    }
    agaveDepartmentIds {
      id
      label
      projectId
      __typename
    }
    agaveSubaccountIds {
      id
      label
      projectId
      __typename
    }
    agaveSubJobIds {
      id
      label
      projectId
      __typename
    }
    agaveEquipmentIds {
      id
      label
      projectId
      __typename
    }
    agaveEmCostCodeIds {
      id
      label
      projectId
      __typename
    }
    agaveEmCostTypeIds {
      id
      label
      projectId
      __typename
    }
    erpBillableItemIds {
      id
      label
      projectId
      __typename
    }
    statementPeriods {
      id
      label
      startDate
      endDate
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.V2GetTransactionFilterOptionsQueryVariables,
  APITypes.V2GetTransactionFilterOptionsQuery
>;
